// // import React, { useState, useEffect } from "react";
// // import {
// //   ChevronDown,
// //   Users,
// //   Star,
// //   Trophy,
// //   Calendar,
// //   X,
// //   MapPin,
// //   Menu,
// //   Crown,
// // } from "lucide-react";
// // import DataTable from "./DataTable"; // Import your updated DataTable

// // import VoteNowBadge from "../../Layouts/VotingButton";
// // import VoteNowBadge from "../../Layouts/VotingButton";
// // import { BASE_URL } from "../../services/configUrls";
// // import api from "../../services/api";
// // import ConferenceApp from "./ConferenceApp";
// // import EastBourneResortMap from "./Venue";
// // import EnhancedMinimalistAgenda from "./Agenda";
// // import EventFeedbackForm from "../Admin/NominationMarking/EventFeedbackForm";
// // import ConferenceTicketGenerator from "../Trainer FDP/Slots/ConferenceTicketGenerator";
// // import AwardsByCategory from "./AwardsByCategory";

// // // For demo purposes, we'll create mock versions

// // // Skeleton components
// // const SkeletonCard = () => (
// //   <div className="bg-white/60 rounded-xl shadow-sm p-4 border border-gray-100 animate-pulse">
// //     <div className="flex items-center space-x-3">
// //       <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
// //       <div className="flex-1">
// //         <div className="h-3 bg-gray-200 rounded mb-2 w-20"></div>
// //         <div className="h-5 bg-gray-200 rounded w-12"></div>
// //       </div>
// //     </div>
// //   </div>
// // );

// // const SkeletonAccordion = () => (
// //   <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 animate-pulse">
// //     <div className="px-6 py-4 flex items-center justify-between">
// //       <div className="flex items-center space-x-4">
// //         <div className="bg-gray-200 p-2 rounded-lg w-10 h-10"></div>
// //         <div>
// //           <div className="h-5 bg-gray-200 rounded w-20 mb-1"></div>
// //           <div className="h-3 bg-gray-200 rounded w-32"></div>
// //         </div>
// //       </div>
// //       <div className="w-5 h-5 bg-gray-200 rounded"></div>
// //     </div>
// //   </div>
// // );

// // const AwardsAccordion = () => {
// //   const [activeYear, setActiveYear] = useState(null);
// //   const [modalData, setModalData] = useState(null);
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [activeTab, setActiveTab] = useState("registration");
// //   const [yearsData, setYearsData] = useState({});
// //   const [regStatus, setRegStatus] = useState(0); // Add regStatus state
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [sidebarOpen, setSidebarOpen] = useState(false); // Add sidebar state for mobile
// //   const itemsPerPage = 5;

// //   // API call to fetch data using axios
// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         setLoading(true);
// //         setError(null);

// //         // Get access token from localStorage
// //         const accessToken = localStorage.getItem("accessToken");

// //         if (!accessToken) {
// //           throw new Error("No access token found. Please login again.");
// //         }

// //         const response = await api.get(`${BASE_URL}/internship/event/summary`, {
// //           headers: {
// //             Authorization: `Bearer ${accessToken}`,
// //             "Content-Type": "application/json",
// //           },
// //         });

// //         // Extract reg_status and years data
// //         const { reg_status, ...years } = response.data;
// //         setRegStatus(reg_status || 0);
// //         setYearsData(years);
// //       } catch (err) {
// //         console.error("Error fetching data:", err);

// //         // Handle axios specific errors
// //         if (err.response) {
// //           // Server responded with error status
// //           if (err.response.status === 401) {
// //             setError("Unauthorized. Please login again.");
// //           } else {
// //             setError(
// //               `Server error: ${err.response.status} - ${
// //                 err.response.data?.message || "Unknown error"
// //               }`
// //             );
// //           }
// //         } else if (err.request) {
// //           // Request was made but no response received
// //           setError("Network error. Please check your internet connection.");
// //         } else {
// //           // Something else happened
// //           setError(err.message);
// //         }

// //         // Fallback to empty data structure
// //         setYearsData({});
// //         setRegStatus(0);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchData();
// //   }, []);

// //   const toggleYear = (year) => {
// //     setActiveYear(activeYear === year ? null : year);
// //     // Reset tab to registration when opening any year
// //     setActiveTab("registration");
// //     // Close sidebar on mobile when changing year
// //     setSidebarOpen(false);
// //   };

// //   const openModal = (type, data, year) => {
// //     setModalData({ type, data, year });
// //     setCurrentPage(1);
// //   };

// //   const closeModal = () => {
// //     setModalData(null);
// //     setCurrentPage(1);
// //   };

// //   const handlePageChange = (page) => {
// //     setCurrentPage(page);
// //   };

// //   // Close sidebar when tab changes on mobile
// //   const handleTabChange = (tabId) => {
// //     setActiveTab(tabId);
// //     setSidebarOpen(false);
// //   };

// //   // Coming Soon component
// //   const ComingSoon = ({ title }) => {
// //     return (
// //       <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
// //         <div className="text-center">
// //           <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
// //             <span className="text-2xl">🚀</span>
// //           </div>
// //           <h3 className="text-xl font-semibold text-gray-800 mb-2">{title}</h3>
// //           <p className="text-gray-500 text-sm mb-4">
// //             This section is coming soon. Stay tuned for updates!
// //           </p>
// //           <div className="inline-flex items-center px-3 py-1 rounded-full bg-amber-50 border border-amber-200">
// //             <div className="w-2 h-2 bg-amber-400 rounded-full animate-pulse mr-2"></div>
// //             <span className="text-xs text-amber-700 font-medium">
// //               Under Development
// //             </span>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   // Compact Stats Card Component
// //   const StatsCard = ({
// //     icon,
// //     label,
// //     value,
// //     color,
// //     onClick,
// //     clickable = false,
// //   }) => {
// //     const colorClasses = {
// //       blue: "bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100",
// //       yellow: "bg-amber-50 border-amber-200 text-amber-700 hover:bg-amber-100",
// //       green:
// //         "bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100",
// //       gray: "bg-gray-50 border-gray-200 text-gray-700",
// //     };

// //     const iconClasses = {
// //       blue: "bg-blue-500 text-white",
// //       yellow: "bg-amber-500 text-white",
// //       green: "bg-emerald-500 text-white",
// //       gray: "bg-gray-500 text-white",
// //     };

// //     const Component = clickable ? "button" : "div";

// //     return (
// //       <Component
// //         onClick={clickable ? onClick : undefined}
// //         className={`
// //           ${colorClasses[color]} 
// //           ${clickable ? "cursor-pointer transform hover:scale-105" : ""}
// //           rounded-xl border p-4 transition-all duration-200 shadow-sm
// //         `}
// //       >
// //         <div className="flex items-center space-x-3">
// //           <div className={`p-2 rounded-lg ${iconClasses[color]}`}>{icon}</div>
// //           <div className="text-left">
// //             <p className="text-xs font-medium opacity-75 uppercase tracking-wide">
// //               {label}
// //             </p>
// //             <p className="text-xl font-bold">{value}</p>
// //           </div>
// //         </div>
// //       </Component>
// //     );
// //   };

// //   // Awards Tab Component
// //   const AwardsTab = ({ data, year }) => {
// //     return (
// //       <div className="space-y-6">
// //         {/* Quick Stats Grid */}
// //         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //           <StatsCard
// //             icon={<Star className="w-4 h-4" />}
// //             label="Nominated"
// //             value={data.nominated?.length || 0}
// //             color="yellow"
// //             onClick={() => openModal("nominated", data.nominated || [], year)}
// //             clickable={true}
// //           />
// //           <StatsCard
// //             icon={<Trophy className="w-4 h-4" />}
// //             label="Winners"
// //             value={data.winners?.length || 0}
// //             color="green"
// //             onClick={() => openModal("winners", data.winners || [], year)}
// //             clickable={true}
// //           />
// //         </div>
// //       </div>
// //     );
// //   };

// //   // Registration Tab Component with Attendees
// //   const RegistrationTab = ({ data, year }) => {
// //     return (
// //       <div className="space-y-6">
// //         {/* Quick Stats */}
// //         <div className="grid grid-cols-1 gap-4">
// //           <StatsCard
// //             icon={<Users className="w-4 h-4" />}
// //             label="Attendees"
// //             value={data.attendees?.length || 0}
// //             color="blue"
// //             onClick={() => openModal("attendees", data.attendees || [], year)}
// //             clickable={true}
// //           />
// //         </div>

// //         {/* Conference App for 2025 - with proper z-index isolation */}
// //         {year === "2025" && (
// //           <div className="relative">
// //             <ConferenceApp />
// //           </div>
// //         )}
// //       </div>
// //     );
// //   };

// //   // Dynamic tabs based on regStatus
// //   const getAvailableTabs = () => {
// //     const baseTabs = [
// //       { id: "registration", label: "Registration", icon: Users, color: "blue" },
// //       { id: "awards", label: "Awards", icon: Trophy, color: "amber" },
// //       { id: "winners", label: "Winners", icon: Crown, color: "green" },
// //     ];

// //     // Add conditional tabs only if regStatus is 1
// //     if (regStatus === 1) {
// //       baseTabs.push(
// //         { id: "venue", label: "Venue", icon: MapPin, color: "green" },
// //         { id: "agenda", label: "Agenda", icon: Calendar, color: "green" },
// //         { id: "attending", label: "Attending", icon: Users, color: "green" },
// //         { id: "photos", label: "Event Photos", icon: Users, color: "green" },
// //         { id: "feedback", label: "Feedback", icon: Star, color: "purple" }
// //       );
// //     }

// //     return baseTabs;
// //   };

// //   const tabs = getAvailableTabs();

// //   const renderTabContent = (data, year) => {
// //     switch (activeTab) {
// //       case "registration":
// //         return <RegistrationTab data={data} year={year} />;
// //       case "awards":
// //         return <AwardsTab data={data} year={year} />;
// //       case "winners":
// //         return <AwardsByCategory data={data} year={year} />;

// //       case "venue":
// //         return regStatus === 1 ? (
// //           <EastBourneResortMap />
// //         ) : (
// //           <RegistrationTab data={data} year={year} />
// //         );
// //       case "agenda":
// //         return regStatus === 1 ? (
// //           <EnhancedMinimalistAgenda />
// //         ) : (
// //           <RegistrationTab data={data} year={year} />
// //         );
// //       case "attending":
// //         return regStatus === 1 ? (
// //           <ConferenceTicketGenerator />
// //         ) : (
// //           <RegistrationTab data={data} year={year} />
// //         );
// //       case "photos":
// //         return regStatus === 1 ? (
// //           <ComingSoon title="Event Photos" />
// //         ) : (
// //           <RegistrationTab data={data} year={year} />
// //         );
// //       case "feedback":
// //         return regStatus === 1 ? <EventFeedbackForm /> : <ComingSoon title="Feedback" />;
// //       default:
// //         return <AwardsTab data={data} year={year} />;
// //     }
// //   };

// //   // Reset active tab if it's not available anymore
// //   useEffect(() => {
// //     const availableTabIds = tabs.map((tab) => tab.id);
// //     if (!availableTabIds.includes(activeTab)) {
// //       setActiveTab("registration");
// //     }
// //   }, [regStatus, tabs, activeTab]);

// //   const renderModalContent = () => {
// //     if (!modalData) return null;

// //     const { type, data, year } = modalData;
// //     const yearData = yearsData[year];
// //     const instituteNominatedCategories =
// //       yearData?.instituteNominatedCategories || [];
// //     const instituteWinnerCategories = yearData?.instituteWinnerCategories || [];

// //     return (
// //       <div
// //         className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
// //         style={{ zIndex: 50000 }}
// //       >
// //         <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-hidden shadow-2xl border border-gray-200">
// //           <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-gray-50/50">
// //             <div>
// //               <h2 className="text-xl font-semibold text-gray-800">
// //                 {type === "attendees"
// //                   ? "Event Attendees"
// //                   : type === "nominated"
// //                   ? "Nominated Candidates"
// //                   : "Award Winners"}
// //               </h2>
// //               <p className="text-sm text-gray-500 mt-1">
// //                 {year} • {data.length} entries
// //               </p>
// //             </div>
// //             <button
// //               onClick={closeModal}
// //               className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-lg"
// //             >
// //               <X className="w-5 h-5" />
// //             </button>
// //           </div>

// //           <div
// //             className="p-6 overflow-y-auto"
// //             style={{ maxHeight: "calc(90vh - 140px)" }}
// //           >
// //             <DataTable
// //               data={data}
// //               type={type}
// //               currentPage={currentPage}
// //               itemsPerPage={itemsPerPage}
// //               onPageChange={handlePageChange}
// //               instituteNominatedCategories={instituteNominatedCategories}
// //               instituteWinnerCategories={instituteWinnerCategories}
// //             />
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   // Mobile Tab Navigation Component
// //   const MobileTabNavigation = ({ tabs, activeTab, onTabChange }) => {
// //     return (
// //       <div className="lg:hidden bg-white border-b border-gray-200 px-4 py-2">
// //         <div className="flex overflow-x-auto space-x-2 scrollbar-hide">
// //           {tabs.map((tab) => {
// //             const IconComponent = tab.icon;
// //             const isActive = activeTab === tab.id;

// //             const colorClasses = {
// //               blue: isActive
// //                 ? "bg-blue-100 text-blue-700 border-blue-200"
// //                 : "text-gray-600 hover:bg-blue-50 hover:text-blue-600",
// //               amber: isActive
// //                 ? "bg-amber-100 text-amber-700 border-amber-200"
// //                 : "text-gray-600 hover:bg-amber-50 hover:text-amber-600",
// //               green: isActive
// //                 ? "bg-green-100 text-green-700 border-green-200"
// //                 : "text-gray-600 hover:bg-green-50 hover:text-green-600",
// //               purple: isActive
// //                 ? "bg-purple-100 text-purple-700 border-purple-200"
// //                 : "text-gray-600 hover:bg-purple-50 hover:text-purple-600",
// //             };

// //             return (
// //               <button
// //                 key={tab.id}
// //                 onClick={() => onTabChange(tab.id)}
// //                 className={`
// //                   flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap border
// //                   ${
// //                     isActive
// //                       ? `${colorClasses[tab.color]} shadow-sm`
// //                       : `${colorClasses[tab.color]} border-transparent`
// //                   }
// //                 `}
// //               >
// //                 <IconComponent className="w-4 h-4 flex-shrink-0" />
// //                 <span>{tab.label}</span>
// //               </button>
// //             );
// //           })}
// //         </div>
// //       </div>
// //     );
// //   };

// //   // Error state
// //   if (error) {
// //     return (
// //       <div className="p-4 sm:p-6 max-w-[1500px] mx-auto bg-gray-50 min-h-screen">
// //         <div className="bg-white rounded-xl shadow-sm border border-red-200 p-8">
// //           <div className="text-center">
// //             <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
// //               <span className="text-2xl">⚠️</span>
// //             </div>
// //             <h3 className="text-xl font-semibold text-red-600 mb-2">
// //               Error Loading Data
// //             </h3>
// //             <p className="text-gray-600 mb-6">{error}</p>
// //             <button
// //               onClick={() => window.location.reload()}
// //               className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium"
// //             >
// //               Try Again
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   }

// //   // Loading state
// //   if (loading) {
// //     return (
// //       <div className="p-4 max-w-[1500px] mx-auto bg-gray-50 min-h-screen">
// //         <div className="space-y-4">
// //           {[1, 2, 3].map((index) => (
// //             <SkeletonAccordion key={index} />
// //           ))}
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <>
// //       {/* Main Content - Lower z-index */}
// //       <div
// //         className="p-4 max-w-[1700px] mx-auto min-h-screen relative"
// //         style={{ zIndex: 1 }}
// //       >
// //         {/* Year Accordions */}
// //         <div className="space-y-4">
// //           {Object.keys(yearsData).length === 0 ? (
// //             <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
// //               <div className="text-center">
// //                 <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
// //                   <span className="text-2xl">📊</span>
// //                 </div>
// //                 <h3 className="text-xl font-semibold text-gray-600 mb-2">
// //                   No Data Available
// //                 </h3>
// //                 <p className="text-gray-500 text-sm">
// //                   There are no awards data to display at the moment.
// //                 </p>
// //               </div>
// //             </div>
// //           ) : (
// //             Object.entries(yearsData)
// //               .sort(([a], [b]) => Number(b) - Number(a))
// //               .map(([year, data]) => (
// //                 <div
// //                   key={year}
// //                   className="bg-white rounded-xl shadow-sm overflow-visible border border-gray-100 relative"
// //                   style={{
// //                     zIndex: year === "2025" && activeYear === year ? 10 : 2,
// //                   }}
// //                 >
// //                   {/* Accordion Header */}
// //                   <button
// //                     onClick={() => toggleYear(year)}
// //                     className="w-full px-4 sm:px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
// //                   >
// //                     <div className="flex items-center space-x-3 sm:space-x-4">
// //                       <div className="bg-gradient-to-br from-blue-500 to-purple-600 p-2 rounded-lg">
// //                         <Calendar className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
// //                       </div>
// //                       <div className="text-left">
// //                         <h2 className="text-lg font-semibold text-gray-800">
// //                           {year}
// //                         </h2>
// //                         <p className="text-xs text-gray-500 hidden sm:block">
// //                           {data.attendees?.length || 0} attendees •{" "}
// //                           {data.nominated?.length || 0} nominated •{" "}
// //                           {data.winners?.length || 0} winners
// //                         </p>
// //                         <p className="text-xs text-gray-500 sm:hidden">
// //                           {data.attendees?.length || 0} attendees
// //                         </p>
// //                       </div>
// //                     </div>
// //                     <ChevronDown
// //                       className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${
// //                         activeYear === year ? "rotate-180" : ""
// //                       }`}
// //                     />
// //                   </button>

// //                   {/* Accordion Content */}
// //                   <div
// //                     className={`transition-all duration-500 ease-in-out ${
// //                       activeYear === year
// //                         ? "max-h-[80vh] opacity-100 overflow-visible"
// //                         : "max-h-0 opacity-0 overflow-hidden"
// //                     }`}
// //                   >
// //                     <div className="border-t border-gray-100">
// //                       {year === "2025" ? (
// //                         // Enhanced Responsive Layout for 2025
// //                         <>
// //                           {/* Mobile Tab Navigation */}
// //                           <MobileTabNavigation
// //                             tabs={tabs}
// //                             activeTab={activeTab}
// //                             onTabChange={handleTabChange}
// //                           />

// //                           {/* Desktop Sidebar Layout + Mobile Stack Layout */}
// //                           <div className="lg:flex lg:h-[70vh] lg:overflow-visible">
// //                             {/* Desktop Sidebar Navigation */}
// //                             <div className="hidden lg:block w-64 bg-gray-50/50 border-r border-gray-100 p-4 flex-shrink-0 overflow-y-auto">
// //                               <div className="space-y-2">
// //                                 {tabs.map((tab) => {
// //                                   const IconComponent = tab.icon;
// //                                   const isActive = activeTab === tab.id;

// //                                   const colorClasses = {
// //                                     blue: isActive
// //                                       ? "bg-blue-100 text-blue-700 border-blue-200"
// //                                       : "hover:bg-blue-50 hover:text-blue-600",
// //                                     amber: isActive
// //                                       ? "bg-amber-100 text-amber-700 border-amber-200"
// //                                       : "hover:bg-amber-50 hover:text-amber-600",
// //                                     green: isActive
// //                                       ? "bg-green-100 text-green-700 border-green-200"
// //                                       : "hover:bg-green-50 hover:text-green-600",
// //                                     purple: isActive
// //                                       ? "bg-purple-100 text-purple-700 border-purple-200"
// //                                       : "hover:bg-purple-50 hover:text-purple-600",
// //                                   };

// //                                   return (
// //                                     <button
// //                                       key={tab.id}
// //                                       onClick={() => setActiveTab(tab.id)}
// //                                       className={`
// //                                         w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200
// //                                         ${
// //                                           isActive
// //                                             ? `${
// //                                                 colorClasses[tab.color]
// //                                               } border shadow-sm`
// //                                             : `text-gray-600 ${
// //                                                 colorClasses[tab.color]
// //                                               } border border-transparent`
// //                                         }
// //                                       `}
// //                                     >
// //                                       <IconComponent className="w-4 h-4 flex-shrink-0" />
// //                                       <span className="text-left">
// //                                         {tab.label}
// //                                       </span>
// //                                       {isActive && (
// //                                         <div className="ml-auto w-2 h-2 bg-current rounded-full opacity-60"></div>
// //                                       )}
// //                                     </button>
// //                                   );
// //                                 })}
// //                               </div>
// //                             </div>

// //                             {/* Main Content Area - responsive padding */}
// //                             <div className="flex-1 p-4 sm:p-6 lg:overflow-y-auto lg:overflow-x-visible min-h-[50vh] lg:min-h-0">
// //                               {renderTabContent(data, year)}
// //                             </div>
// //                           </div>
// //                         </>
// //                       ) : (
// //                         // Original Simple Card Layout for other years (no tabs)
// //                         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4 px-4 sm:px-6 pb-6">
// //                           {loading ? (
// //                             <>
// //                               <SkeletonCard />
// //                               <SkeletonCard />
// //                               <SkeletonCard />
// //                             </>
// //                           ) : (
// //                             <>
// //                               {/* Attendees Card */}
// //                               <button
// //                                 onClick={() =>
// //                                   openModal(
// //                                     "attendees",
// //                                     data.attendees || [],
// //                                     year
// //                                   )
// //                                 }
// //                                 className="bg-blue-50 rounded-lg shadow-sm p-3 border-l-4 border-blue-500 hover:shadow-md transition-shadow text-left w-full"
// //                               >
// //                                 <div className="flex items-center justify-between">
// //                                   <div>
// //                                     <h3 className="text-xs font-medium text-blue-700 mb-1">
// //                                       Attendees
// //                                     </h3>
// //                                     <p className="text-xl font-bold text-blue-600">
// //                                       {data.attendees?.length || 0}
// //                                     </p>
// //                                   </div>
// //                                   <div className="bg-blue-100 p-1.5 rounded">
// //                                     <Users className="w-4 h-4 text-blue-600" />
// //                                   </div>
// //                                 </div>
// //                               </button>

// //                               {/* Nominated Card */}
// //                               <button
// //                                 onClick={() =>
// //                                   openModal(
// //                                     "nominated",
// //                                     data.nominated || [],
// //                                     year
// //                                   )
// //                                 }
// //                                 className="bg-yellow-50 rounded-lg shadow-sm p-3 border-l-4 border-yellow-500 hover:shadow-md transition-shadow text-left w-full"
// //                               >
// //                                 <div className="flex items-center justify-between">
// //                                   <div>
// //                                     <h3 className="text-xs font-medium text-yellow-700 mb-1">
// //                                       Nominated
// //                                     </h3>
// //                                     <p className="text-xl font-bold text-yellow-600">
// //                                       {data.nominated?.length || 0}
// //                                     </p>
// //                                   </div>
// //                                   <div className="bg-yellow-100 p-1.5 rounded">
// //                                     <Star className="w-4 h-4 text-yellow-600" />
// //                                   </div>
// //                                 </div>
// //                               </button>

// //                               {/* Winners Card */}
// //                               <button
// //                                 onClick={() =>
// //                                   openModal("winners", data.winners || [], year)
// //                                 }
// //                                 className="bg-green-50 rounded-lg shadow-sm p-3 border-l-4 border-green-500 hover:shadow-md transition-shadow text-left w-full"
// //                               >
// //                                 <div className="flex items-center justify-between">
// //                                   <div>
// //                                     <h3 className="text-xs font-medium text-green-700 mb-1">
// //                                       Winners
// //                                     </h3>
// //                                     <p className="text-xl font-bold text-green-600">
// //                                       {data.winners?.length || 0}
// //                                     </p>
// //                                   </div>
// //                                   <div className="bg-green-100 p-1.5 rounded">
// //                                     <Trophy className="w-4 h-4 text-green-600" />
// //                                   </div>
// //                                 </div>
// //                               </button>
// //                             </>
// //                           )}
// //                         </div>
// //                       )}
// //                     </div>
// //                   </div>
// //                 </div>
// //               ))
// //           )}
// //         </div>
// //       </div>

// //       {/* Modal - Highest z-index, rendered outside main content */}
// //       {renderModalContent()}
// //     </>
// //   );
// // };

// // export default AwardsAccordion;


// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   ChevronDown,
//   Users,
//   Star,
//   Trophy,
//   Calendar,
//   X,
//   MapPin,
//   Menu,
//   Crown,
//   Mail,
//   Phone,
//   Eye,
//   Upload,
//   FileText,
//   Link,
//   ExternalLink,
//   ClipboardList,
//   Headphones,
//   User,
//   Info,
//   Sparkles
// } from "lucide-react";
// import DataTable from "./DataTable"; // Import your updated DataTable
// import api from "../../services/api";
// import { BASE_URL } from "../../services/configUrls";
// import VoteNowBadge from "../../Layouts/VotingButton";
// import ConferenceApp from "./ConferenceApp";
// import EastBourneResortMap from "./Venue";
// import EnhancedMinimalistAgenda from "./Agenda";
// import EventFeedbackForm from "../Admin/NominationMarking/EventFeedbackForm";
// import ConferenceTicketGenerator from "../Trainer FDP/Slots/ConferenceTicketGenerator";
// import AwardsByCategory from "./AwardsByCategory";

// // For demo purposes, we'll create mock versions

// // Skeleton components
// const SkeletonCard = () => (
//   <div className="bg-white/60 rounded-xl shadow-sm p-4 border border-gray-100 animate-pulse">
//     <div className="flex items-center space-x-3">
//       <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
//       <div className="flex-1">
//         <div className="h-3 bg-gray-200 rounded mb-2 w-20"></div>
//         <div className="h-5 bg-gray-200 rounded w-12"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonAccordion = () => (
//   <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 animate-pulse">
//     <div className="px-6 py-4 flex items-center justify-between">
//       <div className="flex items-center space-x-4">
//         <div className="bg-gray-200 p-2 rounded-lg w-10 h-10"></div>
//         <div>
//           <div className="h-5 bg-gray-200 rounded w-20 mb-1"></div>
//           <div className="h-3 bg-gray-200 rounded w-32"></div>
//         </div>
//       </div>
//       <div className="w-5 h-5 bg-gray-200 rounded"></div>
//     </div>
//   </div>
// );

// // ── Celebration Popper ──────────────────────────────────────────────────────
// const CONFETTI_COLORS = [
//   "#FFD700", "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4",
//   "#FFEAA7", "#DDA0DD", "#98FB98", "#F0E68C", "#FF69B4",
// ];
// const EMOJIS = ["🏆", "🌟", "🎉", "✨", "🥇", "🎊", "⭐"];

// const CelebrationPopper = ({ onDismiss, origin, side = "right" }) => {
//   const canvasRef = React.useRef(null);
//   const animRef = React.useRef(null);
//   const particlesRef = React.useRef([]);

//   React.useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext("2d");

//     const resize = () => {
//       canvas.width = window.innerWidth;
//       canvas.height = window.innerHeight;
//     };
//     resize();
//     window.addEventListener("resize", resize);

//     // Burst origin — corner of the table (or fallback)
//     const ox = origin?.x ?? window.innerWidth * 0.85;
//     const oy = origin?.y ?? window.innerHeight * 0.35;

//     // Spawn particles — burst FROM origin upward, then fall due to gravity
//     // side="left"  → fan angles -10° to -100° (upper-right arc)
//     // side="right" → fan angles -80° to -170° (upper-left arc)
//     const count = 140;
//     const angleMin = side === "left" ? 0.05 : 0.45;   // fraction of -PI
//     const angleRange = 0.5;                             // span of 90° each
//     particlesRef.current = Array.from({ length: count }, (_, i) => {
//       const angle = -Math.PI * (angleMin + Math.random() * angleRange);
//       const speed = Math.random() * 50 + 5;
//       return {
//         x: ox,
//         y: oy,
//         vx: Math.cos(angle) * speed,
//         vy: Math.sin(angle) * speed,          // negative = upward
//         spinAngle: Math.random() * Math.PI * 2,
//         spin: (Math.random() - 0.5) * 0.35,
//         size: Math.random() * 9 + 5,
//         color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
//         emoji: i % 8 === 0 ? EMOJIS[Math.floor(Math.random() * EMOJIS.length)] : null,
//         opacity: 1,
//         shape: Math.random() > 0.5 ? "rect" : "circle",
//       };
//     });

//     let frame = 0;
//     const GRAVITY = 0.45;   // pulls particles downward each frame
//     const DRAG   = 0.99;    // slight air resistance

//     const draw = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       frame++;

//       particlesRef.current = particlesRef.current.map((p) => {
//         const updated = {
//           ...p,
//           x: p.x + p.vx,
//           y: p.y + p.vy,
//           vx: p.vx * DRAG,
//           vy: p.vy * DRAG + GRAVITY,   // gravity pulls down
//           spinAngle: p.spinAngle + p.spin,
//           opacity: frame > 80 ? Math.max(0, p.opacity - 0.014) : p.opacity,
//         };

//         ctx.save();
//         ctx.globalAlpha = updated.opacity;
//         ctx.translate(updated.x, updated.y);
//         ctx.rotate(updated.spinAngle);

//         if (updated.emoji) {
//           ctx.font = `${updated.size + 8}px serif`;
//           ctx.textAlign = "center";
//           ctx.textBaseline = "middle";
//           ctx.fillText(updated.emoji, 0, 0);
//         } else if (updated.shape === "rect") {
//           ctx.fillStyle = updated.color;
//           ctx.fillRect(-updated.size / 2, -updated.size / 4, updated.size, updated.size / 2);
//         } else {
//           ctx.beginPath();
//           ctx.arc(0, 0, updated.size / 2, 0, Math.PI * 2);
//           ctx.fillStyle = updated.color;
//           ctx.fill();
//         }

//         ctx.restore();
//         return updated;
//       }).filter((p) => p.opacity > 0 && p.y < canvas.height + 60);

//       if (particlesRef.current.length > 0) {
//         animRef.current = requestAnimationFrame(draw);
//       } else {
//         onDismiss && onDismiss();
//       }
//     };

//     animRef.current = requestAnimationFrame(draw);

//     // Auto-dismiss after 5 seconds
//     const timer = setTimeout(() => {
//       onDismiss && onDismiss();
//     }, 5000);

//     return () => {
//       cancelAnimationFrame(animRef.current);
//       window.removeEventListener("resize", resize);
//       clearTimeout(timer);
//     };
//   }, [onDismiss, origin?.x, origin?.y, side]);

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         zIndex: 99999,
//         pointerEvents: "none",
//       }}
//     >
//       <canvas ref={canvasRef} style={{ position: "absolute", inset: 0 }} />
//       {/* Popup card — commented out, confetti only */}
//       {/* <div
//         style={{
//           position: "relative",
//           background: "linear-gradient(135deg, rgba(255,215,0,0.97) 0%, rgba(255,165,0,0.97) 100%)",
//           borderRadius: "24px",
//           padding: "40px 56px",
//           boxShadow: "0 32px 80px rgba(0,0,0,0.35), 0 0 0 3px rgba(255,255,255,0.4) inset",
//           textAlign: "center",
//           maxWidth: "440px",
//           animation: "celebPop 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) forwards",
//           pointerEvents: "auto",
//         }}
//         onClick={onDismiss}
//       >
//         <style>{`
//           @keyframes celebPop {
//             0% { transform: scale(0.3) rotate(-8deg); opacity: 0; }
//             100% { transform: scale(1) rotate(0deg); opacity: 1; }
//           }
//           @keyframes trophyBounce {
//             0%, 100% { transform: translateY(0) rotate(-5deg); }
//             50% { transform: translateY(-14px) rotate(5deg); }
//           }
//           @keyframes shimmer {
//             0% { background-position: -200% center; }
//             100% { background-position: 200% center; }
//           }
//         `}</style>
//         <div style={{ fontSize: "64px", lineHeight: 1, marginBottom: "12px", animation: "trophyBounce 1.2s ease-in-out infinite" }}>🏆</div>
//         <div
//           style={{
//             fontSize: "26px",
//             fontWeight: "900",
//             color: "#7B3F00",
//             marginBottom: "8px",
//             fontFamily: "system-ui, sans-serif",
//             letterSpacing: "-0.5px",
//           }}
//         >
//           Congratulations, Winner! 🎉
//         </div>
//         <div
//           style={{
//             fontSize: "15px",
//             color: "#92400e",
//             fontFamily: "system-ui, sans-serif",
//             lineHeight: 1.5,
//             marginBottom: "20px",
//           }}
//         >
//           You've won an EduSkills Connect Award!<br />
//           <span style={{ fontWeight: "700" }}>Well done — you earned it! ⭐</span>
//         </div>
//         <div
//           style={{
//             fontSize: "12px",
//             color: "rgba(120,60,0,0.7)",
//             fontFamily: "system-ui, sans-serif",
//           }}
//         >
//           Tap anywhere to continue
//         </div>
//       </div> */}
//     </div>
//   );
// };

// // COE Award Ranking Table — fetches /coe_award_ranking_v2
// const CoeAwardTable = ({ registrationStatus }) => {
//   const [rankData, setRankData] = useState({ institute: [], individual: [] });
//   const [activeTab, setActiveTab] = useState("institute");
//   const [rankLoading, setRankLoading] = useState(true);
//   const [tooltipId, setTooltipId] = useState(null);
//   const [showCelebration, setShowCelebration] = useState(false);
//   const [popperLeft, setPopperLeft]   = useState(null);
//   const [popperRight, setPopperRight] = useState(null);
//   const tableRef = React.useRef(null);

//   useEffect(() => {
//     const fetchRankings = async () => {
//       try {
//         setRankLoading(true);
//         const accessToken = localStorage.getItem("accessToken");
//         if (!accessToken) return;
//         const res = await api.get(`${BASE_URL}/awards/coe_award_ranking_v2`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         });
//         if (res.data) {
//           const instituteRows = Object.entries(res.data.institute || {}).map(([awardName, entries]) => {
//             const entry = Array.isArray(entries) && entries.length > 0 ? entries[0] : null;
//             return { awardName, entry };
//           });
//           const individualRows = Object.entries(res.data.individual || {}).map(([awardName, status]) => {
//             return { awardName, status };
//           });
//           setRankData({ institute: instituteRows, individual: individualRows });

//           // 🎉 Trigger celebration if any award is won
//           const hasWinner =
//             instituteRows.some((r) => r.entry?.is_winner === true) ||
//             individualRows.some((r) => r.status?.is_winner === true);
//           if (hasWinner) {
//             // Capture both top corners of the table as burst origins
//             if (tableRef.current) {
//               const rect = tableRef.current.getBoundingClientRect();
//               setPopperLeft({ x: rect.left + 20, y: rect.top + 20 });
//               setPopperRight({ x: rect.right - 20, y: rect.top + 20 });
//             }
//             setShowCelebration(true);
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching COE rankings:", err);
//       } finally {
//         setRankLoading(false);
//       }
//     };
//     fetchRankings();
//   }, []);

//   const getRankingCell = (entry, rankKey, totalKey, idx) => {
//     if (!entry) {
//       return (
//         <div className="flex items-center justify-center">
//           <span className="text-xs font-semibold text-red-500 bg-red-50 border border-red-200 px-2 py-0.5 rounded-full whitespace-nowrap">
//             Not Eligible
//           </span>
//         </div>
//       );
//     }

//     // Check for message from API
//     const hasMessage = !!entry.message;
    
//     // Check eligibility using limit vs total_internships OR placed_count
//     const hasLimit = entry.limit !== undefined && entry.limit !== null;
//     let countToCheck = 0;
//     let isPlacedCount = false;
    
//     if (entry.placed_count !== undefined && entry.placed_count !== null) {
//       countToCheck = entry.placed_count;
//       isPlacedCount = true;
//     } else if (entry.total_internships !== undefined && entry.total_internships !== null) {
//       countToCheck = entry.total_internships;
//     }
    
//     const failsLimit = hasLimit && (countToCheck < entry.limit);

//     if (hasMessage || failsLimit) {
//       // Use idx to ensure a stable tipId across re-renders
//       const tipId = `${rankKey}-${idx}`;
//       const tooltipText = hasMessage 
//         ? entry.message 
//         : `Your institute must have at least ${entry.limit} ${isPlacedCount ? 'placements' : 'completed internships'} to be eligible.`;

//       return (
//         <div className="flex items-center justify-center">
//           <div className="relative flex items-center">
//             <span className="text-xs font-semibold text-red-500 bg-red-50 border border-red-200 px-2 py-0.5 rounded-full whitespace-nowrap">
//               Not Eligible
//             </span>
//             <div className="absolute left-full ml-1.5 z-10">
//               <button
//                 className="text-gray-400 hover:text-blue-500 transition-colors cursor-pointer flex items-center"
//                 onMouseEnter={() => setTooltipId(tipId)}
//                 onMouseLeave={() => setTooltipId(null)}
//               >
//                 <Info className="w-3.5 h-3.5" />
//               </button>
//               {tooltipId === tipId && (
//                 <div className="absolute bottom-6 right-0 w-52 bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-xl leading-snug">
//                   {tooltipText}
//                   <div className="absolute top-full right-2 border-4 border-transparent border-t-gray-900"></div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       );
//     }

//     if (entry?.is_winner) return <span className="text-gray-400 text-xs">—</span>;

//     const rank = entry[rankKey];
//     const total = entry[totalKey];
//     if (rank === null || rank === undefined) return <span className="text-gray-400 text-xs">—</span>;
//     return (
//       <span className="inline-flex items-center justify-center text-sm font-bold text-amber-600 bg-amber-100/80 px-2.5 py-1 rounded-md">
//         #{rank}
//       </span>
//     );
//   };

//   return (
//     <div className="mt-6" ref={tableRef}>
//       {/* 🎉 Celebration Poppers — left & right corners */}
//       {showCelebration && (
//         <>
//           <CelebrationPopper
//             side="left"
//             origin={popperLeft}
//             onDismiss={() => setShowCelebration(false)}
//           />
//           <CelebrationPopper
//             side="right"
//             origin={popperRight}
//             onDismiss={() => setShowCelebration(false)}
//           />
//         </>
//       )}
//       {/* Info Note */}
//       <div className="flex items-start gap-2.5 bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 mb-4">
//         <Info className="w-4 h-4 text-blue-500 shrink-0 mt-0.5" />
//         <span className="text-sm text-gray-800 leading-snug">
//           <span className="font-bold">Note:</span> <span className="font-normal">All rankings are  <span className="font-bold">provisional  </span> and subject to change based on the completion of <span className="font-bold"> Cohort 17   </span> and the final verification process. The <span className="font-bold"> EduSkills Connect 2026 Award Winners </span> will be selected based on the final rankings. The official winners' list will be announced in the <span className="font-bold">first week of September 2026 </span> and published on the <a href="https://connect.eduskillsfoundation.org/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline"> Eduskills Connect website</a>.</span>
//           <br />
//           {/* {registrationStatus === 0 && (
//             <span className="text-red-400 block mt-2">*Nomination and voting are not applicable.</span>
//           )} */}
//         </span>
//       </div>

//       {/* Tabs */}
//       <div className="flex gap-6 mb-4 border-b border-gray-200">
//         <button
//           onClick={() => setActiveTab("institute")}
//           className={`pb-2 font-semibold text-sm transition-colors relative ${
//             activeTab === "institute" ? "text-amber-600" : "text-gray-500 hover:text-gray-700"
//           }`}
//         >
//           Institute Awards
//           {activeTab === "institute" && (
//             <div className="absolute bottom-[-1px] left-0 right-0 h-0.5 bg-amber-500 rounded-t-full"></div>
//           )}
//         </button>
//         <button
//           onClick={() => setActiveTab("individual")}
//           className={`pb-2 font-semibold text-sm transition-colors relative ${
//             activeTab === "individual" ? "text-amber-600" : "text-gray-500 hover:text-gray-700"
//           }`}
//         >
//           Individual Awards
//           {activeTab === "individual" && (
//             <div className="absolute bottom-[-1px] left-0 right-0 h-0.5 bg-amber-500 rounded-t-full"></div>
//           )}
//         </button>
//       </div>

//       {activeTab === "institute" ? (
//       <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-100">
//         <table className="w-full text-left border-collapse">
//           <thead>
//             <tr className="bg-gray-50 border-b border-gray-100 text-sm text-gray-600">
//               <th className="p-4 font-semibold">Award Name</th>
//               <th className="p-4 font-semibold text-center">State Ranking</th>
//               <th className="p-4 font-semibold text-center">National Ranking</th>
//               <th className="p-4 font-semibold text-center">Award Winner</th>
//             </tr>
//           </thead>
//           <tbody>
//             {rankLoading ? (
//               <tr>
//                 <td colSpan="4" className="p-8 text-center">
//                   <div className="flex justify-center">
//                     <div className="w-8 h-8 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
//                   </div>
//                 </td>
//               </tr>
//             ) : rankData.institute.length === 0 ? (
//               <tr>
//                 <td colSpan="4" className="p-8 text-center text-gray-500">
//                   <div className="flex flex-col items-center justify-center">
//                     <Trophy className="w-10 h-10 text-gray-300 mb-3" />
//                     <p className="font-medium">No institute ranking data available yet.</p>
//                   </div>
//                 </td>
//               </tr>
//             ) : (
//               rankData.institute.map(({ awardName, entry }, idx) => (
//                 <tr
//                   key={idx}
//                   className={`border-b border-gray-50 transition-colors ${
//                     entry?.is_winner
//                       ? "bg-amber-50/60 hover:bg-amber-50"
//                       : "hover:bg-gray-50/50"
//                   }`}
//                 >
//                   <td className="p-4 text-sm font-semibold text-gray-800">{awardName}</td>
//                   <td className="p-4 text-center">
//                     {getRankingCell(entry, "rank_position_state", "total_institutes_state", idx)}
//                   </td>
//                   <td className="p-4 text-center">
//                     {getRankingCell(entry, "rank_position", "total_institutes", idx)}
//                   </td>
//                   <td className="p-4 text-center">
//                     {entry?.is_winner ? (
//                       <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-700 border border-amber-200">
//                         <Trophy className="w-3.5 h-3.5" />
//                         Winner
//                       </span>
//                     ) : (
//                       <span className="text-xs text-gray-400">—</span>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//       ) : (
//         <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-100">
//           <table className="w-full text-left border-collapse">
//             <thead>
//               <tr className="bg-gray-50 border-b border-gray-100 text-sm text-gray-600">
//                 <th className="p-4 font-semibold">Award Name</th>
//                 <th className="p-4 font-semibold text-center">Award Winner</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rankLoading ? (
//                 <tr>
//                   <td colSpan="2" className="p-8 text-center">
//                     <div className="flex justify-center">
//                       <div className="w-8 h-8 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
//                     </div>
//                   </td>
//                 </tr>
//               ) : rankData.individual.length === 0 ? (
//                 <tr>
//                   <td colSpan="2" className="p-8 text-center text-gray-500">
//                     <div className="flex flex-col items-center justify-center">
//                       <Trophy className="w-10 h-10 text-gray-300 mb-3" />
//                       <p className="font-medium">No individual awards available yet.</p>
//                     </div>
//                   </td>
//                 </tr>
//               ) : (
//                 rankData.individual.map(({ awardName, status }, idx) => (
//                   <tr
//                     key={idx}
//                     className={`border-b border-gray-50 transition-colors ${
//                       status?.is_winner
//                         ? "bg-amber-50/60 hover:bg-amber-50"
//                         : "hover:bg-gray-50/50"
//                     }`}
//                   >
//                     <td className="p-4 text-sm font-semibold text-gray-800">{awardName}</td>
//                     <td className="p-4 text-center">
//                       {status?.is_winner ? (
//                         <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-700 border border-amber-200">
//                           <Trophy className="w-3.5 h-3.5" />
//                           Winner
//                         </span>
//                       ) : (
//                         <span className="text-xs text-gray-400">—</span>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// const AwardsTab = ({ data, year, openModal, showAward, activeSubCategory, rmDetails, rmLoading }) => {

//   const [awards, setAwards] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const [applyingId, setApplyingId] = useState(null);
  
//   const [eduAwards, setEduAwards] = useState([]);
//   const [loadingEdu, setLoadingEdu] = useState(false);
//   const [errorEdu, setErrorEdu] = useState(null);

//   const activeSubTab = activeSubCategory || (showAward === 1 ? "special" : "education");

//   const [nominationStatus, setNominationStatus] = useState(null);
//   const [nominationLoading, setNominationLoading] = useState(true);
//   const [eduTab, setEduTab] = useState('individual');

//   // Fetch global nomination status
//   useEffect(() => {
//     const fetchNominationStatus = async () => {
//       try {
//         setNominationLoading(true);
//         const accessToken = localStorage.getItem("accessToken");
//         if (!accessToken) return;

//         const response = await api.get(`${BASE_URL}/internship/nomination/status`, {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (response.status === 200) {
//           setNominationStatus(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching nomination status:", error);
//       } finally {
//         setNominationLoading(false);
//       }
//     };

//     fetchNominationStatus();
//   }, []);

//   // No longer need to reset activeSubTab locally because it is managed by the parent


//   const handleApplyClick = async (award) => {
//     const awardId = award.id || award.category_id || award.award_id;
//     if (award.nomination_status === 'submitted') {
//       try {
//         setApplyingId(awardId);
//         const accessToken = localStorage.getItem("accessToken");
        
//         // Use nomination_id if provided by backend, otherwise try awardId as fallback
//         const nomId = award.nomination_id || awardId;
        
//         const res = await api.get(`${BASE_URL}/awards/nominations?nomination_id=${nomId}`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         });
        
//         if (res.data) {
//           openModal("view_nomination", res.data, year);
//         }
//       } catch (err) {
//         console.error("Error fetching nomination details:", err);
//         openModal("error", { message: err.response?.data?.detail || "Failed to load nomination details." }, year);
//       } finally {
//         setApplyingId(null);
//       }
//       return;
//     }

//     try {
//       setApplyingId(awardId);
//       const accessToken = localStorage.getItem("accessToken");
//       const res = await api.get(`${BASE_URL}/awards/nomination-form/${awardId}`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
      
//       if (res.data) {
//         openModal("apply_form", { ...res.data, award_id: awardId, award_name: award.award_name }, year);
//       }
//     } catch (err) {
//       console.error("Error fetching nomination form:", err);
//       openModal("error", { message: err.response?.data?.detail || "Failed to load the nomination form. Please try again later." }, year);
//     } finally {
//       setApplyingId(null);
//     }
//   };

//   useEffect(() => {
//     const fetchAwards = async () => {
//       try {
//         setLoading(true);
//         const accessToken = localStorage.getItem("accessToken");
//         // Fetch active awards
//         const res = await api.get(`${BASE_URL}/awards/award/institutes`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         });
//         if (res.data && res.data.data) {
//           setAwards(res.data.data);
//         }
//       } catch (err) {
//         console.error("Error fetching awards:", err);
//         setError("Failed to load available awards.");
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchAwards();
//   }, []);

//   useEffect(() => {
//     const fetchEduAwards = async () => {
//       if (activeSubTab !== "education") return;
//       if (eduAwards.length > 0) return; // Already fetched
      
//       try {
//         setLoadingEdu(true);
//         const accessToken = localStorage.getItem("accessToken");
//         // Attempting to hit the provided API path (might need adjustment if not under /awards)
//         // const res = await api.get(`${BASE_URL}/awards/education_excellence_awards`, {
//         //   headers: { Authorization: `Bearer ${accessToken}` },
//         // });
//         // if (res.data && res.data.awards) {
//         //   setEduAwards(res.data.awards);
//         // }
//       } catch (err) {
//         console.error("Error fetching education excellence awards:", err);
//         setErrorEdu("Failed to load education excellence awards.");
//       } finally {
//         setLoadingEdu(false);
//       }
//     };
    
//     fetchEduAwards();
//   }, [activeSubTab, eduAwards.length]);

//   const subTabs = [];
//   if (showAward === 1) {
//     subTabs.push({ id: "special", label: "Special Category Award", color: "blue" });
//   }
//   subTabs.push({ id: "education", label: "Education Excellence Category", color: "blue" });
//   subTabs.push({ id: "general", label: "Eduskills Center Of Excellence (COE) Awards", color: "blue" });

//   const hasAccess = nominationStatus?.registration_status === 1;

//   if (nominationLoading) {
//     return (
//       <div className="flex justify-center py-12">
//         <div className="w-10 h-10 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
//       </div>
//     );
//   }

//   if (!hasAccess && activeSubTab === "education") {
//     return (
//       <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgb(59,130,246,0.12)] p-3 md:p-4 max-w-2xl mx-auto my-0 border border-blue-100 relative overflow-hidden">
//         <div className="flex flex-col items-center text-center relative z-10 pt-4">
//           {/* Awards List */}
//           <div className="w-full max-w-2xl mx-auto mb-6">
//             <h2 className="text-lg md:text-xl font-bold text-slate-800 mb-4 text-center">
//               Awards
//             </h2>
//             <div className="grid grid-cols-2 gap-3 text-left">
//               {(rmDetails.awards || []).map((award, index) => (
//                 <div key={index} className="flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-xl px-3 py-3 hover:bg-blue-100/50 transition-colors">
//                   <div className="w-7 h-7 rounded-full bg-blue-500 flex items-center justify-center text-white shrink-0 shadow-sm">
//                     <Trophy className="w-3.5 h-3.5" />
//                   </div>
//                   <span className="text-slate-700 font-semibold text-xs md:text-sm leading-snug">
//                     {award.award_name}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Divider 2 */}
//           <div className="w-full flex items-center justify-center mb-3 relative max-w-lg mx-auto">
//             <div className="h-px bg-transparent flex-1 border-t border-dashed border-gray-300"></div>
//             <div className="px-3 relative">
//               <div className="w-8 h-8 bg-orange-50 rounded-full border border-orange-100 flex items-center justify-center">
//                 <Headphones className="w-4 h-4 text-orange-400" />
//               </div>
//             </div>
//             <div className="h-px bg-transparent flex-1 border-t border-dashed border-gray-300"></div>
//           </div>

//           <h3 className="text-xs md:text-sm font-bold text-slate-800 mb-2">For Nomination, Please Connect With</h3>

//           {/* Contact Box */}
//           <div className="w-full max-w-3xl bg-orange-50/40 border border-orange-100 rounded-2xl p-4 mb-6">
//             <div className="w-fit mx-auto md:w-full flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
//               <div className="flex items-center gap-2">
//                 <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center text-orange-500 shrink-0">
//                   <User className="w-4 h-4" />
//                 </div>
//                 <span className="font-bold text-slate-800 text-xs md:text-sm">
//                    {rmLoading ? (
//                      <span className="animate-pulse bg-slate-200 h-4 w-24 rounded inline-block"></span>
//                    ) : (
//                      rmDetails.rm_name || "Pritipragyan"
//                    )}
//                 </span>
//               </div>
              
//               <div className="flex items-center gap-2">
//                 <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center text-orange-500 shrink-0">
//                   <Mail className="w-4 h-4" />
//                 </div>
//                 {rmLoading ? (
//                   <span className="animate-pulse bg-slate-200 h-4 w-32 rounded inline-block"></span>
//                 ) : (
//                   <a href={`mailto:${rmDetails.rm_email || "lead_op@eduskills.academy"}`} className="font-bold text-blue-600 text-xs md:text-sm hover:underline">
//                     {rmDetails.rm_email || "lead_op@eduskills.academy"}
//                   </a>
//                 )}
//               </div>

//               <div className="flex items-center gap-2">
//                 <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center text-orange-500 shrink-0">
//                   <Phone className="w-4 h-4" />
//                 </div>
//                 {rmLoading ? (
//                   <span className="animate-pulse bg-slate-200 h-4 w-24 rounded inline-block"></span>
//                 ) : (
//                   <a href={`tel:${rmDetails.rm_mobile || "8093254905"}`} className="font-bold text-blue-600 text-xs md:text-sm hover:underline">
//                     {rmDetails.rm_mobile || "8093254905"}
//                   </a>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Info Banner */}
        

//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-6">
//       {/* Sub Tab Content */}
//       <div className="pt-2">
//                 {/* Education Excellence Category */}
//         {activeSubTab === "education" && (() => {
//           const individualAwardsList = [];
//           const instituteAwardsList = [];

//           if (nominationStatus) {
//             // Main Award (Individual)
            
//             // Check if user has already submitted an individual award (ignore coe type)
//             const hasSubmittedIndividual = (nominationStatus.submited_awards || []).some(
//               sa => (sa.award_type || '').toLowerCase() === 'individual'
//                  && (sa.award_type || '').toLowerCase() !== 'coe'
//             );
//             const showPrimary = nominationStatus.nomination_submitted || !hasSubmittedIndividual;

//             if (showPrimary && nominationStatus.category_name) {
//               const primarySubmitted = (nominationStatus.submited_awards || []).find(sa => sa.category_id === nominationStatus.category_id || sa.award_name === nominationStatus.category_name);

//               individualAwardsList.push({
//                 id: nominationStatus.category_id,
//                 award_name: nominationStatus.category_name,
//                 nomination_start: nominationStatus.nomination_start_date,
//                 nomination_end: nominationStatus.nomination_end_date,
//                 voting_start_date: nominationStatus.voting_start_date,
//                 voting_end_date: nominationStatus.voting_end_date,
//                 voting_status: nominationStatus.voting_status,
//                 status: nominationStatus.nomination_status,
//                 voters_count: nominationStatus.voters_count,
//                 corporate_voters_count: nominationStatus.corporate_voters_count,
//                 is_winner: primarySubmitted ? primarySubmitted.is_winner : undefined,
//                 isPrimary: true
//               });
//             }

//             // Eligible Awards
//             if (nominationStatus.eligible_awards) {
//               nominationStatus.eligible_awards.forEach(award => {
//                 const submitted = (nominationStatus.submited_awards || []).find(sa => sa.id === award.id || sa.award_name === award.award_name);
//                 const awardData = {
//                   ...award,
//                   status: submitted ? submitted.nomination_status || 'submitted' : null,
//                   voters_count: submitted ? submitted.voters_count : 0,
//                   corporate_voters_count: submitted ? submitted.corporate_voters_count : 0,
//                   is_winner: submitted ? submitted.is_winner : null,
//                   nomination_start: award.nomination_start_date || award.nomination_start,
//                   nomination_end: award.nomination_end_date || award.nomination_end,
//                 };
//                 if ((award.award_type || '').toLowerCase() === 'individual') {
//                   individualAwardsList.push(awardData);
//                 } else if ((award.award_type || '').toLowerCase() === 'institute') {
//                   instituteAwardsList.push(awardData);
//                 }
//               });
//             }

//             // Other submitted awards not in eligible list (exclude coe type)
//             if (nominationStatus.submited_awards) {
//               nominationStatus.submited_awards.forEach(sa => {
//                 // Skip COE type awards entirely
//                 if ((sa.award_type || '').toLowerCase() === 'coe') return;

//                 const exists = [...individualAwardsList, ...instituteAwardsList].some(a => a.id === sa.id || a.award_name === sa.award_name);
//                 if (!exists) {
//                   const awardData = {
//                     ...sa,
//                     status: sa.nomination_status || 'submitted',
//                     nomination_start: sa.nomination_start_date || sa.nomination_start,
//                     nomination_end: sa.nomination_end_date || sa.nomination_end,
//                   };
//                   if ((sa.award_type || '').toLowerCase() === 'individual' && awardData.category_id !== nominationStatus.category_id) {
//                     individualAwardsList.push(awardData);
//                   } else if ((sa.award_type || '').toLowerCase() === 'institute') {
//                     instituteAwardsList.push(awardData);
//                   }
//                 }
//               });
//             }
//           }

//           // Since the tabs are hidden, combine both lists to show all awards
//           const currentAwardsList = [...individualAwardsList, ...instituteAwardsList];

//           return (
//             <>
//               {/* Tabs - Individual/Institute */}
//               {/* <div className="flex space-x-2 border-b border-gray-200">
//                 <button
//                   onClick={() => setEduTab("individual")}
//                   className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
//                     eduTab === "individual"
//                       ? "border-blue-600 text-blue-600"
//                       : "border-transparent text-gray-500 hover:text-blue-600 hover:border-blue-300"
//                   }`}
//                 >
//                   Individual
//                 </button>
//                 <button
//                   onClick={() => setEduTab("institute")}
//                   className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
//                     eduTab === "institute"
//                       ? "border-blue-600 text-blue-600"
//                       : "border-transparent text-gray-500 hover:text-blue-600 hover:border-blue-300"
//                   }`}
//                 >
//                   Institute
//                 </button>
//               </div> */}

//               {/* Table */}
//               <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-100 mt-6 ">
//                 <table className="w-full text-left border-collapse">
//                   <thead>
//                     <tr className="bg-gray-50 border-b border-gray-100 text-sm text-gray-600">
//                       <th className="p-4 font-semibold">Award Names</th>
//                       <th className="p-4 font-semibold">Nomination Date</th>
//                       <th className="p-4 font-semibold text-center w-48">Nomination</th>
//                       <th className="p-4 font-semibold text-center">Winner</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {nominationLoading ? (
//                       <tr>
//                         <td colSpan="4" className="p-8 text-center text-gray-500">
//                           <div className="flex justify-center">
//                             <div className="w-6 h-6 border-2 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
//                           </div>
//                         </td>
//                       </tr>
//                     ) : currentAwardsList.length === 0 ? (
//                       <tr>
//                         <td colSpan="4" className="p-8 text-center text-gray-500 font-medium">
//                           No awards are available.
//                         </td>
//                       </tr>
//                     ) : currentAwardsList.map((award, idx) => {
//                         const status = award.status ? award.status.toLowerCase() : null;
//                         const totalVotes = (award.voters_count || 0) + (award.corporate_voters_count || 0);
//                         return (
//                           <tr key={idx} className="border-b border-gray-50 hover:bg-gray-50/50 transition-colors">
//                             <td className="p-4 font-bold text-gray-800 text-sm hover:text-blue-600 transition-colors cursor-pointer">
//                               {award.award_name}
//                             </td>
//                             <td className="p-4 text-sm text-gray-600">
//                               <div className="flex flex-col gap-1.5">
//                                 {/* Nomination / Voting Date Range */}
//                                 {award.nomination_start && award.nomination_end ? (
//                                   <div className="flex items-center gap-1.5">
//                                     <Calendar className="w-3.5 h-3.5 text-gray-400 shrink-0" />
//                                     <span className="text-gray-700 whitespace-nowrap">
//                                       {new Date(award.nomination_start).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} – {new Date(award.nomination_end).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
//                                     </span>
//                                   </div>
//                                 ) : (
//                                   <span className="text-gray-400">N/A</span>
//                                 )}

//                                 {/* Voting Status badge — shown for primary award */}
//                                 {award.isPrimary && award.voting_status ? (
//                                   <span className="inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-100 w-fit whitespace-nowrap">
//                                     <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse inline-block"></span>
//                                     Voting {award.voting_status}
//                                   </span>
//                                 ) : !award.isPrimary && !award.voting_start_date ? (
//                                   /* Eligible awards with no voting yet */
//                                   <span className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-gray-50 text-gray-400 border border-gray-100 w-fit whitespace-nowrap">
//                                      No voting
//                                   </span>
//                                 ) : null}
//                               </div>
//                             </td>
//                             <td className="p-4 text-center">
//                               {!status ? (
//                                 award.nomination_end && new Date(award.nomination_end).setHours(23, 59, 59, 999) < new Date() ? (
//                                   <span className="inline-block w-full px-3 py-1.5 bg-gray-50 text-gray-500 text-xs font-semibold rounded-lg border border-gray-200">
//                                     Nomination Closed
//                                   </span>
//                                 ) : (
//                                   <button
//                                     onClick={() => {
//                                       if (award.isPrimary) {
//                                         navigate("/award/e3454-345");
//                                       } else {
//                                         handleApplyClick(award);
//                                       }
//                                     }}
//                                     className="w-full px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded-lg transition-colors shadow-sm"
//                                   >
//                                     Nomination
//                                   </button>
//                                 )
//                               ) : status === 'accepted' || status === 'nomination accepted' ? (
//                                 award.isPrimary ? (
//                                   <VoteNowBadge 
//                                     forceSubmitted={true}
//                                     customTrigger={({ onClick }) => (
//                                       <div className="flex flex-col items-center gap-1.5 w-full">
//                                         <button 
//                                           onClick={onClick}
//                                           className="w-full px-3 py-1.5 bg-green-50 hover:bg-green-100 text-green-700 text-[11px] font-bold rounded-lg border border-green-200 transition-colors shadow-sm"
//                                         >
//                                           Nomination Accepted - View Votes
//                                         </button>
//                                       </div>
//                                     )} 
//                                   />
//                                 ) : (
//                                   <div className="flex flex-col items-center gap-1.5 w-full">
//                                     <span className="w-full px-3 py-1.5 bg-green-50 text-green-700 text-xs font-semibold rounded-lg border border-green-200 text-center">
//                                       Nomination Accepted
//                                     </span>
//                                   </div>
//                                 )
//                               ) : status === 'rejected' || status === 'nomination rejected' ? (
//                                 <span className="inline-block w-full px-3 py-1.5 bg-red-50 text-red-700 text-xs font-semibold rounded-lg border border-red-200">
//                                   Nomination Rejected
//                                 </span>
//                               ) : (
//                                 <button
//                                   onClick={() => {
//                                     if (award.isPrimary) {
//                                       navigate("/award/e3454-345");
//                                     } else {
//                                       handleApplyClick(award);
//                                     }
//                                   }}
//                                   className="w-full px-3 py-1.5 bg-green-50 hover:bg-green-100 text-green-700 text-xs font-semibold rounded-lg transition-colors border border-green-200"
//                                 >
//                                   {status.charAt(0).toUpperCase() + status.slice(1)}
//                                 </button>
//                               )}
//                             </td>
//                             <td className="p-4 text-center text-sm font-medium">
//                               {award.is_winner === true || award.is_winner === "true" || award.is_winner === 1 ? (
//                                 <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200 shadow-sm whitespace-nowrap">
//                                   🏆 Winner
//                                 </span>
//                               ) : award.is_winner === false || award.is_winner === "false" || award.is_winner === 0 ? (
//                                 <span className="text-gray-400 font-bold whitespace-nowrap">—</span>
//                               ) : (
//                                 <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 text-[11px] font-semibold whitespace-nowrap">
//                                   <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse inline-block"></span>
//                                   ⏳ Coming Soon
//                                 </span>
//                               )}
//                             </td>
//                           </tr>
//                         );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//               {/* <p className="text-xs text-gray-400 mt-2 text-center italic">
//                 *Note: You can submit only one nomination from the above awards.
//               </p> */}
//             </>
//           );
//         })()}

//         {/* Special Category Award */}
//         {activeSubTab === "special" && showAward === 1 && (
//           <div>
//             {loading ? (
//               <div className="flex justify-center py-8">
//                 <div className="w-8 h-8 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
//               </div>
//             ) : error ? (
//               <div className="bg-red-50 text-red-600 p-4 rounded-xl text-sm border border-red-100">
//                 {error}
//               </div>
//             ) : awards.length === 0 ? (
//               <div className="bg-gray-50 border border-gray-100 rounded-xl p-8 text-center">
//                 <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
//                   <Trophy className="w-6 h-6 text-gray-400" />
//                 </div>
//                 <p className="text-gray-500 text-sm font-medium">No active awards available at this moment in this category.</p>
//               </div>
//             ) : (
//               <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-100">
//                 <table className="w-full text-left border-collapse">
//                   <thead>
//                     <tr className="bg-gray-50 border-b border-gray-100 text-sm text-gray-600">
//                       <th className="p-4 font-semibold">Award Name</th>
//                       <th className="p-4 font-semibold">Award Type</th>
//                       <th className="p-4 font-semibold">Nomination Date</th>
//                       <th className="p-4 font-semibold text-center w-48">Nomination</th>
//                       <th className="p-4 font-semibold text-center">Winner</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {awards.map((award, idx) => {
//                       const status = award.nomination_status ? award.nomination_status.toLowerCase() : null;
//                       return (
//                         <tr key={award.id || idx} className="border-b border-gray-50 hover:bg-gray-50/50 transition-colors">
//                           <td className="p-4 font-bold text-gray-800 text-sm hover:text-blue-600 transition-colors cursor-pointer">
//                             {award.award_name}
//                           </td>
//                           <td className="p-4 text-sm text-gray-600 font-medium">
//                             {award.award_type}
//                           </td>
//                           <td className="p-4 text-sm text-gray-600">
//                             {award.nomination_start_date && award.nomination_end_date ? (
//                               <div className="flex items-center gap-1.5">
//                                 <Calendar className="w-3.5 h-3.5 text-gray-400 shrink-0" />
//                                 <span className="text-gray-700 whitespace-nowrap">
//                                   {new Date(award.nomination_start_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} – {new Date(award.nomination_end_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
//                                 </span>
//                               </div>
//                             ) : (
//                               <span className="text-gray-400">N/A</span>
//                             )}
//                           </td>
//                           <td className="p-4 text-center">
//                             {status === 'submitted' ? (
//                               <button
//                                 onClick={() => handleApplyClick(award)}
//                                 disabled={applyingId === award.id}
//                                 className="w-full px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors shadow-sm flex items-center justify-center gap-2 bg-green-50 hover:bg-green-100 text-green-700 border border-green-200"
//                               >
//                                 {applyingId === award.id ? (
//                                   <div className="w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
//                                 ) : null}
//                                 Submitted
//                               </button>
//                             ) : award.nomination_end_date && new Date(award.nomination_end_date).setHours(23, 59, 59, 999) < new Date() ? (
//                               <span className="inline-flex w-full items-center justify-center px-3 py-1.5 bg-gray-50 text-gray-500 text-xs font-semibold rounded-lg border border-gray-200">
//                                 Nomination Closed
//                               </span>
//                             ) : (
//                               <button
//                                 onClick={() => handleApplyClick(award)}
//                                 disabled={applyingId === award.id}
//                                 className="w-full px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors shadow-sm flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white"
//                               >
//                                 {applyingId === award.id ? (
//                                   <div className="w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
//                                 ) : null}
//                                 Nomination
//                               </button>
//                             )}
//                           </td>
//                           <td className="p-4 text-center text-sm font-medium">
//                             {award.is_winner === true || award.is_winner === "true" || award.is_winner === 1 ? (
//                               <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200 shadow-sm whitespace-nowrap">
//                                 🏆 Winner
//                               </span>
//                             ) : award.is_winner === false || award.is_winner === "false" || award.is_winner === 0 ? (
//                               <span className="text-gray-400 font-bold whitespace-nowrap">—</span>
//                             ) : (
//                               <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 text-[11px] font-semibold whitespace-nowrap">
//                                 <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse inline-block"></span>
//                                 ⏳ Coming Soon
//                               </span>
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Awards (previously COE Awards) */}
//         {activeSubTab === "general" && (() => {
//           return <CoeAwardTable />;
//         })()}
//       </div>
//     </div>
//   );
// };

// const ParticipateTab = ({ participateLoading, participateData }) => {

//   if (participateLoading) {
//     return (
//       <div className="flex items-center justify-center py-20">
//         <div className="text-center">
//           <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-500 rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-gray-500 text-sm">Loading participate info...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!participateData || !participateData.members || participateData.members.length === 0) {
//     return (
//       <div className="flex items-center justify-center py-12">
//         <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center max-w-sm w-full">
//           <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
//             <Users className="w-8 h-8 text-gray-400" />
//           </div>
//           <h3 className="text-xl font-bold text-gray-800 mb-2">No Participants</h3>
//           <p className="text-gray-500 text-sm">No members are currently registered to participate.</p>
//         </div>
//       </div>
//     );
//   }

//   const displayMembers = participateData.members;

//   return (
//     <div className="space-y-5 mt-2">
//       {/* Cards Grid */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//         {displayMembers.length === 0 ? (
//           <div className="col-span-full flex flex-col items-center justify-center py-12 text-center">
//             <div className="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center mb-3">
//               <Trophy className="w-7 h-7 text-amber-400" />
//             </div>
//             <p className="text-gray-500 text-sm font-medium">No nominated members found.</p>
//           </div>
//         ) : (
//           displayMembers.map((member, index) => {
//             const hasAwards = member.awards && member.awards.length > 0;
//             return (
//               <div
//                 key={index}
//                 className="group relative bg-white border border-gray-100 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col overflow-hidden hover:-translate-y-1"
//               >
//                 {/* Top gradient accent */}
//                 <div className="h-1.5 w-full bg-gradient-to-r from-blue-500 to-indigo-600"></div>

//                 <div className="p-6 flex flex-col gap-5 flex-1">
//                   <div className="flex items-center gap-4">
//                     {/* Avatar placeholder with initials */}
//                     <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center shrink-0 border border-blue-200 group-hover:scale-105 transition-transform duration-300 shadow-sm">
//                       <Users className="w-6 h-6 text-blue-600" />
//                     </div>
//                     <div>
//                       <h4 className="font-bold text-gray-800 text-lg group-hover:text-blue-600 transition-colors">
//                         {member.fullname}
//                       </h4>
//                       <span className="inline-flex items-center px-2 py-0.5 rounded-lg text-[10px] font-bold bg-gray-50 text-gray-500 border border-gray-200 uppercase tracking-wider mt-1">
//                         Participant
//                       </span>
//                     </div>
//                   </div>

//                   <div className="space-y-3 bg-gray-50/50 p-3.5 rounded-xl border border-gray-100/50">
//                     <div className="flex items-start gap-3 text-sm text-gray-600">
//                       <div className="p-1.5 bg-white rounded-md shadow-sm border border-gray-100 shrink-0">
//                         <Mail className="w-3.5 h-3.5 text-blue-500" />
//                       </div>
//                       <span className="font-medium break-all mt-0.5 leading-snug">{member.email}</span>
//                     </div>
//                     <div className="flex items-start gap-3 text-sm text-gray-600">
//                       <div className="p-1.5 bg-white rounded-md shadow-sm border border-gray-100 shrink-0">
//                         <Phone className="w-3.5 h-3.5 text-blue-500" />
//                       </div>
//                       <span className="font-medium mt-0.5 leading-snug">{member.phone_no}</span>
//                     </div>
//                   </div>

//                   {hasAwards && (
//                     <div className="pt-2 flex-1 flex flex-col">
//                       <div className="flex items-center gap-2 mb-3">
//                         <div className="h-px flex-1 bg-gray-100"></div>
//                         <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
//                           Nominated Awards ({member.awards.length})
//                         </span>
//                         <div className="h-px flex-1 bg-gray-100"></div>
//                       </div>
//                       <div className="flex flex-col gap-2.5">
//                         {member.awards.map((award, idx) => (
//                           <div
//                             key={idx}
//                             className="flex items-start gap-3 bg-white p-3 rounded-xl border border-amber-100 shadow-sm hover:border-amber-300 hover:shadow-md transition-all group/award"
//                           >
//                             <div className="p-1.5 bg-amber-50 rounded-lg group-hover/award:bg-amber-100 transition-colors">
//                               <Trophy className="w-4 h-4 text-amber-500 shrink-0" />
//                             </div>
//                             <div className="flex flex-col flex-1 min-w-0 justify-center">
//                               <span className="text-sm font-bold text-gray-700 leading-tight group-hover/award:text-amber-700 transition-colors">
//                                 {award.award_name}
//                               </span>
//                               {award.type && (
//                                 <span className="text-[10px] uppercase font-bold text-amber-600 tracking-wider mt-1">
//                                   {award.type}
//                                 </span>
//                               )}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             );
//           })
//         )}
//       </div>
//     </div>
//   );
// };


// // ─────────────────────────────────────────────────────────────────────────────
// // 1 Million Internship Milestone Tab
// // API note: /institute-submissions returns ONE row per image, so we group rows
// // by submission_id on the frontend. Reupload is per-image via image_id.
// // ─────────────────────────────────────────────────────────────────────────────
// const MilestoneTab = () => {
//   const [rawRows, setRawRows] = useState([]);
//   const [milestoneLoading, setMilestoneLoading] = useState(true);
//   const [uploadLoading, setUploadLoading] = useState(false);
//   const [reuploadSubmitting, setReuploadSubmitting] = useState(false);
//   const [downloadLoadingId, setDownloadLoadingId] = useState(null);
//   const [certModal, setCertModal] = useState(null);
//   const [viewLoadingKey, setViewLoadingKey] = useState(null);
//   const [viewModalData, setViewModalData] = useState(null);
//   const [confirmModal, setConfirmModal] = useState(null);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [reuploadFile, setReuploadFile] = useState({});
//   const [error, setError] = useState(null);
//   const [successMsg, setSuccessMsg] = useState(null);
//   const fileInputRef = React.useRef(null);
//   const reuploadRefs = React.useRef({});

//   const getToken = () => localStorage.getItem("accessToken");

//   const fetchSubmissions = async () => {
//     try {
//       setMilestoneLoading(true);
//       setError(null);
//       const res = await api.get(`${BASE_URL}/awards/institute-submissions`, {
//         headers: { Authorization: `Bearer ${getToken()}` },
//       });
//       setRawRows(Array.isArray(res.data) ? res.data : []);
//     } catch (err) {
//       setError(err.response?.data?.detail || "Failed to load submissions.");
//     } finally {
//       setMilestoneLoading(false);
//     }
//   };

//   useEffect(() => { fetchSubmissions(); }, []);

//   const grouped = React.useMemo(() => {
//     const map = new Map();
//     rawRows.forEach((row) => {
//       const sid = row.submission_id;
//       if (!map.has(sid)) {
//         map.set(sid, {
//           submission_id: sid,
//           award_id: row.award_id,
//           award_name: row.award_name,
//           status: (row.status || "").toLowerCase(),
//           reason: row.reason,
//           images: [],
//         });
//       }
//       const existing = map.get(sid);
//       if (Array.isArray(row.images) && row.images.length > 0) {
//         row.images.forEach((img, idx) => {
//           existing.images.push({
//             image_id: img.image_id,
//             image_key: img.image_key,
//             sequence_no: img.sequence_no ?? (idx + 1),
//           });
//         });
//       } else if (row.image_key) {
//         existing.images.push({
//           image_id: row.image_id,
//           image_key: row.image_key,
//           sequence_no: row.sequence_no,
//         });
//       }
//     });
//     return Array.from(map.values());
//   }, [rawRows]);

//   const handleFileSelection = (e) => {
//     const files = Array.from(e.target.files || []);
//     if (!files.length) return;

//     setSelectedFiles((prev) => {
//       // Avoid duplicate files based on name and size
//       const existingKeys = new Set(prev.map((f) => `${f.name}_${f.size}`));
//       const uniqueNew = files.filter((f) => !existingKeys.has(`${f.name}_${f.size}`));
//       const combined = [...prev, ...uniqueNew];
//       if (combined.length > 3) {
//         setConfirmModal({
//           title: "File Limit Reached",
//           message: "You can only choose up to 3 files. Please select fewer files.",
//           confirmText: "Got it",
//           isAlert: true,
//           action: null
//         });
//         return prev;
//       }
//       return combined;
//     });

//     // Reset input value so selecting the same file again triggers onChange
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const handleRemoveSelectedFile = (indexToRemove) => {
//     setSelectedFiles((prev) => prev.filter((_, i) => i !== indexToRemove));
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const handleUpload = async () => {
//     if (!selectedFiles.length) return;
//     setConfirmModal({
//       title: "Upload Images",
//       message: "Are you sure you want to upload the image?",
//       confirmText: "Confirm Upload",
//       action: async () => {
//         setConfirmModal(null);
//         try {
//           setUploadLoading(true);
//           setError(null);
//           setSuccessMsg(null);
//           const formData = new FormData();
//           selectedFiles.forEach((f) => formData.append("images", f));
//           await api.post(`${BASE_URL}/awards/upload/screenshots`, formData, {
//             headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
//           });
//           setSelectedFiles([]);
//           if (fileInputRef.current) fileInputRef.current.value = "";
//           setSuccessMsg("Screenshots uploaded successfully!");
//           await fetchSubmissions();
//         } catch (err) {
//           setError(err.response?.data?.detail || "Upload failed.");
//         } finally {
//           setUploadLoading(false);
//         }
//       }
//     });
//   };

//   const handleReuploadAll = async (sub) => {
//     const selectedEntries = (sub.images || [])
//       .filter((img) => !!reuploadFile[img.image_id])
//       .map((img) => ({
//         imageId: img.image_id,
//         file: reuploadFile[img.image_id],
//       }));

//     if (selectedEntries.length === 0) return;
    
//     setConfirmModal({
//       title: "Confirm Re-upload",
//       message: "Are you sure you want to re-upload these replaced images?",
//       confirmText: "Submit",
//       action: async () => {
//         setConfirmModal(null);
//         const MAX_FILE_SIZE = 2 * 1024 * 1024;
//         for (const { file } of selectedEntries) {
//           if (file.size > MAX_FILE_SIZE) {
//             setError(`File "${file.name}" exceeds the 2 MB limit (${(file.size / (1024 * 1024)).toFixed(2)} MB). Please choose a smaller file.`);
//             return;
//           }
//         }

//         try {
//           setReuploadSubmitting(true);
//           setError(null);
//           setSuccessMsg(null);

//           const formData = new FormData();
//           selectedEntries.forEach(({ imageId, file }) => {
//             formData.append("image_ids", imageId);
//             formData.append("images", file);
//           });

//           const res = await api.put(`${BASE_URL}/awards/reupload/screenshots`, formData, {
//             headers: {
//               Authorization: `Bearer ${getToken()}`,
//               "Content-Type": "multipart/form-data",
//             },
//           });

//           setReuploadFile((prev) => {
//             const next = { ...prev };
//             selectedEntries.forEach(({ imageId }) => {
//               delete next[imageId];
//               if (reuploadRefs.current[imageId]) {
//                 reuploadRefs.current[imageId].value = "";
//               }
//             });
//             return next;
//           });

//           setSuccessMsg(res.data?.message || `${selectedEntries.length} screenshot(s) re-uploaded successfully. Submission is now pending review.`);
//           await fetchSubmissions();
//         } catch (err) {
//           console.error("Re-upload error:", err);
//           setError(err.response?.data?.detail || "Re-upload failed. Please try again.");
//         } finally {
//           setReuploadSubmitting(false);
//         }
//       }
//     });

//   };

//   const handleCertSelect = async (certType) => {
//     const submissionId = certModal;
//     if (!submissionId) return;
//     try {
//       setDownloadLoadingId(submissionId);
//       setCertModal(null);
//       setError(null);
//       const res = await api.get(
//         `${BASE_URL}/awards/get-certificate?cert_type=${certType}`,
//         { headers: { Authorization: `Bearer ${getToken()}` } }
//       );
//       const { cert_base64 } = res.data;
//       const link = document.createElement("a");
//       link.href = `data:image/png;base64,${cert_base64}`;
//       link.download = `certificate_${submissionId}_${certType}.png`;
//       link.click();
//     } catch (err) {
//       setError(err.response?.data?.detail || "Failed to download certificate.");
//     } finally {
//       setDownloadLoadingId(null);
//     }
//   };

//   const handleViewImage = async (s3Key) => {
//     try {
//       setViewLoadingKey(s3Key);
//       setError(null);
//       const res = await api.get(
//         `${BASE_URL}/awards/image-url?s3_key=${encodeURIComponent(s3Key)}`,
//         { headers: { Authorization: `Bearer ${getToken()}` } }
//       );
//       setViewModalData({ url: res.data.url });
//     } catch (err) {
//       setError(err.response?.data?.detail || "Failed to load image.");
//     } finally {
//       setViewLoadingKey(null);
//     }
//   };

//   const statusBadge = (status) => {
//     const cfg = {
//       pending: { cls: "bg-amber-50 text-amber-700 border-amber-200", label: "⏳ Pending Review" },
//       approved: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "✅ Approved" },
//       rejected: { cls: "bg-red-50 text-red-700 border-red-200", label: "❌ Rejected" },
//     };
//     const c = cfg[status] || { cls: "bg-gray-100 text-gray-600 border-gray-200", label: status };
//     return (
//       <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${c.cls}`}>
//         {c.label}
//       </span>
//     );
//   };

//   if (milestoneLoading) {
//     return (
//       <div className="flex items-center justify-center py-20">
//         <div className="text-center">
//           <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-500 rounded-full animate-spin mx-auto mb-4" />
//           <p className="text-gray-500 text-sm">Loading submissions...</p>
//         </div>
//       </div>
//     );
//   }

//   const hasActiveSubmission = grouped.some((s) => s.status === "pending" || s.status === "approved");
//   const hasRejected = grouped.some((s) => s.status === "rejected");

//   return (
//     <div className="space-y-6">
//       {/* Header */}
//       <div className="flex items-center gap-3 bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-100 rounded-2xl px-5 py-4">
//         <div className="p-2 bg-indigo-100 rounded-xl">
//           <Sparkles className="w-5 h-5 text-indigo-600" />
//         </div>
//         <div>
//           <h3 className="font-bold text-indigo-800 text-base">1 Million Internship Milestone Award</h3>
//           <p className="text-indigo-600 text-xs mt-0.5">Upload screenshot proof to claim your award certificate.</p>
//         </div>
//       </div>

//       {/* Alerts */}
//       {error && (
//         <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
//           <span className="text-red-500 text-lg leading-none mt-0.5">⚠️</span>
//           <p className="text-red-700 text-sm font-medium flex-1">{error}</p>
//           <button onClick={() => setError(null)} className="text-red-400 hover:text-red-600"><X className="w-4 h-4" /></button>
//         </div>
//       )}
//       {successMsg && (
//         <div className="flex items-start gap-3 bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-3">
//           <span className="text-emerald-500 text-lg leading-none mt-0.5">✅</span>
//           <p className="text-emerald-700 text-sm font-medium flex-1">{successMsg}</p>
//           <button onClick={() => setSuccessMsg(null)} className="text-emerald-400 hover:text-emerald-600"><X className="w-4 h-4" /></button>
//         </div>
//       )}

//       {/* First-time upload — shown only when no submissions exist */}
//       {!hasActiveSubmission && !hasRejected && (
//         <div className="bg-white rounded-2xl border-2 border-dashed border-indigo-300 p-6 shadow-sm">
//           <h4 className="font-semibold text-gray-800 mb-3 text-sm flex items-center gap-2">
//             <Upload className="w-4 h-4 text-indigo-500" />
//             Upload Screenshots
//             <span className="text-gray-400 font-normal text-xs">(max 2 MB each)</span>
//           </h4>
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept="image/*"
//             multiple
//             onChange={handleFileSelection}
//             className="block w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-xl file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 transition-all cursor-pointer"
//           />
//           {selectedFiles.length > 0 && (
//             <div className="mt-3 space-y-2">
//               <div className="flex items-center justify-between">
//                 <span className="text-xs font-semibold text-gray-600">
//                   Selected Images ({selectedFiles.length}):
//                 </span>
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setSelectedFiles([]);
//                     if (fileInputRef.current) fileInputRef.current.value = "";
//                   }}
//                   className="text-xs text-red-500 hover:text-red-700 font-medium transition-colors"
//                 >
//                   Clear all
//                 </button>
//               </div>
//               <div className="flex flex-wrap gap-2">
//                 {selectedFiles.map((f, i) => (
//                   <span
//                     key={`${f.name}-${f.size}-${i}`}
//                     className="inline-flex items-center gap-1.5 text-xs bg-indigo-50 text-indigo-700 border border-indigo-200 pl-2.5 pr-1.5 py-1 rounded-lg font-medium shadow-sm hover:border-indigo-300 transition-all"
//                   >
//                     <FileText className="w-3.5 h-3.5 shrink-0 text-indigo-600" />
//                     <span className="max-w-[200px] truncate" title={f.name}>{f.name}</span>
//                     <span className="text-[10px] text-indigo-500 font-normal">
//                       ({(f.size / (1024 * 1024)).toFixed(2)} MB)
//                     </span>
//                     <button
//                       type="button"
//                       onClick={() => handleRemoveSelectedFile(i)}
//                       className="p-1 text-indigo-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
//                       title="Remove this image"
//                     >
//                       <X className="w-3.5 h-3.5" />
//                     </button>
//                   </span>
//                 ))}
//               </div>
//             </div>
//           )}
//           <button
//             onClick={handleUpload}
//             disabled={!selectedFiles.length || uploadLoading}
//             className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white text-sm font-semibold rounded-xl transition-colors"
//           >
//             {uploadLoading && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />}
//             {uploadLoading ? "Uploading..." : `Submit Screenshots (${selectedFiles.length})`}
//           </button>
//         </div>
//       )}

//       {/* Submissions list */}
//       {grouped.length > 0 && (
//         <div className="space-y-5">
//           <h4 className="font-semibold text-gray-700 text-sm">Your Submissions</h4>
//           {grouped.map((sub) => (
//             <div
//               key={sub.submission_id}
//               className={`bg-white rounded-2xl border shadow-sm overflow-hidden ${sub.status === "rejected" ? "border-red-200" :
//                 sub.status === "approved" ? "border-emerald-200" : "border-gray-200"
//                 }`}
//             >
//               {/* Card header */}
//               <div className={`flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-b ${sub.status === "rejected" ? "bg-red-50/50 border-red-100" :
//                 sub.status === "approved" ? "bg-emerald-50/50 border-emerald-100" :
//                   "bg-gray-50/60 border-gray-100"
//                 }`}>
//                 <div>
//                   <p className="font-bold text-gray-800 text-sm">{sub.award_name}</p>
//                   <p className="text-xs text-gray-400 mt-0.5">Submission #{sub.submission_id}</p>
//                 </div>
//                 {statusBadge(sub.status)}
//               </div>

//               <div className="p-5 space-y-4">
//                 {/* Rejection reason */}
//                 {sub.status === "rejected" && sub.reason && (
//                   <div className="bg-red-50 border border-red-100 rounded-xl px-4 py-3">
//                     <p className="text-xs font-semibold text-red-600 mb-1">Rejection Reason:</p>
//                     <p className="text-sm text-red-700">{sub.reason}</p>
//                   </div>
//                 )}

//                 {/* Pending info */}
//                 {sub.status === "pending" && (
//                   <div className="bg-amber-50 border border-amber-100 rounded-xl px-4 py-3">
//                     <p className="text-xs text-amber-700">
//                       Your submission is under review. Upload and re-upload are disabled while status is <strong>pending</strong>.
//                     </p>
//                   </div>
//                 )}

//                 {/* Images */}
//                 {sub.images.length > 0 && (
//                   <div className="space-y-3">
//                     <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
//                       Uploaded Images ({sub.images.length})
//                     </p>
//                     {sub.images.map((img, idx) => {
//                       const stagedFile = reuploadFile[img.image_id];
//                       return (
//                         <div
//                           key={img.image_id}
//                           className={`bg-gray-50 border rounded-xl p-4 space-y-2.5 transition-all ${
//                             stagedFile ? "border-orange-300 bg-orange-50/40 ring-1 ring-orange-200" : "border-gray-100"
//                           }`}
//                         >
//                           {/* Image row top */}
//                           <div className="flex items-center justify-between gap-3 flex-wrap">
//                             <div className="flex items-center gap-2 min-w-0">
//                               <div
//                                 className={`w-7 h-7 rounded-lg flex items-center justify-center shrink-0 ${
//                                   stagedFile ? "bg-orange-100 text-orange-600" : "bg-blue-100 text-blue-600"
//                                 }`}
//                               >
//                                 <FileText className="w-3.5 h-3.5" />
//                               </div>
//                               <div className="min-w-0">
//                                 <p className="text-xs font-semibold text-gray-700">
//                                   Image {img.sequence_no ?? (idx + 1)}
//                                 </p>
//                                 <p className="text-[10px] text-gray-400 font-mono truncate max-w-[180px]">
//                                   {img.image_key?.split("/").pop()}
//                                 </p>
//                               </div>
//                             </div>

//                             <div className="flex items-center gap-2">
//                               {/* View button — lazy */}
//                               <button
//                                 type="button"
//                                 onClick={() => handleViewImage(img.image_key)}
//                                 disabled={viewLoadingKey === img.image_key}
//                                 className="shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100 transition-colors disabled:opacity-60"
//                               >
//                                 {viewLoadingKey === img.image_key ? (
//                                   <span className="w-3.5 h-3.5 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
//                                 ) : (
//                                   <Eye className="w-3.5 h-3.5" />
//                                 )}
//                                 View
//                               </button>

//                               {/* Re-upload button with icon (shown when status is rejected) */}
//                               {sub.status === "rejected" && (
//                                 <>
//                                   <input
//                                     ref={(el) => (reuploadRefs.current[img.image_id] = el)}
//                                     type="file"
//                                     accept="image/*"
//                                     className="hidden"
//                                     onChange={(e) =>
//                                       setReuploadFile((prev) => ({
//                                         ...prev,
//                                         [img.image_id]: e.target.files?.[0] || null,
//                                       }))
//                                     }
//                                   />
//                                   <button
//                                     type="button"
//                                     onClick={() => reuploadRefs.current[img.image_id]?.click()}
//                                     className={`shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg border transition-colors ${
//                                       stagedFile
//                                         ? "bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200"
//                                         : "bg-orange-50 text-orange-600 border-orange-200 hover:bg-orange-100"
//                                     }`}
//                                   >
//                                     <Upload className="w-3.5 h-3.5" />
//                                     {stagedFile ? "Change File" : "Re-upload"}
//                                   </button>
//                                 </>
//                               )}
//                             </div>
//                           </div>

//                           {/* Staged replacement preview */}
//                           {sub.status === "rejected" && stagedFile && (
//                             <div className="pt-2 border-t border-orange-200/80 flex items-center justify-between gap-2 bg-orange-100/60 px-3 py-1.5 rounded-lg">
//                               <div className="flex items-center gap-2 min-w-0">
//                                 <span className="text-[10px] font-bold uppercase tracking-wider text-orange-700 bg-orange-200 px-1.5 py-0.5 rounded">
//                                   Staged
//                                 </span>
//                                 <p className="text-xs font-semibold text-orange-900 truncate max-w-[200px] sm:max-w-[320px]">
//                                   {stagedFile.name}
//                                 </p>
//                                 <span className="text-[10px] text-orange-600 font-normal">
//                                   ({(stagedFile.size / (1024 * 1024)).toFixed(2)} MB)
//                                 </span>
//                               </div>
//                               <button
//                                 type="button"
//                                 onClick={() => {
//                                   setReuploadFile((prev) => {
//                                     const n = { ...prev };
//                                     delete n[img.image_id];
//                                     return n;
//                                   });
//                                   if (reuploadRefs.current[img.image_id]) {
//                                     reuploadRefs.current[img.image_id].value = "";
//                                   }
//                                 }}
//                                 className="p-1 text-orange-500 hover:text-red-600 hover:bg-orange-200 rounded transition-colors"
//                                 title="Remove selection"
//                               >
//                                 <X className="w-3.5 h-3.5" />
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       );
//                     })}

//                     {/* Batch re-upload submit bar */}
//                     {sub.status === "rejected" && (() => {
//                       const reuploadedCount = sub.images.filter((img) => !!reuploadFile[img.image_id]).length;
//                       return (
//                         <div className="mt-4 bg-orange-50 border border-orange-200 rounded-xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 shadow-sm">
//                           <div>
//                             <p className="text-xs font-bold text-orange-900">
//                               Re-upload Replacement Images
//                             </p>
//                             <p className="text-xs text-orange-700 mt-0.5">
//                               {reuploadedCount} of {sub.images.length} image{sub.images.length > 1 ? "s" : ""} selected for replacement
//                             </p>
//                           </div>
//                           <button
//                             type="button"
//                             onClick={() => handleReuploadAll(sub)}
//                             disabled={reuploadedCount === 0 || reuploadSubmitting}
//                             className="inline-flex items-center gap-2 px-5 py-2.5 bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white text-xs sm:text-sm font-bold rounded-xl transition-all shadow-sm shrink-0 cursor-pointer disabled:cursor-not-allowed"
//                           >
//                             {reuploadSubmitting ? (
//                               <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                             ) : (
//                               <Upload className="w-4 h-4" />
//                             )}
//                             {reuploadSubmitting
//                               ? "Submitting All Re-uploads..."
//                               : `Confirm & Submit Re-uploads (${reuploadedCount})`}
//                           </button>
//                         </div>
//                       );
//                     })()}
//                   </div>
//                 )}

//                 {/* Download certificate */}
//                 {sub.status === "approved" && (
//                   <div className="pt-1">
//                     <button
//                       onClick={() => setCertModal(sub.submission_id)}
//                       disabled={downloadLoadingId === sub.submission_id}
//                       className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white text-sm font-semibold rounded-xl transition-colors"
//                     >
//                       {downloadLoadingId === sub.submission_id ? (
//                         <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                       ) : (
//                         <Trophy className="w-4 h-4" />
//                       )}
//                       {downloadLoadingId === sub.submission_id ? "Downloading..." : "Download Certificate"}
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}



//       {/* Certificate Select Modal */}
//       {certModal && (
//         <div
//           className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
//           style={{ zIndex: 60002 }}
//           onClick={() => setCertModal(null)}
//         >
//           <div
//             className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="flex items-start justify-between mb-6">
//               <div className="flex items-center gap-4">
//                 <div className="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-xl flex items-center justify-center">
//                   <FileText className="w-6 h-6" /> 
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-gray-900 text-xl">Download Certificate</h3>
//                   <p className="text-sm text-gray-500 mt-1">Please select the certificate type you want to download.</p>
//                 </div>
//               </div>
//               <button 
//                 onClick={() => setCertModal(null)}
//                 className="text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition-colors flex items-center justify-center"
//               >
//                 <X className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               {/* Institute Certificate */}
//               <div className="border border-emerald-100 bg-emerald-50/30 rounded-2xl p-6 flex flex-col items-center text-center">
//                 <div className="w-14 h-14 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4">
//                   <span className="text-2xl" style={{ lineHeight: 1 }}>🏦</span>
//                 </div>
//                 <h4 className="font-bold text-gray-900 mb-2">Institute Certificate</h4>
//                 <p className="text-sm text-gray-500 mb-6 flex-grow">Download the certificate issued by the institute.</p>
//                 <button
//                   onClick={() => handleCertSelect("institute")}
//                   disabled={!!downloadLoadingId}
//                   className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-xl transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
//                 >
//                   <Trophy className="w-4 h-4" />
//                   Download Institute Certificate
//                 </button>
//               </div>

//               {/* Educator Certificate */}
//               <div className="border border-blue-100 bg-blue-50/30 rounded-2xl p-6 flex flex-col items-center text-center">
//                 <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
//                   <span className="text-2xl" style={{ lineHeight: 1 }}>🎓</span>
//                 </div>
//                 <h4 className="font-bold text-gray-900 mb-2">Educator Certificate</h4>
//                 <p className="text-sm text-gray-500 mb-6 flex-grow">Download the certificate issued by the educator.</p>
//                 <button
//                   onClick={() => handleCertSelect("educator")}
//                   disabled={!!downloadLoadingId}
//                   className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
//                 >
//                   <Trophy className="w-4 h-4" />
//                   Download Educator Certificate
//                 </button>
//               </div>
//             </div>

//             <div className="mt-8 flex justify-end">
//               <button
//                 onClick={() => setCertModal(null)}
//                 className="px-6 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors bg-white shadow-sm"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Confirm modal popup */}
//       {confirmModal && (
//         <div
//           className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
//           style={{ zIndex: 60002 }}
//           onClick={() => setConfirmModal(null)}
//         >
//           <div
//             className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 space-y-4"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div>
//               <h3 className="font-bold text-gray-900 text-lg">{confirmModal.title}</h3>
//               <p className="text-sm text-gray-500 mt-2 leading-relaxed">{confirmModal.message}</p>
//             </div>
//             <div className="flex justify-end gap-3 mt-6">
//               {!confirmModal.isAlert && (
//                 <button
//                   onClick={() => setConfirmModal(null)}
//                   className="px-4 py-2 border border-gray-200 rounded-xl text-sm text-gray-700 hover:bg-gray-50 font-medium transition-colors"
//                 >
//                   Cancel
//                 </button>
//               )}
//               <button
//                 onClick={() => {
//                   if (confirmModal.action) confirmModal.action();
//                   else setConfirmModal(null);
//                 }}
//                 className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-bold rounded-xl transition-colors"
//               >
//                 {confirmModal.confirmText}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Image view modal */}
//       {viewModalData && (
//         <div
//           className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
//           style={{ zIndex: 60000 }}
//           onClick={() => setViewModalData(null)}
//         >
//           <div
//             className="relative bg-white rounded-2xl shadow-2xl overflow-hidden max-w-3xl w-full max-h-[90vh]"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
//               <p className="text-sm font-semibold text-gray-700">Submission Screenshot</p>
//               <button
//                 onClick={() => setViewModalData(null)}
//                 className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors"
//               >
//                 <X className="w-5 h-5" />
//               </button>
//             </div>
//             <div className="overflow-auto p-4 flex items-center justify-center bg-gray-50" style={{ maxHeight: "calc(90vh - 60px)" }}>
//               <img src={viewModalData.url} alt="Submission screenshot" className="max-w-full max-h-full rounded-xl shadow object-contain" />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// const AwardsAccordion = () => {
//   const location = useLocation();
//   const [activeYear, setActiveYear] = useState("2026");
//   const [modalData, setModalData] = useState(null);
//   const [formValues, setFormValues] = useState({});
//   const [formErrors, setFormErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [activeTab, setActiveTab] = useState(location.state?.activeTab || "general");
//   const [isAwardsExpanded, setIsAwardsExpanded] = useState(
//     ["special", "education", "general"].includes(location.state?.activeTab || "general")
//   );
//   const [yearsData, setYearsData] = useState({});
//   const [regStatus, setRegStatus] = useState(0); // Add regStatus state
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [sidebarOpen, setSidebarOpen] = useState(false); // Add sidebar state for mobile
//   const [memStatus, setMemStatus] = useState(null); // mem_status from registration-details API
//   const [regDetails, setRegDetails] = useState(null); // full reg details if reg_status === 1
//   const [regDetailsLoading, setRegDetailsLoading] = useState(true);
//   const [showAward, setShowAward] = useState(0); // Add showAward state
//   const [showPreview, setShowPreview] = useState(false); // Add showPreview state
//   const [showAgendaTabs, setShowAgendaTabs] = useState(false); // show_agenda_tabs from API
//   const [nominationRegStatus, setNominationRegStatus] = useState(0); // registration_status from nomination/status API

//   // RM details
//   const [rmDetails, setRmDetails] = useState({ rm_name: "", rm_email: "", rm_mobile: "" });
//   const [rmLoading, setRmLoading] = useState(true);
// // ── 1 Million Internship Milestone ──
//   const [isEligible, setIsEligible] = useState(false);
//   const [eligibleLoading, setEligibleLoading] = useState(true);
// // Fetch eligibility for the Milestone tab
//   useEffect(() => {
//     const fetchEligibility = async () => {
//       try {
//         setEligibleLoading(true);
//         const accessToken = localStorage.getItem("accessToken");
//         if (!accessToken) return;
//         const res = await api.get(`${BASE_URL}/awards/show_upload`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         });
//         if (res.data) {
//           setIsEligible(res.data.is_eligible === true);
//         }
//       } catch (err) {
//         console.error("Error fetching milestone eligibility:", err);
//       } finally {
//         setEligibleLoading(false);
//       }
//     };
//     fetchEligibility();
//   }, []);

//   useEffect(() => {
//     const fetchRmDetails = async () => {
//       try {
//         setRmLoading(true);
//         const accessToken = localStorage.getItem("accessToken");
//         if (!accessToken) {
//           setRmLoading(false);
//           return;
//         }

//         const res = await api.get(`${BASE_URL}/awards/rm_details`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         });

//         if (res.data && res.data.rm_name) {
//           setRmDetails(res.data);
//         }
//       } catch (err) {
//         console.error("Error fetching RM details:", err);
//       } finally {
//         setRmLoading(false);
//       }
//     };
//     fetchRmDetails();
//   }, []);

//   // Fetch nomination registration_status for Education Excellence tab visibility
//   useEffect(() => {
//     const fetchNominationRegStatus = async () => {
//       try {
//         const accessToken = localStorage.getItem("accessToken");
//         if (!accessToken) return;

//         const response = await api.get(`${BASE_URL}/internship/nomination/status`, {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (response.status === 200 && response.data) {
//           setNominationRegStatus(response.data.registration_status || 0);
//         }
//       } catch (error) {
//         console.error("Error fetching nomination registration status:", error);
//       }
//     };

//     fetchNominationRegStatus();
//   }, []);

//   // New state for institute participation
//   const [participateData, setParticipateData] = useState(null);
//   const [participateLoading, setParticipateLoading] = useState(false);

//   const itemsPerPage = 5;

//   // Fetch registration details from /registration-details API
//   useEffect(() => {
//     const fetchRegDetails = async () => {
//       try {
//         setRegDetailsLoading(true);
//         const accessToken = localStorage.getItem("accessToken");
//         if (!accessToken) return;

//         const res = await api.get(`${BASE_URL}/admin/registration-details`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         });

//         let { mem_status, registration_status, data, show_award, show_agenda_tabs } = res.data;

//         setMemStatus(mem_status ?? null);
//         setRegStatus(registration_status || 0);
//         setShowAward(show_award || 0);
//         setShowAgendaTabs(show_agenda_tabs === true);
//         if (registration_status === 1 && data) {
//           setRegDetails(data);
//         }
//       } catch (err) {
//         console.error("Error fetching registration details:", err);
//       } finally {
//         setRegDetailsLoading(false);
//       }
//     };
//     fetchRegDetails();
//   }, []);

//   // Fetch institute participation data
//   useEffect(() => {
//     const fetchParticipateData = async () => {
//       try {
//         setParticipateLoading(true);
//         const accessToken = localStorage.getItem("accessToken");
//         if (!accessToken) return;

//         const res = await api.get(`${BASE_URL}/admin/institute-registration-details`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         });

//         if (res.data) {
//           setParticipateData(res.data);
//         }
//       } catch (err) {
//         console.error("Error fetching participate details:", err);
//       } finally {
//         setParticipateLoading(false);
//       }
//     };
//     fetchParticipateData();
//   }, []);

//   // API call to fetch event summary data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         // Get access token from localStorage
//         const accessToken = localStorage.getItem("accessToken");

//         if (!accessToken) {
//           throw new Error("No access token found. Please login again.");
//         }

//         const response = await api.get(`${BASE_URL}/internship/event/summary`, {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         });

//         // Extract registration_status and years data
//         const { reg_status, registration_status, ...years } = response.data;
//         setYearsData(years);
//       } catch (err) {
//         console.error("Error fetching data:", err);

//         // Handle axios specific errors
//         if (err.response) {
//           if (err.response.status === 401) {
//             setError("Unauthorized. Please login again.");
//           } else {
//             setError(
//               `Server error: ${err.response.status} - ${err.response.data?.message || "Unknown error"
//               }`
//             );
//           }
//         } else if (err.request) {
//           setError("Network error. Please check your internet connection.");
//         } else {
//           setError(err.message);
//         }

//         // Fallback to empty data structure
//         setYearsData({});
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const toggleYear = (year) => {
//     setActiveYear(activeYear === year ? null : year);
//     // Reset tab to general when opening any year
//     setActiveTab("general");
//     // Close sidebar on mobile when changing year
//     setSidebarOpen(false);
//   };

//   const openModal = (type, data, year) => {
//     setModalData({ type, data, year });
//     setCurrentPage(1);
//     if (type === "apply_form") {
//       setFormValues({});
//       setFormErrors({});
//       setShowPreview(false);
//     }
//   };

//   const closeModal = () => {
//     setModalData(null);
//     setCurrentPage(1);
//     setFormValues({});
//     setFormErrors({});
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   // --- Form Handlers ---
//   const handleInputChange = (questionId, value) => {
//     setFormValues(prev => ({ ...prev, [questionId]: value }));
//     if (formErrors[questionId]) {
//       setFormErrors(prev => ({ ...prev, [questionId]: null }));
//     }
//   };

//   const handleCheckboxChange = (questionId, optionValue) => {
//     setFormValues(prev => {
//       const currentSelected = prev[questionId] || [];
//       let newSelected;
//       if (currentSelected.includes(optionValue)) {
//         newSelected = currentSelected.filter(val => val !== optionValue);
//       } else {
//         newSelected = [...currentSelected, optionValue];
//       }
//       return { ...prev, [questionId]: newSelected };
//     });
//     if (formErrors[questionId]) {
//       setFormErrors(prev => ({ ...prev, [questionId]: null }));
//     }
//   };

//   const handleFileChange = (questionId, e, validation) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     // Extension validation
//     if (validation?.allowed_extensions) {
//       const allowedExts = validation.allowed_extensions
//         .split(',')
//         .map(ext => ext.trim().toLowerCase())
//         .filter(Boolean);
//       const fileExt = file.name.split('.').pop().toLowerCase();
//       if (allowedExts.length > 0 && !allowedExts.includes(fileExt)) {
//         setFormErrors(prev => ({
//           ...prev,
//           [questionId]: `Invalid file type. Allowed: ${allowedExts.map(e => e.toUpperCase()).join(', ')}`
//         }));
//         e.target.value = ''; // reset input
//         return;
//       }
//     }

//     // File size validation
//     if (validation?.max_file_size_mb) {
//       const sizeInMb = file.size / (1024 * 1024);
//       if (sizeInMb > validation.max_file_size_mb) {
//         setFormErrors(prev => ({ ...prev, [questionId]: `File size must be less than ${validation.max_file_size_mb}MB` }));
//         e.target.value = ''; // reset input
//         return;
//       }
//     }

//     setFormValues(prev => ({ ...prev, [questionId]: file }));
//     if (formErrors[questionId]) {
//       setFormErrors(prev => ({ ...prev, [questionId]: null }));
//     }
//   };

//   const handlePreviewClick = () => {
//     if (!modalData || modalData.type !== "apply_form") return;
//     const { data, year } = modalData;
//     let errors = {};
//     let isValid = true;

//     data.questions?.forEach(q => {
//       const val = formValues[q.id];
      
//       // Required check
//       if (q.is_required) {
//         if (q.question_type === 'boolean') {
//            if (val !== true && val !== false) {
//               errors[q.id] = "Please select Yes or No.";
//               isValid = false;
//               return;
//            }
//         } else if (val === undefined || val === null || val === "" || (Array.isArray(val) && val.length === 0)) {
//           errors[q.id] = "This field is required.";
//           isValid = false;
//           return;
//         }
//       }

//       // Validation check
//       if (val !== undefined && val !== null && val !== "") {
//          if (q.question_type === 'text' || q.question_type === 'textarea') {
//             if (q.validation?.min_length && val.length < q.validation.min_length) {
//                errors[q.id] = `Minimum length is ${q.validation.min_length} characters.`;
//                isValid = false;
//             }
//             if (q.validation?.max_length && val.length > q.validation.max_length) {
//                errors[q.id] = `Maximum length is ${q.validation.max_length} characters.`;
//                isValid = false;
//             }
//          }
//          if (q.question_type === 'number' || q.question_type === 'numeric') {
//             const numVal = Number(val);
//             if (q.validation?.min_value !== null && numVal < q.validation.min_value) {
//                errors[q.id] = `Minimum value is ${q.validation.min_value}.`;
//                isValid = false;
//             }
//             if (q.validation?.max_value !== null && numVal > q.validation.max_value) {
//                errors[q.id] = `Maximum value is ${q.validation.max_value}.`;
//                isValid = false;
//             }
//          }
//       }
//     });

//     if (!isValid) {
//       setFormErrors(errors);
//       setTimeout(() => {
//         const firstErrorId = Object.keys(errors)[0];
//         if (firstErrorId) {
//           const errorElement = document.getElementById(`question-container-${firstErrorId}`);
//           if (errorElement) {
//             errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
//           }
//         }
//       }, 100);
//       return;
//     }

//     setShowPreview(true);
    
//     // Scroll to top of modal when showing preview
//     setTimeout(() => {
//       const container = document.getElementById("modal-scroll-container");
//       if (container) {
//         container.scrollTo({ top: 0, behavior: "smooth" });
//       }
//     }, 50);
//   };

//   const handleFormSubmit = async () => {
//     if (!modalData || modalData.type !== "apply_form") return;
//     const { data, year } = modalData;

//     setIsSubmitting(true);
//     try {
//       const answersList = [];
      
//       // Upload files to S3 first
//       for (const q of (data.questions || [])) {
//         const val = formValues[q.id];
        
//         if (q.question_type === 'file' || q.question_type === 'upload') {
//           if (val instanceof File) {
//             // Upload directly to S3 using the presigned URL
//             if (!q.upload_url || !q.s3_key || !q.file_url_base) {
//               throw new Error(`Presigned URL information is missing for question: ${q.question_text}`);
//             }
            
//             // Using standard fetch for S3 upload to avoid interceptors in the api instance
//             const uploadRes = await fetch(q.upload_url, {
//               method: "PUT",
//               body: val,
//               headers: {
//                 "Content-Type": val.type
//               }
//             });
            
//             if (!uploadRes.ok) {
//               throw new Error(`Failed to upload file ${val.name} to S3.`);
//             }
            
//             answersList.push({
//               question_id: q.id,
//               file_name: val.name,
//               file_path: `${q.file_url_base}/${q.s3_key}`,
//               file_size_bytes: val.size
//             });
//           }
//         } else {
//            if (val !== undefined && val !== null && val !== "") {
//                let answerStr = val;
//                if (Array.isArray(val)) {
//                    answerStr = val.join(',');
//                } else if (typeof val === 'boolean') {
//                    answerStr = val ? 'Yes' : 'No';
//                }
//                answersList.push({ question_id: q.id, answer: String(answerStr) });
//            }
//         }
//       }

//       const formData = new FormData();
//       formData.append("award_id", data.award_id);
//       formData.append("answers_json", JSON.stringify(answersList));

//       const accessToken = localStorage.getItem("accessToken");
//       const res = await api.post(`${BASE_URL}/awards/nominations/create`, formData, {
//         headers: { 
//            Authorization: `Bearer ${accessToken}`
//         }
//       });
      
//       if (res.data) {
//          openModal("success", { message: res.data.message || "Nomination submitted successfully!" }, year);
//       }
//     } catch (err) {
//       console.error("Submission error:", err);
//       const errorMsg = err.response?.data?.detail || err.message || "Failed to submit nomination. Please try again.";
//       openModal("error", { message: errorMsg }, year);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const parseOptions = (optionsStr, optionKeysStr) => {
//     if (!optionsStr) return [];
//     const opts = optionsStr.split(',').map(s => s.trim());
//     const keys = optionKeysStr ? optionKeysStr.split(',').map(s => s.trim()) : opts;
//     return opts.map((opt, index) => ({
//       label: opt,
//       value: keys[index] !== undefined ? keys[index] : opt
//     }));
//   };

//   // Close sidebar when tab changes on mobile
//   const handleTabChange = (tabId) => {
//     setActiveTab(tabId);
//     setSidebarOpen(false);
//   };

//   // Coming Soon component
//   const ComingSoon = ({ title }) => {
//     return (
//       <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
//         <div className="text-center">
//           <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
//             <span className="text-2xl">🚀</span>
//           </div>
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">{title}</h3>
//           <p className="text-gray-500 text-sm">
//             This section is coming soon. Stay tuned for updates!
//           </p>
//         </div>
//       </div>
//     );
//   };

//   // Compact Stats Card Component
//   const StatsCard = ({
//     icon,
//     label,
//     value,
//     color,
//     onClick,
//     clickable = false,
//   }) => {
//     const colorClasses = {
//       blue: "bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100",
//       yellow: "bg-amber-50 border-amber-200 text-amber-700 hover:bg-amber-100",
//       green:
//         "bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100",
//       gray: "bg-gray-50 border-gray-200 text-gray-700",
//     };

//     const iconClasses = {
//       blue: "bg-blue-500 text-white",
//       yellow: "bg-amber-500 text-white",
//       green: "bg-emerald-500 text-white",
//       gray: "bg-gray-500 text-white",
//     };

//     const Component = clickable ? "button" : "div";

//     return (
//       <Component
//         onClick={clickable ? onClick : undefined}
//         className={`
//           ${colorClasses[color]} 
//           ${clickable ? "cursor-pointer transform hover:scale-105" : ""}
//           rounded-xl border p-4 transition-all duration-200 shadow-sm
//         `}
//       >
//         <div className="flex items-center space-x-3">
//           <div className={`p-2 rounded-lg ${iconClasses[color]}`}>{icon}</div>
//           <div className="text-left">
//             <p className="text-xs font-medium opacity-75 uppercase tracking-wide">
//               {label}
//             </p>
//             <p className="text-xl font-bold">{value}</p>
//           </div>
//         </div>
//       </Component>
//     );
//   };

//   // AwardsTab is extracted outside

//   // Registration Tab Component with conditional UI based on mem_status & reg_status
//   const RegistrationTab = ({ data, year }) => {
//     // Loading state for registration details
//     if (regDetailsLoading) {
//       return (
//         <div className="flex items-center justify-center py-20">
//           <div className="text-center">
//             <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin mx-auto mb-4"></div>
//             <p className="text-gray-500 text-sm">Loading registration info...</p>
//           </div>
//         </div>
//       );
//     }

//     // Case 1: mem_status is 0 or 1 → Registration not yet open
//     if (memStatus === 0 || memStatus === 1) {
//       return (
//         <div className="flex items-center justify-center py-12">
//           <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center max-w-sm w-full">
//             <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
//               <span style={{ fontSize: 48 }}>📅</span>
//             </div>
//             {/* <h3 className="text-xl font-bold text-gray-800 mb-2">Registration opens on 1st July</h3> */}
//             <h3 className="text-xl font-bold text-gray-800 mb-2">
//               Registration Opening Soon
//             </h3>
//             {/* <p className="text-gray-500 text-sm mb-6">Please check back on 1st July to complete your registration.</p> */}
//             {/* <button
//               onClick={() => window.location.reload()}
//               className="px-8 py-2.5 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold transition-colors"
//             >
//               Refresh
//             </button> */}
//           </div>
//         </div>
//       );
//     }

//     // Case 2: mem_status is 2 and reg_status is 0 → Not yet registered
//     if (memStatus === 2 && regStatus === 0) {
//       return (
//         <div className="flex items-center justify-center py-12">
//           <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center max-w-sm w-full">
//             <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
//               <span style={{ fontSize: 48 }}>🎟️</span>
//             </div>
//             <h3 className="text-xl font-bold text-gray-800 mb-2">Register for Connect 2026</h3>
//             <p className="text-gray-500 text-sm mb-6">You're eligible to register! Click below to explore and register yourself for the event.</p>
//             <a
//               href="https://connect.eduskillsfoundation.org"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-block px-8 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl font-semibold transition-colors"
//             >
//               Register Now
//             </a>
//           </div>
//         </div>
//       );
//     }

//     // Case 3: reg_status is 1 → Already registered — show their registration details
//     if (regStatus === 1 && regDetails) {
//       const mealDays = regDetails.meal_days || {};
//       return (
//         <div className="space-y-5">
//           {/* Registration confirmed banner */}
//           <div className="flex items-center gap-3 bg-emerald-50 border border-emerald-200 rounded-xl px-5 py-3">
//             <span className="text-2xl">✅</span>
//             <div>
//               <p className="font-semibold text-emerald-700 text-sm">Registration Confirmed</p>
//               <p className="text-emerald-600 text-xs">You are registered for Connect 2026</p>
//             </div>
//           </div>

//           {/* Details grid */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Member Type</p>
//               <p className="font-semibold text-gray-800 capitalize">{regDetails.mem_type || "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Package</p>
//               <p className="font-semibold text-gray-800">{regDetails.package_name || "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Total Days</p>
//               <p className="font-semibold text-gray-800">{regDetails.total_days || "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Start Date</p>
//               <p className="font-semibold text-gray-800">{regDetails.start_date ? new Date(regDetails.start_date).toLocaleDateString() : "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">End Date</p>
//               <p className="font-semibold text-gray-800">{regDetails.end_date ? new Date(regDetails.end_date).toLocaleDateString() : "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Check-in Date</p>
//               <p className="font-semibold text-gray-800">{regDetails.checkin_date ? new Date(regDetails.checkin_date).toLocaleDateString() : "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Check-out Date</p>
//               <p className="font-semibold text-gray-800">{regDetails.checkout_date ? new Date(regDetails.checkout_date).toLocaleDateString() : "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Mode of Travel</p>
//               <p className="font-semibold text-gray-800 capitalize">{regDetails.mode_of_travel ? regDetails.mode_of_travel.replace(/_/g, ' ') : "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Cuisine</p>
//               <p className="font-semibold text-gray-800 capitalize">{regDetails.cuisine ? regDetails.cuisine.replace(/_/g, ' ') : "—"}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Alcohol Pref.</p>
//               <p className="font-semibold text-gray-800 capitalize">{regDetails.alcohol_preference ? regDetails.alcohol_preference.replace(/_/g, ' ') : "—"}</p>
//             </div>
//           </div>

//           {/* Meal preferences per day */}
//           {Object.keys(mealDays).length > 0 && (
//             <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//               <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-3">Meal Preferences</p>
//               <div className="flex flex-wrap gap-2">
//                 {Object.entries(mealDays).map(([day, meal]) => (
//                   <span
//                     key={day}
//                     className={`px-3 py-1 rounded-full text-xs font-semibold ${meal === "veg"
//                       ? "bg-green-100 text-green-700"
//                       : "bg-amber-100 text-amber-700"
//                       }`}
//                   >
//                     Day {day}: {meal === "veg" ? "🥦 Veg" : "🍗 Non-Veg"}
//                   </span>
//                 ))}
//               </div>
//             </div>
//           )}


//         </div>
//       );
//     }

//     // Default fallback — show attendees count
//     return (
//       <div className="space-y-6">
//         <div className="grid grid-cols-1 gap-4">
//           <StatsCard
//             icon={<Users className="w-4 h-4" />}
//             label="Attendees"
//             value={data.attendees?.length || 0}
//             color="blue"
//             onClick={() => openModal("attendees", data.attendees || [], year)}
//             clickable={true}
//           />
//         </div>
//       </div>
//     );
//   };

//   // Dynamic tabs based on regStatus and showAward
//   const getAvailableTabs = () => {
//     const baseTabs = [
//       { id: "awards-parent", label: "Awards Category", icon: Trophy, color: "blue", isParent: true }
//     ];

//     baseTabs.push(
//       { id: "general", label: "Connect 2026 Awards", icon: Trophy, color: "blue", parentId: "awards-parent" }
//     );

//     baseTabs.push(
//       { id: "education", label: "Education Excellence", icon: Trophy, color: "blue", parentId: "awards-parent" }
//     );

//     if (showAward === 1) {
//       baseTabs.push({ id: "special", label: "Special Category Award", icon: Trophy, color: "blue", parentId: "awards-parent" });
//     }

//     // if (isEligible) {
//     //   baseTabs.push({ id: "milestone", label: "1 Million Internship Milestone", icon: Sparkles, color: "indigo" });
//     // }
//       if (showAgendaTabs) {
//       baseTabs.push(
//         { id: "venue", label: "Venue & Accommodation", icon: MapPin, color: "blue" },
//         { id: "agenda", label: "Agenda", icon: Calendar, color: "blue" },
//         // { id: "attending", label: "Attending", icon: Users, color: "blue" },
//         // { id: "photos", label: "Event Photos", icon: Users, color: "blue" },
//         { id: "participate", label: "Participating", icon: Users, color: "blue" },
//         // { id: "feedback", label: "Feedback", icon: Star, color: "blue" }
//       );
//     }

//     return baseTabs;
//   };

//   const tabs = getAvailableTabs();

//   const renderTabContent = (data, year) => {
//     switch (activeTab) {
//       case "registration":
//         return <RegistrationTab data={data} year={year} />;
//       case "participate":
//         return <ParticipateTab participateLoading={participateLoading} participateData={participateData} />;
//       case "special":
//       case "education":
//       case "general":
//         return <AwardsTab data={data} year={year} openModal={openModal} showAward={showAward} activeSubCategory={activeTab} rmDetails={rmDetails} rmLoading={rmLoading} />;
//       case "winners":
//         return <AwardsByCategory data={data} year={year} />;

//       case "venue":
//         return showAgendaTabs ? (
//           <EastBourneResortMap />
//         ) : (
//           <RegistrationTab data={data} year={year} />
//         );
//       case "agenda":
//         return showAgendaTabs ? (
//           <EnhancedMinimalistAgenda />
//         ) : (
//           <RegistrationTab data={data} year={year} />
//         );
//       // case "attending":
//       //   return showAgendaTabs ? (
//       //     <ConferenceTicketGenerator />
//       //   ) : (
//       //     <RegistrationTab data={data} year={year} />
//       //   );
//       case "photos":
//         return regStatus === 1 ? (
//           <ComingSoon title="Event Photos" />
//         ) : (
//           <RegistrationTab data={data} year={year} />
//         );
//       // case "feedback":
//       //   return <EventFeedbackForm />;
//         // case "milestone":
//         // return <MilestoneTab />;
//       default:
//         return <AwardsTab data={data} year={year} openModal={openModal} showAward={showAward} />;
//     }
//   };

//   // Reset active tab if it's not available anymore
//   useEffect(() => {
//     const availableTabIds = tabs.map((tab) => tab.id);
//     if (!availableTabIds.includes(activeTab)) {
//       setActiveTab("general");
//     }
//   }, [regStatus, tabs, activeTab]);

//   const renderModalContent = () => {
//     if (!modalData) return null;

//     const { type, data, year } = modalData;
//     const yearData = yearsData[year];
//     const instituteNominatedCategories =
//       yearData?.instituteNominatedCategories || [];
//     const instituteWinnerCategories = yearData?.instituteWinnerCategories || [];

//     return (
//       <div
//         className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
//         style={{ zIndex: 50000 }}
//       >
//         <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-hidden shadow-2xl border border-gray-200">
//           <div className={`flex items-center justify-between p-6 border-b ${(type === "apply_form" || type === "view_nomination") ? "bg-blue-500 border-blue-600 shadow-sm" : "border-gray-100 bg-gray-50/50"}`}>
//             <div>
//               <h2 className={`text-xl font-bold ${(type === "apply_form" || type === "view_nomination") ? "text-white" : "text-gray-800"}`}>
//                 {type === "attendees"
//                   ? "Event Attendees"
//                   : type === "nominated"
//                     ? "Nominated Candidates"
//                     : type === "apply_form"
//                       ? "Apply for Award Nomination"
//                       : type === "view_nomination"
//                         ? "Nomination Submission Details"
//                         : type === "error"
//                           ? "Error"
//                           : type === "success"
//                             ? "Success"
//                             : "Award Winners"}
//               </h2>
//               <p className={`text-sm mt-1 ${(type === "apply_form" || type === "view_nomination") ? "text-blue-50 font-medium" : "text-gray-500"}`}>
//                 {type === "apply_form" ? data.award_name : (type === "error" || type === "success" || type === "view_nomination") ? "" : `${year} • ${data?.length || 0} entries`}
//               </p>
//             </div>
//             <button
//               onClick={closeModal}
//               className={`transition-colors p-2 rounded-lg ${(type === "apply_form" || type === "view_nomination") ? "text-blue-100 hover:text-white hover:bg-blue-600" : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"}`}
//             >
//               <X className="w-5 h-5" />
//             </button>
//           </div>

//           <div
//             id="modal-scroll-container"
//             className="p-6 overflow-y-auto"
//             style={{ maxHeight: "calc(90vh - 140px)" }}
//           >
//             {type === "apply_form" ? (
//               <div>
//                 {!data.is_eligible ? (
//                   <div className="bg-red-50 text-red-700 p-4 rounded-xl border border-red-200">
//                     {/* <h3 className="font-bold mb-2">Not Eligible to Apply hhhhh</h3> */}
//                     <p className="text-sm">{data.reason}</p>
//                   </div>
//                 ) : (
//                   <div className="space-y-6">
                    
//                     <div className="space-y-4">
//                       <h3 className="text-lg font-bold text-blue-700 border-b pb-2">{showPreview ? "Preview Nomination" : "Nomination Form"}</h3>
//                       {showPreview ? (
//                         <div className="space-y-4">
//                           {data.questions?.map((q, idx) => {
//                             const val = formValues[q.id];
//                             let displayVal = val;
//                             if (q.question_type === 'file' || q.question_type === 'upload') {
//                                displayVal = val ? (val.name || (typeof val === 'string' ? val.split('/').pop() : 'Uploaded File')) : "No file chosen";
//                             } else if (q.question_type === 'boolean') {
//                                displayVal = val === true ? "Yes" : (val === false ? "No" : "");
//                             } else if (Array.isArray(val)) {
//                                displayVal = val.join(', ');
//                             } else if (q.question_type === 'select' || q.question_type === 'dropdown' || q.question_type === 'radio') {
//                                const options = parseOptions(q.options, q.option_keys);
//                                const selectedOpt = options.find(o => String(o.value) === String(val));
//                                displayVal = selectedOpt ? selectedOpt.label : val;
//                             }
//                             return (
//                                <div key={q.id} className="py-4 border-b border-gray-100 last:border-0">
//                                   <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-1">Question {idx + 1}</p>
//                                   <p className="font-medium text-gray-800 mb-2">{q.question_text}</p>
//                                   <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mt-1">
//                                     {((q.question_type === 'file' || q.question_type === 'upload') && val) ? (
//                                       <button 
//                                         type="button"
//                                         onClick={() => {
//                                           if (val instanceof File) {
//                                             window.open(URL.createObjectURL(val), '_blank');
//                                           } else if (typeof val === 'string') {
//                                             window.open(val, '_blank');
//                                           }
//                                         }}
//                                         className="px-4 py-2 bg-blue-50 text-blue-600 rounded-md text-sm font-semibold hover:bg-blue-100 transition-colors flex items-center gap-2 shrink-0 self-start w-fit"
//                                       >
//                                         <Eye className="w-4 h-4" />
//                                         Preview Document
//                                       </button>
//                                     ) : (
//                                       <p className="text-base text-gray-900 font-semibold break-all leading-tight">
//                                         {displayVal || <span className="text-gray-400 font-normal italic">No answer provided</span>}
//                                       </p>
//                                     )}
//                                   </div>
//                                </div>
//                             );
//                           })}
//                         </div>
//                       ) : data.questions?.length > 0 ? (
//                         data.questions.map((q, idx) => {
//                           const options = parseOptions(q.options, q.option_keys);
//                           const value = formValues[q.id];
//                           const error = formErrors[q.id];
//                           const inputClass = `w-full border ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-amber-500'} rounded-lg p-2.5 text-sm shadow-sm focus:outline-none focus:ring-2 transition-shadow`;

//                           return (
//                             <div key={q.id} id={`question-container-${q.id}`} className="bg-gray-50 p-4 rounded-xl border border-gray-100 shadow-sm">
//                               <p className="font-medium text-gray-800">
//                                 {idx + 1}. {q.question_text} {q.is_required && <span className="text-red-500">*</span>}
//                               </p>
//                               {q.helper_text && <p className="text-xs text-gray-500 mt-1">{q.helper_text}</p>}
//                               <div className="mt-3">
//                                 {q.question_type === 'text' || q.question_type === 'number' || q.question_type === 'numeric' || q.question_type === 'url' ? (
//                                   <input 
//                                     type={q.question_type === 'number' || q.question_type === 'numeric' ? 'number' : 'text'} 
//                                     className={inputClass} 
//                                     placeholder="Your answer..." 
//                                     value={value !== undefined ? value : ''}
//                                     onChange={(e) => handleInputChange(q.id, e.target.value)}
//                                     onWheel={(e) => e.target.blur()}
//                                   />
//                                 ) : q.question_type === 'date' ? (
//                                   <input 
//                                     type="date"
//                                     className={inputClass} 
//                                     value={value || ''}
//                                     onChange={(e) => handleInputChange(q.id, e.target.value)}
//                                   />
//                                 ) : q.question_type === 'boolean' ? (
//                                   <div className="flex items-center space-x-6 mt-2">
//                                     <label className="flex items-center space-x-3 cursor-pointer">
//                                       <input 
//                                         type="radio"
//                                         name={`question_${q.id}`}
//                                         checked={value === true}
//                                         onChange={() => handleInputChange(q.id, true)}
//                                         className={`w-4 h-4 text-amber-500 focus:ring-amber-500 border-gray-300 ${error ? 'border-red-500' : ''}`}
//                                       />
//                                       <span className="text-sm text-gray-700">Yes</span>
//                                     </label>
//                                     <label className="flex items-center space-x-3 cursor-pointer">
//                                       <input 
//                                         type="radio"
//                                         name={`question_${q.id}`}
//                                         checked={value === false}
//                                         onChange={() => handleInputChange(q.id, false)}
//                                         className={`w-4 h-4 text-amber-500 focus:ring-amber-500 border-gray-300 ${error ? 'border-red-500' : ''}`}
//                                       />
//                                       <span className="text-sm text-gray-700">No</span>
//                                     </label>
//                                   </div>
//                                 ) : q.question_type === 'textarea' ? (
//                                   <textarea 
//                                     className={inputClass} 
//                                     rows="3" 
//                                     placeholder="Your answer..."
//                                     value={value || ''}
//                                     onChange={(e) => handleInputChange(q.id, e.target.value)}
//                                   ></textarea>
//                                 ) : q.question_type === 'select' || q.question_type === 'dropdown' ? (
//                                   <select 
//                                     className={inputClass}
//                                     value={value || ''}
//                                     onChange={(e) => handleInputChange(q.id, e.target.value)}
//                                   >
//                                     <option value="">Select an option...</option>
//                                     {options.map((opt, i) => <option key={i} value={opt.value}>{opt.label}</option>)}
//                                   </select>
//                                 ) : q.question_type === 'radio' ? (
//                                   <div className="space-y-2">
//                                     {options.map((opt, i) => (
//                                        <label key={i} className="flex items-center space-x-3 cursor-pointer">
//                                          <input 
//                                            type="radio" 
//                                            name={`question_${q.id}`} 
//                                            value={opt.value}
//                                            checked={value === opt.value}
//                                            onChange={(e) => handleInputChange(q.id, e.target.value)}
//                                            className="w-4 h-4 text-amber-500 focus:ring-amber-500 border-gray-300"
//                                          />
//                                          <span className="text-sm text-gray-700">{opt.label}</span>
//                                        </label>
//                                     ))}
//                                   </div>
//                                 ) : q.question_type === 'checkbox' ? (
//                                   <div className="space-y-2">
//                                     {options.map((opt, i) => (
//                                        <label key={i} className="flex items-center space-x-3 cursor-pointer">
//                                          <input 
//                                            type="checkbox" 
//                                            value={opt.value}
//                                            checked={(value || []).includes(opt.value)}
//                                            onChange={() => handleCheckboxChange(q.id, opt.value)}
//                                            className="w-4 h-4 text-amber-500 focus:ring-amber-500 rounded border-gray-300"
//                                          />
//                                          <span className="text-sm text-gray-700">{opt.label}</span>
//                                        </label>
//                                     ))}
//                                   </div>
//                                 ) : q.question_type === 'file' || q.question_type === 'upload' ? (
//                                   <div className="mt-2">
//                                     <div 
//                                       className={`relative border-2 border-dashed rounded-xl p-6 transition-all duration-200 ${
//                                         error 
//                                           ? 'border-red-300 bg-red-50 hover:bg-red-100/50' 
//                                           : value 
//                                             ? 'border-emerald-300 bg-emerald-50' 
//                                             : 'border-gray-300 bg-gray-50 hover:bg-gray-100'
//                                       }`}
//                                     >
//                                       <input 
//                                         key={value ? value.name : 'empty'}
//                                         type="file"
//                                         accept={q.validation?.allowed_extensions
//                                           ? q.validation.allowed_extensions.split(',').map(e => `.${e.trim().toLowerCase()}`).join(',')
//                                           : undefined
//                                         }
//                                         className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" 
//                                         onChange={(e) => handleFileChange(q.id, e, q.validation)}
//                                       />
                                      
//                                       <div className="flex flex-col items-center justify-center text-center space-y-3">
//                                         {value ? (
//                                           <>
//                                             <div className="w-12 h-12 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-1">
//                                               <FileText className="w-6 h-6" />
//                                             </div>
//                                             <div>
//                                               <p className="text-sm font-semibold text-emerald-700">{value.name}</p>
//                                               <p className="text-xs text-emerald-600 mt-1">{(value.size / (1024 * 1024)).toFixed(2)} MB</p>
//                                             </div>
//                                             <div className="flex gap-2 relative z-10 mt-2">
//                                               <button
//                                                 type="button"
//                                                 onClick={(e) => {
//                                                   e.preventDefault();
//                                                   if (value instanceof File) {
//                                                     const url = URL.createObjectURL(value);
//                                                     window.open(url, "_blank");
//                                                   } else if (value && typeof value === 'object' && value.url) {
//                                                     window.open(value.url, "_blank");
//                                                   } else if (typeof value === "string") {
//                                                     window.open(value, "_blank");
//                                                   }
//                                                 }}
//                                                 className="text-xs px-4 py-1.5 bg-white text-blue-600 font-medium hover:bg-blue-50 rounded-lg border border-blue-200 transition-colors shadow-sm"
//                                               >
//                                                 View File
//                                               </button>
//                                               <button
//                                                 type="button"
//                                                 onClick={(e) => {
//                                                   e.preventDefault();
//                                                   handleInputChange(q.id, null);
//                                                 }}
//                                                 className="text-xs px-4 py-1.5 bg-white text-red-600 font-medium hover:bg-red-50 rounded-lg border border-red-200 transition-colors shadow-sm"
//                                               >
//                                                 Remove File
//                                               </button>
//                                             </div>
//                                           </>
//                                         ) : (
//                                           <>
//                                             <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-1 transition-colors ${
//                                               error ? 'bg-red-100 text-red-500' : 'bg-amber-100 text-amber-500'
//                                             }`}>
//                                               <Upload className="w-6 h-6" />
//                                             </div>
//                                             <div>
//                                               <p className="text-sm font-medium text-gray-700">
//                                                 <span className="text-amber-600 font-semibold hover:underline cursor-pointer">Click to upload</span> or drag and drop
//                                               </p>
//                                               <div className="text-xs text-gray-500 mt-2 space-y-1">
//                                                 {q.validation?.allowed_extensions && (
//                                                   <p>Allowed: {q.validation.allowed_extensions.split(',').map(e => e.trim().toUpperCase()).join(', ')}</p>
//                                                 )}
//                                                 {q.validation?.max_file_size_mb && (
//                                                   <p>Maximum file size: {q.validation.max_file_size_mb}MB</p>
//                                                 )}
//                                               </div>
//                                             </div>
//                                           </>
//                                         )}
//                                       </div>
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div className="text-sm text-gray-400 italic">Input type: {q.question_type}</div>
//                                 )}
//                               </div>
//                               {error && <p className="text-red-500 text-xs mt-2 font-medium bg-red-50 p-2 rounded inline-block">{error}</p>}
//                             </div>
//                           );
//                         })
//                       ) : (
//                         <div className="bg-white rounded-2xl shadow-sm p-12 mt-2 text-center border border-gray-100 flex flex-col items-center justify-center">
//                           <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4 border border-gray-100 shadow-sm">
//                             <Trophy className="w-8 h-8 text-gray-300" />
//                           </div>
//                           <h3 className="text-xl font-bold mb-2 text-gray-700">Application Not Available</h3>
//                           <p className="text-gray-500 max-w-md mx-auto text-sm leading-relaxed">
//                             The application questions for this award have not been configured yet. Please check back later or contact the administrator.
//                           </p>
//                         </div>
//                       )}
//                     </div>
                    
//                     {data.questions?.length > 0 && (
//                       <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-100">
//                         {showPreview ? (
//                            <>
//                              <button onClick={() => setShowPreview(false)} disabled={isSubmitting} className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium transition-colors disabled:opacity-50">Edit</button>
//                              <button onClick={handleFormSubmit} disabled={isSubmitting} className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-bold transition-colors flex items-center gap-2 disabled:opacity-70">
//                                {isSubmitting && <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>}
//                                Confirm & Submit
//                              </button>
//                            </>
//                         ) : (
//                            <>
//                              <button onClick={closeModal} className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium transition-colors">Cancel</button>
//                              <button onClick={handlePreviewClick} className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-bold transition-colors">Save & Preview</button>
//                            </>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             ) : type === "view_nomination" ? (
//               <div className="space-y-6">
//                 <div className="space-y-4">
//                   <h3 className="text-lg font-bold text-gray-800 border-b pb-2">{data.award_name}</h3>
//                   <div className="space-y-4">
//                     {data.answers?.map((ans, idx) => (
//                       <div key={ans.id} className="py-4 border-b border-gray-100 last:border-0">
//                          <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-1">Question {idx + 1}</p>
//                          <p className="font-medium text-gray-800 mb-2">{ans.question_text}</p>
//                          <p className="text-base text-gray-900 font-semibold break-words">
//                            {ans.answer || (ans.file_name ? (
//                               <div className="flex items-center gap-3 mt-1">
//                                 <a href={ans.file_path} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 text-sm font-semibold transition-colors border border-blue-100">
//                                   <Eye className="w-4 h-4" /> View Document
//                                 </a>
//                               </div>
//                            ) : <span className="text-gray-400 font-normal italic">No answer provided</span>)}
//                          </p>
//                       </div>
//                     ))}
//                     {(!data.answers || data.answers.length === 0) && (
//                       <p className="text-gray-500 italic">No answers found for this nomination.</p>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ) : type === "error" ? (
//               <div className="flex flex-col items-center justify-center py-10 text-center">
//                 <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-4">
//                   <X className="w-8 h-8" />
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-800 mb-2">Failed to load</h3>
//                 <p className="text-gray-600">{data.message}</p>
//                 <button onClick={closeModal} className="mt-6 px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg font-bold transition-colors">
//                   Close
//                 </button>
//               </div>
//             ) : type === "success" ? (
//               <div className="flex flex-col items-center justify-center py-10 text-center">
//                 <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4 text-3xl">
//                   ✓
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-800 mb-2">Success!</h3>
//                 <p className="text-gray-600">{data.message}</p>
//                 <button onClick={() => { closeModal(); window.location.reload(); }} className="mt-6 px-6 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg font-bold transition-colors">
//                   Done
//                 </button>
//               </div>
//             ) : (
//               <DataTable
//                 data={data}
//                 type={type}
//                 currentPage={currentPage}
//                 itemsPerPage={itemsPerPage}
//                 onPageChange={handlePageChange}
//                 instituteNominatedCategories={instituteNominatedCategories}
//                 instituteWinnerCategories={instituteWinnerCategories}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Mobile Tab Navigation Component
//   const MobileTabNavigation = ({ tabs, activeTab, onTabChange }) => {
//     return (
//       <div className="lg:hidden bg-white border-b border-gray-200 px-4 py-2">
//         <style>{`
//           .scrollbar-hide::-webkit-scrollbar { display: none; }
//           .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
//         `}</style>
//         <div className="flex overflow-x-auto space-x-2 scrollbar-hide">
//           {tabs.map((tab) => {
//             if (tab.isHeader || tab.isParent) return null;
//             if (tab.parentId && !isAwardsExpanded) return null;

//             const IconComponent = tab.icon;
//             const isActive = activeTab === tab.id;

//             const colorClasses = {
//               blue: isActive
//                 ? "bg-blue-100 text-blue-700 border-blue-200"
//                 : "text-gray-900 hover:bg-blue-50 hover:text-blue-600",
//               amber: isActive
//                 ? "bg-amber-100 text-amber-700 border-amber-200"
//                 : "text-gray-900 hover:bg-amber-50 hover:text-amber-600",
//               green: isActive
//                 ? "bg-green-100 text-green-700 border-green-200"
//                 : "text-gray-900 hover:bg-green-50 hover:text-green-600",
//               purple: isActive
//                 ? "bg-purple-100 text-purple-700 border-purple-200"
//                 : "text-gray-900 hover:bg-purple-50 hover:text-purple-600",
//               indigo: isActive
//                 ? "bg-indigo-100 text-indigo-700 border-indigo-200"
//                 : "text-gray-900 hover:bg-indigo-50 hover:text-indigo-600",
//             };

//             return (
//               <button
//                 key={tab.id}
//                 onClick={() => onTabChange(tab.id)}
//                 className={`
//                   flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap border
//                   ${isActive
//                     ? `${colorClasses[tab.color]} shadow-sm`
//                     : `${colorClasses[tab.color]} border-transparent`
//                   }
//                 `}
//               >
//                 {IconComponent && <IconComponent className="w-4 h-4 flex-shrink-0" />}
//                 <span>{tab.label}</span>
//               </button>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   // Error state
//   if (error) {
//     return (
//       <div className="p-4 sm:p-6 max-w-[1500px] mx-auto bg-gray-50 min-h-screen">
//         <div className="bg-white rounded-xl shadow-sm border border-red-200 p-8">
//           <div className="text-center">
//             <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
//               <span className="text-2xl">⚠️</span>
//             </div>
//             <h3 className="text-xl font-semibold text-red-600 mb-2">
//               Error Loading Data
//             </h3>
//             <p className="text-gray-600 mb-6">{error}</p>
//             <button
//               onClick={() => window.location.reload()}
//               className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium"
//             >
//               Try Again
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Loading state
//   if (loading) {
//     return (
//       <div className="p-4 max-w-[1500px] mx-auto min-h-[50vh] flex justify-center items-center">
//         <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* Main Content - Lower z-index */}
//       <div
//         className="p-4 max-w-[1700px] mx-auto min-h-screen relative"
//         style={{ zIndex: 1 }}
//       >
//         {/* Year Accordions */}
//         <div className="space-y-4">
//           {Object.keys(yearsData).length === 0 ? (
//             <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
//               <div className="text-center">
//                 <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
//                   <span className="text-2xl">📊</span>
//                 </div>
//                 <h3 className="text-xl font-semibold text-gray-600 mb-2">
//                   No Data Available
//                 </h3>
//                 <p className="text-gray-500 text-sm">
//                   There are no awards data to display at the moment.
//                 </p>
//               </div>
//             </div>
//           ) : (
//             <div className="flex flex-col">
//               {/* Active Year Content */}
//               {activeYear && yearsData[activeYear] && (
//                 <div className="bg-white rounded-xl shadow-sm border border-gray-100 relative mt-2">
//                   {/* Static Top-Right Year Badge */}
//                   <div className="absolute -top-3.5 right-6 z-20">
//                     <span className="px-4 py-1 text-xs uppercase tracking-widest rounded-full font-bold shadow-md border bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-transparent">
//                       {activeYear}
//                     </span>
//                   </div>
//                   {activeYear === "2026" ? (
//                     // Enhanced Responsive Layout for 2026
//                     <>
//                       {/* Mobile Tab Navigation */}
//                       <MobileTabNavigation
//                         tabs={tabs}
//                         activeTab={activeTab}
//                         onTabChange={handleTabChange}
//                       />

//                       {/* Desktop Sidebar Layout + Mobile Stack Layout */}
//                       <div className="lg:flex lg:h-[85vh] lg:overflow-visible">
//                         {/* Desktop Sidebar Navigation */}
//                         <div className="hidden lg:block w-64 bg-gray-50/50 border-r border-gray-100 p-4 flex-shrink-0 overflow-y-auto">
//                           <div className="space-y-2">
//                             {tabs.map((tab) => {
//                               if (tab.isHeader) {
//                                 return (
//                                   <div key={tab.id} className="pt-4 pb-1 px-4">
//                                     <h3 className="text-xs font-bold text-gray-400 tracking-widest uppercase">{tab.label}</h3>
//                                   </div>
//                                 );
//                               }

//                               if (tab.parentId && !isAwardsExpanded) {
//                                 return null;
//                               }

//                               if (tab.isParent) {
//                                 const IconComponent = tab.icon;
//                                 return (
//                                   <button
//                                     key={tab.id}
//                                     onClick={() => {
//                                       setIsAwardsExpanded(!isAwardsExpanded);
//                                       if (!isAwardsExpanded) {
//                                         setActiveTab("general");
//                                       }
//                                     }}
//                                     className={`
//                                       w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-bold transition-all duration-200
//                                       text-gray-900 hover:bg-gray-50 border border-transparent
//                                     `}
//                                   >
//                                     {IconComponent && <IconComponent className="w-4 h-4 flex-shrink-0" />}
//                                     <span className="text-left flex-1">{tab.label}</span>
//                                     <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isAwardsExpanded ? 'rotate-180' : ''}`} />
//                                   </button>
//                                 );
//                               }

//                               const IconComponent = tab.icon;
//                               const isActive = activeTab === tab.id;
//                               const isSubItem = !!tab.parentId;

//                               const colorClasses = {
//                                 blue: isActive
//                                   ? "bg-blue-100 text-blue-700 border-blue-200"
//                                   : "hover:bg-blue-50 hover:text-blue-600",
//                                 amber: isActive
//                                   ? "bg-amber-100 text-amber-700 border-amber-200"
//                                   : "hover:bg-amber-50 hover:text-amber-600",
//                                 green: isActive
//                                   ? "bg-green-100 text-green-700 border-green-200"
//                                   : "hover:bg-green-50 hover:text-green-600",
//                                 purple: isActive
//                                   ? "bg-purple-100 text-purple-700 border-purple-200"
//                                   : "hover:bg-purple-50 hover:text-purple-600",
//                                 indigo: isActive
//                                   ? "bg-indigo-100 text-indigo-700 border-indigo-200"
//                                   : "hover:bg-indigo-50 hover:text-indigo-600",
//                               };

//                               return (
//                                 <button
//                                   key={tab.id}
//                                   onClick={() => setActiveTab(tab.id)}
//                                   className={`
//                                     w-full flex items-center space-x-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
//                                     ${isSubItem ? 'pl-11' : ''}
//                                     ${isActive
//                                       ? `${colorClasses[tab.color]} border shadow-sm`
//                                       : `text-gray-900 ${colorClasses[tab.color]} border border-transparent`
//                                     }
//                                   `}
//                                 >
//                                   {IconComponent && <IconComponent className="w-4 h-4 flex-shrink-0" />}
//                                   <span className="text-left">{tab.label}</span>
//                                   {isActive && (
//                                     <div className="ml-auto w-1.5 h-1.5 bg-current rounded-full opacity-60"></div>
//                                   )}
//                                 </button>
//                               );
//                             })}
//                           </div>
//                         </div>

//                         {/* Main Content Area - responsive padding */}
//                         <div className="flex-1 p-4 sm:p-6 lg:overflow-y-auto lg:overflow-x-visible min-h-[50vh] lg:min-h-0">
//                           {renderTabContent(yearsData[activeYear], activeYear)}
//                         </div>
//                       </div>
//                     </>
//                   ) : (
//                     // Original Simple Card Layout for other years (no tabs)
//                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-4 sm:p-6 mt-4">
//                       {loading ? (
//                         <div className="col-span-full flex justify-center items-center py-12">
//                           <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
//                         </div>
//                       ) : (
//                         <>
//                           {/* Attendees Card */}
//                           <button
//                             onClick={() => openModal("attendees", yearsData[activeYear].attendees || [], activeYear)}
//                             className="bg-blue-50 rounded-lg shadow-sm p-3 border-l-4 border-blue-500 hover:shadow-md transition-shadow text-left w-full"
//                           >
//                             <div className="flex items-center justify-between">
//                               <div>
//                                 <h3 className="text-xs font-medium text-blue-700 mb-1">Attendees</h3>
//                                 <p className="text-xl font-bold text-blue-600">{yearsData[activeYear].attendees?.length || 0}</p>
//                               </div>
//                               <div className="bg-blue-100 p-1.5 rounded">
//                                 <Users className="w-4 h-4 text-blue-600" />
//                               </div>
//                             </div>
//                           </button>

//                           {/* Nominated Card */}
//                           <button
//                             onClick={() => openModal("nominated", yearsData[activeYear].nominated || [], activeYear)}
//                             className="bg-yellow-50 rounded-lg shadow-sm p-3 border-l-4 border-yellow-500 hover:shadow-md transition-shadow text-left w-full"
//                           >
//                             <div className="flex items-center justify-between">
//                               <div>
//                                 <h3 className="text-xs font-medium text-yellow-700 mb-1">Nominated</h3>
//                                 <p className="text-xl font-bold text-yellow-600">{yearsData[activeYear].nominated?.length || 0}</p>
//                               </div>
//                               <div className="bg-yellow-100 p-1.5 rounded">
//                                 <Star className="w-4 h-4 text-yellow-600" />
//                               </div>
//                             </div>
//                           </button>

//                           {/* Winners Card */}
//                           <button
//                             onClick={() => openModal("winners", yearsData[activeYear].winners || [], activeYear)}
//                             className="bg-green-50 rounded-lg shadow-sm p-3 border-l-4 border-green-500 hover:shadow-md transition-shadow text-left w-full"
//                           >
//                             <div className="flex items-center justify-between">
//                               <div>
//                                 <h3 className="text-xs font-medium text-green-700 mb-1">Winners</h3>
//                                 <p className="text-xl font-bold text-green-600">{yearsData[activeYear].winners?.length || 0}</p>
//                               </div>
//                               <div className="bg-green-100 p-1.5 rounded">
//                                 <Trophy className="w-4 h-4 text-green-600" />
//                               </div>
//                             </div>
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Modal - Highest z-index, rendered outside main content */}
//       {renderModalContent()}
//     </>
//   );
// };

// export default AwardsAccordion;
///.......................................

// 20.09.2026


// import React, { useState, useEffect } from "react";
// import {
//   ChevronDown,
//   Users,
//   Star,
//   Trophy,
//   Calendar,
//   X,
//   MapPin,
//   Menu,
//   Crown,
// } from "lucide-react";
// import DataTable from "./DataTable"; // Import your updated DataTable

// import VoteNowBadge from "../../Layouts/VotingButton";
import VoteNowBadge from "../../Layouts/VotingButton";
import { BASE_URL } from "../../services/configUrls";
// import api from "../../services/api";
// import ConferenceApp from "./ConferenceApp";
// import EastBourneResortMap from "./Venue";
// import EnhancedMinimalistAgenda from "./Agenda";
// import EventFeedbackForm from "../Admin/NominationMarking/EventFeedbackForm";
// import ConferenceTicketGenerator from "../Trainer FDP/Slots/ConferenceTicketGenerator";
// import AwardsByCategory from "./AwardsByCategory";

// // For demo purposes, we'll create mock versions

// // Skeleton components
// const SkeletonCard = () => (
//   <div className="bg-white/60 rounded-xl shadow-sm p-4 border border-gray-100 animate-pulse">
//     <div className="flex items-center space-x-3">
//       <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
//       <div className="flex-1">
//         <div className="h-3 bg-gray-200 rounded mb-2 w-20"></div>
//         <div className="h-5 bg-gray-200 rounded w-12"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonAccordion = () => (
//   <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 animate-pulse">
//     <div className="px-6 py-4 flex items-center justify-between">
//       <div className="flex items-center space-x-4">
//         <div className="bg-gray-200 p-2 rounded-lg w-10 h-10"></div>
//         <div>
//           <div className="h-5 bg-gray-200 rounded w-20 mb-1"></div>
//           <div className="h-3 bg-gray-200 rounded w-32"></div>
//         </div>
//       </div>
//       <div className="w-5 h-5 bg-gray-200 rounded"></div>
//     </div>
//   </div>
// );

// const AwardsAccordion = () => {
//   const [activeYear, setActiveYear] = useState(null);
//   const [modalData, setModalData] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [activeTab, setActiveTab] = useState("registration");
//   const [yearsData, setYearsData] = useState({});
//   const [regStatus, setRegStatus] = useState(0); // Add regStatus state
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [sidebarOpen, setSidebarOpen] = useState(false); // Add sidebar state for mobile
//   const itemsPerPage = 5;

//   // API call to fetch data using axios
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         // Get access token from localStorage
//         const accessToken = localStorage.getItem("accessToken");

//         if (!accessToken) {
//           throw new Error("No access token found. Please login again.");
//         }

//         const response = await api.get(`${BASE_URL}/internship/event/summary`, {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         });

//         // Extract reg_status and years data
//         const { reg_status, ...years } = response.data;
//         setRegStatus(reg_status || 0);
//         setYearsData(years);
//       } catch (err) {
//         console.error("Error fetching data:", err);

//         // Handle axios specific errors
//         if (err.response) {
//           // Server responded with error status
//           if (err.response.status === 401) {
//             setError("Unauthorized. Please login again.");
//           } else {
//             setError(
//               `Server error: ${err.response.status} - ${
//                 err.response.data?.message || "Unknown error"
//               }`
//             );
//           }
//         } else if (err.request) {
//           // Request was made but no response received
//           setError("Network error. Please check your internet connection.");
//         } else {
//           // Something else happened
//           setError(err.message);
//         }

//         // Fallback to empty data structure
//         setYearsData({});
//         setRegStatus(0);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const toggleYear = (year) => {
//     setActiveYear(activeYear === year ? null : year);
//     // Reset tab to registration when opening any year
//     setActiveTab("registration");
//     // Close sidebar on mobile when changing year
//     setSidebarOpen(false);
//   };

//   const openModal = (type, data, year) => {
//     setModalData({ type, data, year });
//     setCurrentPage(1);
//   };

//   const closeModal = () => {
//     setModalData(null);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   // Close sidebar when tab changes on mobile
//   const handleTabChange = (tabId) => {
//     setActiveTab(tabId);
//     setSidebarOpen(false);
//   };

//   // Coming Soon component
//   const ComingSoon = ({ title }) => {
//     return (
//       <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
//         <div className="text-center">
//           <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
//             <span className="text-2xl">🚀</span>
//           </div>
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">{title}</h3>
//           <p className="text-gray-500 text-sm mb-4">
//             This section is coming soon. Stay tuned for updates!
//           </p>
//           <div className="inline-flex items-center px-3 py-1 rounded-full bg-amber-50 border border-amber-200">
//             <div className="w-2 h-2 bg-amber-400 rounded-full animate-pulse mr-2"></div>
//             <span className="text-xs text-amber-700 font-medium">
//               Under Development
//             </span>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Compact Stats Card Component
//   const StatsCard = ({
//     icon,
//     label,
//     value,
//     color,
//     onClick,
//     clickable = false,
//   }) => {
//     const colorClasses = {
//       blue: "bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100",
//       yellow: "bg-amber-50 border-amber-200 text-amber-700 hover:bg-amber-100",
//       green:
//         "bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100",
//       gray: "bg-gray-50 border-gray-200 text-gray-700",
//     };

//     const iconClasses = {
//       blue: "bg-blue-500 text-white",
//       yellow: "bg-amber-500 text-white",
//       green: "bg-emerald-500 text-white",
//       gray: "bg-gray-500 text-white",
//     };

//     const Component = clickable ? "button" : "div";

//     return (
//       <Component
//         onClick={clickable ? onClick : undefined}
//         className={`
//           ${colorClasses[color]} 
//           ${clickable ? "cursor-pointer transform hover:scale-105" : ""}
//           rounded-xl border p-4 transition-all duration-200 shadow-sm
//         `}
//       >
//         <div className="flex items-center space-x-3">
//           <div className={`p-2 rounded-lg ${iconClasses[color]}`}>{icon}</div>
//           <div className="text-left">
//             <p className="text-xs font-medium opacity-75 uppercase tracking-wide">
//               {label}
//             </p>
//             <p className="text-xl font-bold">{value}</p>
//           </div>
//         </div>
//       </Component>
//     );
//   };

//   // Awards Tab Component
//   const AwardsTab = ({ data, year }) => {
//     return (
//       <div className="space-y-6">
//         {/* Quick Stats Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <StatsCard
//             icon={<Star className="w-4 h-4" />}
//             label="Nominated"
//             value={data.nominated?.length || 0}
//             color="yellow"
//             onClick={() => openModal("nominated", data.nominated || [], year)}
//             clickable={true}
//           />
//           <StatsCard
//             icon={<Trophy className="w-4 h-4" />}
//             label="Winners"
//             value={data.winners?.length || 0}
//             color="green"
//             onClick={() => openModal("winners", data.winners || [], year)}
//             clickable={true}
//           />
//         </div>
//       </div>
//     );
//   };

//   // Registration Tab Component with Attendees
//   const RegistrationTab = ({ data, year }) => {
//     return (
//       <div className="space-y-6">
//         {/* Quick Stats */}
//         <div className="grid grid-cols-1 gap-4">
//           <StatsCard
//             icon={<Users className="w-4 h-4" />}
//             label="Attendees"
//             value={data.attendees?.length || 0}
//             color="blue"
//             onClick={() => openModal("attendees", data.attendees || [], year)}
//             clickable={true}
//           />
//         </div>

//         {/* Conference App for 2025 - with proper z-index isolation */}
//         {year === "2025" && (
//           <div className="relative">
//             <ConferenceApp />
//           </div>
//         )}
//       </div>
//     );
//   };

//   // Dynamic tabs based on regStatus
//   const getAvailableTabs = () => {
//     const baseTabs = [
//       { id: "registration", label: "Registration", icon: Users, color: "blue" },
//       { id: "awards", label: "Awards", icon: Trophy, color: "amber" },
//       { id: "winners", label: "Winners", icon: Crown, color: "green" },
//     ];

//     // Add conditional tabs only if regStatus is 1
//     if (regStatus === 1) {
//       baseTabs.push(
//         { id: "venue", label: "Venue", icon: MapPin, color: "green" },
//         { id: "agenda", label: "Agenda", icon: Calendar, color: "green" },
//         { id: "attending", label: "Attending", icon: Users, color: "green" },
//         { id: "photos", label: "Event Photos", icon: Users, color: "green" },
//         { id: "feedback", label: "Feedback", icon: Star, color: "purple" }
//       );
//     }

//     return baseTabs;
//   };

//   const tabs = getAvailableTabs();

//   const renderTabContent = (data, year) => {
//     switch (activeTab) {
//       case "registration":
//         return <RegistrationTab data={data} year={year} />;
//       case "awards":
//         return <AwardsTab data={data} year={year} />;
//       case "winners":
//         return <AwardsByCategory data={data} year={year} />;

//       case "venue":
//         return regStatus === 1 ? (
//           <EastBourneResortMap />
//         ) : (
//           <RegistrationTab data={data} year={year} />
//         );
//       case "agenda":
//         return regStatus === 1 ? (
//           <EnhancedMinimalistAgenda />
//         ) : (
//           <RegistrationTab data={data} year={year} />
//         );
//       case "attending":
//         return regStatus === 1 ? (
//           <ConferenceTicketGenerator />
//         ) : (
//           <RegistrationTab data={data} year={year} />
//         );
//       case "photos":
//         return regStatus === 1 ? (
//           <ComingSoon title="Event Photos" />
//         ) : (
//           <RegistrationTab data={data} year={year} />
//         );
//       case "feedback":
//         return regStatus === 1 ? <EventFeedbackForm /> : <ComingSoon title="Feedback" />;
//       default:
//         return <AwardsTab data={data} year={year} />;
//     }
//   };

//   // Reset active tab if it's not available anymore
//   useEffect(() => {
//     const availableTabIds = tabs.map((tab) => tab.id);
//     if (!availableTabIds.includes(activeTab)) {
//       setActiveTab("registration");
//     }
//   }, [regStatus, tabs, activeTab]);

//   const renderModalContent = () => {
//     if (!modalData) return null;

//     const { type, data, year } = modalData;
//     const yearData = yearsData[year];
//     const instituteNominatedCategories =
//       yearData?.instituteNominatedCategories || [];
//     const instituteWinnerCategories = yearData?.instituteWinnerCategories || [];

//     return (
//       <div
//         className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
//         style={{ zIndex: 50000 }}
//       >
//         <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-hidden shadow-2xl border border-gray-200">
//           <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-gray-50/50">
//             <div>
//               <h2 className="text-xl font-semibold text-gray-800">
//                 {type === "attendees"
//                   ? "Event Attendees"
//                   : type === "nominated"
//                   ? "Nominated Candidates"
//                   : "Award Winners"}
//               </h2>
//               <p className="text-sm text-gray-500 mt-1">
//                 {year} • {data.length} entries
//               </p>
//             </div>
//             <button
//               onClick={closeModal}
//               className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-lg"
//             >
//               <X className="w-5 h-5" />
//             </button>
//           </div>

//           <div
//             className="p-6 overflow-y-auto"
//             style={{ maxHeight: "calc(90vh - 140px)" }}
//           >
//             <DataTable
//               data={data}
//               type={type}
//               currentPage={currentPage}
//               itemsPerPage={itemsPerPage}
//               onPageChange={handlePageChange}
//               instituteNominatedCategories={instituteNominatedCategories}
//               instituteWinnerCategories={instituteWinnerCategories}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Mobile Tab Navigation Component
//   const MobileTabNavigation = ({ tabs, activeTab, onTabChange }) => {
//     return (
//       <div className="lg:hidden bg-white border-b border-gray-200 px-4 py-2">
//         <div className="flex overflow-x-auto space-x-2 scrollbar-hide">
//           {tabs.map((tab) => {
//             const IconComponent = tab.icon;
//             const isActive = activeTab === tab.id;

//             const colorClasses = {
//               blue: isActive
//                 ? "bg-blue-100 text-blue-700 border-blue-200"
//                 : "text-gray-600 hover:bg-blue-50 hover:text-blue-600",
//               amber: isActive
//                 ? "bg-amber-100 text-amber-700 border-amber-200"
//                 : "text-gray-600 hover:bg-amber-50 hover:text-amber-600",
//               green: isActive
//                 ? "bg-green-100 text-green-700 border-green-200"
//                 : "text-gray-600 hover:bg-green-50 hover:text-green-600",
//               purple: isActive
//                 ? "bg-purple-100 text-purple-700 border-purple-200"
//                 : "text-gray-600 hover:bg-purple-50 hover:text-purple-600",
//             };

//             return (
//               <button
//                 key={tab.id}
//                 onClick={() => onTabChange(tab.id)}
//                 className={`
//                   flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap border
//                   ${
//                     isActive
//                       ? `${colorClasses[tab.color]} shadow-sm`
//                       : `${colorClasses[tab.color]} border-transparent`
//                   }
//                 `}
//               >
//                 <IconComponent className="w-4 h-4 flex-shrink-0" />
//                 <span>{tab.label}</span>
//               </button>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   // Error state
//   if (error) {
//     return (
//       <div className="p-4 sm:p-6 max-w-[1500px] mx-auto bg-gray-50 min-h-screen">
//         <div className="bg-white rounded-xl shadow-sm border border-red-200 p-8">
//           <div className="text-center">
//             <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
//               <span className="text-2xl">⚠️</span>
//             </div>
//             <h3 className="text-xl font-semibold text-red-600 mb-2">
//               Error Loading Data
//             </h3>
//             <p className="text-gray-600 mb-6">{error}</p>
//             <button
//               onClick={() => window.location.reload()}
//               className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium"
//             >
//               Try Again
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Loading state
//   if (loading) {
//     return (
//       <div className="p-4 max-w-[1500px] mx-auto bg-gray-50 min-h-screen">
//         <div className="space-y-4">
//           {[1, 2, 3].map((index) => (
//             <SkeletonAccordion key={index} />
//           ))}
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* Main Content - Lower z-index */}
//       <div
//         className="p-4 max-w-[1700px] mx-auto min-h-screen relative"
//         style={{ zIndex: 1 }}
//       >
//         {/* Year Accordions */}
//         <div className="space-y-4">
//           {Object.keys(yearsData).length === 0 ? (
//             <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
//               <div className="text-center">
//                 <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
//                   <span className="text-2xl">📊</span>
//                 </div>
//                 <h3 className="text-xl font-semibold text-gray-600 mb-2">
//                   No Data Available
//                 </h3>
//                 <p className="text-gray-500 text-sm">
//                   There are no awards data to display at the moment.
//                 </p>
//               </div>
//             </div>
//           ) : (
//             Object.entries(yearsData)
//               .sort(([a], [b]) => Number(b) - Number(a))
//               .map(([year, data]) => (
//                 <div
//                   key={year}
//                   className="bg-white rounded-xl shadow-sm overflow-visible border border-gray-100 relative"
//                   style={{
//                     zIndex: year === "2025" && activeYear === year ? 10 : 2,
//                   }}
//                 >
//                   {/* Accordion Header */}
//                   <button
//                     onClick={() => toggleYear(year)}
//                     className="w-full px-4 sm:px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
//                   >
//                     <div className="flex items-center space-x-3 sm:space-x-4">
//                       <div className="bg-gradient-to-br from-blue-500 to-purple-600 p-2 rounded-lg">
//                         <Calendar className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
//                       </div>
//                       <div className="text-left">
//                         <h2 className="text-lg font-semibold text-gray-800">
//                           {year}
//                         </h2>
//                         <p className="text-xs text-gray-500 hidden sm:block">
//                           {data.attendees?.length || 0} attendees •{" "}
//                           {data.nominated?.length || 0} nominated •{" "}
//                           {data.winners?.length || 0} winners
//                         </p>
//                         <p className="text-xs text-gray-500 sm:hidden">
//                           {data.attendees?.length || 0} attendees
//                         </p>
//                       </div>
//                     </div>
//                     <ChevronDown
//                       className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${
//                         activeYear === year ? "rotate-180" : ""
//                       }`}
//                     />
//                   </button>

//                   {/* Accordion Content */}
//                   <div
//                     className={`transition-all duration-500 ease-in-out ${
//                       activeYear === year
//                         ? "max-h-[80vh] opacity-100 overflow-visible"
//                         : "max-h-0 opacity-0 overflow-hidden"
//                     }`}
//                   >
//                     <div className="border-t border-gray-100">
//                       {year === "2025" ? (
//                         // Enhanced Responsive Layout for 2025
//                         <>
//                           {/* Mobile Tab Navigation */}
//                           <MobileTabNavigation
//                             tabs={tabs}
//                             activeTab={activeTab}
//                             onTabChange={handleTabChange}
//                           />

//                           {/* Desktop Sidebar Layout + Mobile Stack Layout */}
//                           <div className="lg:flex lg:h-[70vh] lg:overflow-visible">
//                             {/* Desktop Sidebar Navigation */}
//                             <div className="hidden lg:block w-64 bg-gray-50/50 border-r border-gray-100 p-4 flex-shrink-0 overflow-y-auto">
//                               <div className="space-y-2">
//                                 {tabs.map((tab) => {
//                                   const IconComponent = tab.icon;
//                                   const isActive = activeTab === tab.id;

//                                   const colorClasses = {
//                                     blue: isActive
//                                       ? "bg-blue-100 text-blue-700 border-blue-200"
//                                       : "hover:bg-blue-50 hover:text-blue-600",
//                                     amber: isActive
//                                       ? "bg-amber-100 text-amber-700 border-amber-200"
//                                       : "hover:bg-amber-50 hover:text-amber-600",
//                                     green: isActive
//                                       ? "bg-green-100 text-green-700 border-green-200"
//                                       : "hover:bg-green-50 hover:text-green-600",
//                                     purple: isActive
//                                       ? "bg-purple-100 text-purple-700 border-purple-200"
//                                       : "hover:bg-purple-50 hover:text-purple-600",
//                                   };

//                                   return (
//                                     <button
//                                       key={tab.id}
//                                       onClick={() => setActiveTab(tab.id)}
//                                       className={`
//                                         w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200
//                                         ${
//                                           isActive
//                                             ? `${
//                                                 colorClasses[tab.color]
//                                               } border shadow-sm`
//                                             : `text-gray-600 ${
//                                                 colorClasses[tab.color]
//                                               } border border-transparent`
//                                         }
//                                       `}
//                                     >
//                                       <IconComponent className="w-4 h-4 flex-shrink-0" />
//                                       <span className="text-left">
//                                         {tab.label}
//                                       </span>
//                                       {isActive && (
//                                         <div className="ml-auto w-2 h-2 bg-current rounded-full opacity-60"></div>
//                                       )}
//                                     </button>
//                                   );
//                                 })}
//                               </div>
//                             </div>

//                             {/* Main Content Area - responsive padding */}
//                             <div className="flex-1 p-4 sm:p-6 lg:overflow-y-auto lg:overflow-x-visible min-h-[50vh] lg:min-h-0">
//                               {renderTabContent(data, year)}
//                             </div>
//                           </div>
//                         </>
//                       ) : (
//                         // Original Simple Card Layout for other years (no tabs)
//                         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4 px-4 sm:px-6 pb-6">
//                           {loading ? (
//                             <>
//                               <SkeletonCard />
//                               <SkeletonCard />
//                               <SkeletonCard />
//                             </>
//                           ) : (
//                             <>
//                               {/* Attendees Card */}
//                               <button
//                                 onClick={() =>
//                                   openModal(
//                                     "attendees",
//                                     data.attendees || [],
//                                     year
//                                   )
//                                 }
//                                 className="bg-blue-50 rounded-lg shadow-sm p-3 border-l-4 border-blue-500 hover:shadow-md transition-shadow text-left w-full"
//                               >
//                                 <div className="flex items-center justify-between">
//                                   <div>
//                                     <h3 className="text-xs font-medium text-blue-700 mb-1">
//                                       Attendees
//                                     </h3>
//                                     <p className="text-xl font-bold text-blue-600">
//                                       {data.attendees?.length || 0}
//                                     </p>
//                                   </div>
//                                   <div className="bg-blue-100 p-1.5 rounded">
//                                     <Users className="w-4 h-4 text-blue-600" />
//                                   </div>
//                                 </div>
//                               </button>

//                               {/* Nominated Card */}
//                               <button
//                                 onClick={() =>
//                                   openModal(
//                                     "nominated",
//                                     data.nominated || [],
//                                     year
//                                   )
//                                 }
//                                 className="bg-yellow-50 rounded-lg shadow-sm p-3 border-l-4 border-yellow-500 hover:shadow-md transition-shadow text-left w-full"
//                               >
//                                 <div className="flex items-center justify-between">
//                                   <div>
//                                     <h3 className="text-xs font-medium text-yellow-700 mb-1">
//                                       Nominated
//                                     </h3>
//                                     <p className="text-xl font-bold text-yellow-600">
//                                       {data.nominated?.length || 0}
//                                     </p>
//                                   </div>
//                                   <div className="bg-yellow-100 p-1.5 rounded">
//                                     <Star className="w-4 h-4 text-yellow-600" />
//                                   </div>
//                                 </div>
//                               </button>

//                               {/* Winners Card */}
//                               <button
//                                 onClick={() =>
//                                   openModal("winners", data.winners || [], year)
//                                 }
//                                 className="bg-green-50 rounded-lg shadow-sm p-3 border-l-4 border-green-500 hover:shadow-md transition-shadow text-left w-full"
//                               >
//                                 <div className="flex items-center justify-between">
//                                   <div>
//                                     <h3 className="text-xs font-medium text-green-700 mb-1">
//                                       Winners
//                                     </h3>
//                                     <p className="text-xl font-bold text-green-600">
//                                       {data.winners?.length || 0}
//                                     </p>
//                                   </div>
//                                   <div className="bg-green-100 p-1.5 rounded">
//                                     <Trophy className="w-4 h-4 text-green-600" />
//                                   </div>
//                                 </div>
//                               </button>
//                             </>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               ))
//           )}
//         </div>
//       </div>

//       {/* Modal - Highest z-index, rendered outside main content */}
//       {renderModalContent()}
//     </>
//   );
// };

// export default AwardsAccordion;


import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ChevronDown,
  Users,
  Star,
  Trophy,
  Calendar,
  X,
  MapPin,
  Menu,
  Crown,
  Mail,
  Phone,
  Eye,
  Upload,
  FileText,
  Link,
  ExternalLink,
  ClipboardList,
  Headphones,
  User,
  Info,
  Sparkles,
  Download,
  ArrowLeft
} from "lucide-react";
import DataTable from "./DataTable"; // Import your updated DataTable
import api from "../../services/api";
import ConferenceApp from "./ConferenceApp";
import EastBourneResortMap from "./Venue";
import EnhancedMinimalistAgenda from "./Agenda";
import EventFeedbackForm from "../Admin/NominationMarking/EventFeedbackForm";
import ConferenceTicketGenerator from "../Trainer FDP/Slots/ConferenceTicketGenerator";
import AwardsByCategory from "./AwardsByCategory";

// For demo purposes, we'll create mock versions

// Skeleton components
const SkeletonCard = () => (
  <div className="bg-white/60 rounded-xl shadow-sm p-4 border border-gray-100 animate-pulse">
    <div className="flex items-center space-x-3">
      <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
      <div className="flex-1">
        <div className="h-3 bg-gray-200 rounded mb-2 w-20"></div>
        <div className="h-5 bg-gray-200 rounded w-12"></div>
      </div>
    </div>
  </div>
);

const SkeletonAccordion = () => (
  <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 animate-pulse">
    <div className="px-6 py-4 flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <div className="bg-gray-200 p-2 rounded-lg w-10 h-10"></div>
        <div>
          <div className="h-5 bg-gray-200 rounded w-20 mb-1"></div>
          <div className="h-3 bg-gray-200 rounded w-32"></div>
        </div>
      </div>
      <div className="w-5 h-5 bg-gray-200 rounded"></div>
    </div>
  </div>
);

// ── Celebration Popper ──────────────────────────────────────────────────────
const CONFETTI_COLORS = [
  "#FFD700", "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4",
  "#FFEAA7", "#DDA0DD", "#98FB98", "#F0E68C", "#FF69B4",
];
const EMOJIS = ["🏆", "🌟", "🎉", "✨", "🥇", "🎊", "⭐"];

const CelebrationPopper = ({ onDismiss, origin, side = "right" }) => {
  const canvasRef = React.useRef(null);
  const animRef = React.useRef(null);
  const particlesRef = React.useRef([]);

  React.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    // Burst origin — corner of the table (or fallback)
    const ox = origin?.x ?? window.innerWidth * 0.85;
    const oy = origin?.y ?? window.innerHeight * 0.35;

    // Spawn particles — burst FROM origin upward, then fall due to gravity
    // side="left"  → fan angles -10° to -100° (upper-right arc)
    // side="right" → fan angles -80° to -170° (upper-left arc)
    const count = 140;
    const angleMin = side === "left" ? 0.05 : 0.45;   // fraction of -PI
    const angleRange = 0.5;                             // span of 90° each
    particlesRef.current = Array.from({ length: count }, (_, i) => {
      const angle = -Math.PI * (angleMin + Math.random() * angleRange);
      const speed = Math.random() * 50 + 5;
      return {
        x: ox,
        y: oy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,          // negative = upward
        spinAngle: Math.random() * Math.PI * 2,
        spin: (Math.random() - 0.5) * 0.35,
        size: Math.random() * 9 + 5,
        color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
        emoji: i % 8 === 0 ? EMOJIS[Math.floor(Math.random() * EMOJIS.length)] : null,
        opacity: 1,
        shape: Math.random() > 0.5 ? "rect" : "circle",
      };
    });

    let frame = 0;
    const GRAVITY = 0.45;   // pulls particles downward each frame
    const DRAG   = 0.99;    // slight air resistance

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      frame++;

      particlesRef.current = particlesRef.current.map((p) => {
        const updated = {
          ...p,
          x: p.x + p.vx,
          y: p.y + p.vy,
          vx: p.vx * DRAG,
          vy: p.vy * DRAG + GRAVITY,   // gravity pulls down
          spinAngle: p.spinAngle + p.spin,
          opacity: frame > 80 ? Math.max(0, p.opacity - 0.014) : p.opacity,
        };

        ctx.save();
        ctx.globalAlpha = updated.opacity;
        ctx.translate(updated.x, updated.y);
        ctx.rotate(updated.spinAngle);

        if (updated.emoji) {
          ctx.font = `${updated.size + 8}px serif`;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(updated.emoji, 0, 0);
        } else if (updated.shape === "rect") {
          ctx.fillStyle = updated.color;
          ctx.fillRect(-updated.size / 2, -updated.size / 4, updated.size, updated.size / 2);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, updated.size / 2, 0, Math.PI * 2);
          ctx.fillStyle = updated.color;
          ctx.fill();
        }

        ctx.restore();
        return updated;
      }).filter((p) => p.opacity > 0 && p.y < canvas.height + 60);

      if (particlesRef.current.length > 0) {
        animRef.current = requestAnimationFrame(draw);
      } else {
        onDismiss && onDismiss();
      }
    };

    animRef.current = requestAnimationFrame(draw);

    // Auto-dismiss after 5 seconds
    const timer = setTimeout(() => {
      onDismiss && onDismiss();
    }, 5000);

    return () => {
      cancelAnimationFrame(animRef.current);
      window.removeEventListener("resize", resize);
      clearTimeout(timer);
    };
  }, [onDismiss, origin?.x, origin?.y, side]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        pointerEvents: "none",
      }}
    >
      <canvas ref={canvasRef} style={{ position: "absolute", inset: 0 }} />
      {/* Popup card — commented out, confetti only */}
      {/* <div
        style={{
          position: "relative",
          background: "linear-gradient(135deg, rgba(255,215,0,0.97) 0%, rgba(255,165,0,0.97) 100%)",
          borderRadius: "24px",
          padding: "40px 56px",
          boxShadow: "0 32px 80px rgba(0,0,0,0.35), 0 0 0 3px rgba(255,255,255,0.4) inset",
          textAlign: "center",
          maxWidth: "440px",
          animation: "celebPop 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) forwards",
          pointerEvents: "auto",
        }}
        onClick={onDismiss}
      >
        <style>{`
          @keyframes celebPop {
            0% { transform: scale(0.3) rotate(-8deg); opacity: 0; }
            100% { transform: scale(1) rotate(0deg); opacity: 1; }
          }
          @keyframes trophyBounce {
            0%, 100% { transform: translateY(0) rotate(-5deg); }
            50% { transform: translateY(-14px) rotate(5deg); }
          }
          @keyframes shimmer {
            0% { background-position: -200% center; }
            100% { background-position: 200% center; }
          }
        `}</style>
        <div style={{ fontSize: "64px", lineHeight: 1, marginBottom: "12px", animation: "trophyBounce 1.2s ease-in-out infinite" }}>🏆</div>
        <div
          style={{
            fontSize: "26px",
            fontWeight: "900",
            color: "#7B3F00",
            marginBottom: "8px",
            fontFamily: "system-ui, sans-serif",
            letterSpacing: "-0.5px",
          }}
        >
          Congratulations, Winner! 🎉
        </div>
        <div
          style={{
            fontSize: "15px",
            color: "#92400e",
            fontFamily: "system-ui, sans-serif",
            lineHeight: 1.5,
            marginBottom: "20px",
          }}
        >
          You've won an EduSkills Connect Award!<br />
          <span style={{ fontWeight: "700" }}>Well done — you earned it! ⭐</span>
        </div>
        <div
          style={{
            fontSize: "12px",
            color: "rgba(120,60,0,0.7)",
            fontFamily: "system-ui, sans-serif",
          }}
        >
          Tap anywhere to continue
        </div>
      </div> */}
    </div>
  );
};

// COE Award Ranking Table — fetches /coe_award_ranking_v2
const CoeAwardTable = ({ registrationStatus }) => {
  const [rankData, setRankData] = useState({ institute: [], individual: [] });
  const [activeTab, setActiveTab] = useState("institute");
  const [rankLoading, setRankLoading] = useState(true);
  const [tooltipId, setTooltipId] = useState(null);
  const [showCelebration, setShowCelebration] = useState(false);
  const [popperLeft, setPopperLeft]   = useState(null);
  const [popperRight, setPopperRight] = useState(null);
  const tableRef = React.useRef(null);

  useEffect(() => {
    const fetchRankings = async () => {
      try {
        setRankLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;
        const res = await api.get(`${BASE_URL}/awards/coe_award_ranking_v2`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (res.data) {
          const instituteRows = Object.entries(res.data.institute || {}).map(([awardName, entries]) => {
            const entry = Array.isArray(entries) && entries.length > 0 ? entries[0] : null;
            return { awardName, entry };
          });
          const individualRows = Object.entries(res.data.individual || {}).map(([awardName, status]) => {
            return { awardName, status };
          });
          setRankData({ institute: instituteRows, individual: individualRows });

          // 🎉 Trigger celebration if any award is won
          const hasWinner =
            instituteRows.some((r) => r.entry?.is_winner === true) ||
            individualRows.some((r) => r.status?.is_winner === true);
          if (hasWinner) {
            // Capture both top corners of the table as burst origins
            if (tableRef.current) {
              const rect = tableRef.current.getBoundingClientRect();
              setPopperLeft({ x: rect.left + 20, y: rect.top + 20 });
              setPopperRight({ x: rect.right - 20, y: rect.top + 20 });
            }
            setShowCelebration(true);
          }
        }
      } catch (err) {
        console.error("Error fetching COE rankings:", err);
      } finally {
        setRankLoading(false);
      }
    };
    fetchRankings();
  }, []);

  const getRankingCell = (entry, rankKey, totalKey, idx) => {
    if (!entry) {
      return (
        <div className="flex items-center justify-center">
          <span className="text-xs font-semibold text-red-500 bg-red-50 border border-red-200 px-2 py-0.5 rounded-full whitespace-nowrap">
            Not Eligible
          </span>
        </div>
      );
    }

    // Check for message from API
    const hasMessage = !!entry.message;
    
    // Check eligibility using limit vs total_internships OR placed_count
    const hasLimit = entry.limit !== undefined && entry.limit !== null;
    let countToCheck = 0;
    let isPlacedCount = false;
    
    if (entry.placed_count !== undefined && entry.placed_count !== null) {
      countToCheck = entry.placed_count;
      isPlacedCount = true;
    } else if (entry.total_internships !== undefined && entry.total_internships !== null) {
      countToCheck = entry.total_internships;
    }
    
    const failsLimit = hasLimit && (countToCheck < entry.limit);

    if (hasMessage || failsLimit) {
      // Use idx to ensure a stable tipId across re-renders
      const tipId = `${rankKey}-${idx}`;
      const tooltipText = hasMessage 
        ? entry.message 
        : `Your institute must have at least ${entry.limit} ${isPlacedCount ? 'placements' : 'completed internships'} to be eligible.`;

      return (
        <div className="flex items-center justify-center">
          <div className="relative flex items-center">
            <span className="text-xs font-semibold text-red-500 bg-red-50 border border-red-200 px-2 py-0.5 rounded-full whitespace-nowrap">
              Not Eligible
            </span>
            <div className="absolute left-full ml-1.5 z-10">
              <button
                className="text-gray-400 hover:text-blue-500 transition-colors cursor-pointer flex items-center"
                onMouseEnter={() => setTooltipId(tipId)}
                onMouseLeave={() => setTooltipId(null)}
              >
                <Info className="w-3.5 h-3.5" />
              </button>
              {tooltipId === tipId && (
                <div className="absolute bottom-6 right-0 w-52 bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-xl leading-snug">
                  {tooltipText}
                  <div className="absolute top-full right-2 border-4 border-transparent border-t-gray-900"></div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    if (entry?.is_winner) return <span className="text-gray-400 text-xs">—</span>;

    const rank = entry[rankKey];
    const total = entry[totalKey];
    if (rank === null || rank === undefined) return <span className="text-gray-400 text-xs">—</span>;
    return (
      <span className="inline-flex items-center justify-center text-sm font-bold text-amber-600 bg-amber-100/80 px-2.5 py-1 rounded-md">
        #{rank}
      </span>
    );
  };

  return (
    <div className="mt-6" ref={tableRef}>
      {/* 🎉 Celebration Poppers — left & right corners */}
      {showCelebration && (
        <>
          <CelebrationPopper
            side="left"
            origin={popperLeft}
            onDismiss={() => setShowCelebration(false)}
          />
          <CelebrationPopper
            side="right"
            origin={popperRight}
            onDismiss={() => setShowCelebration(false)}
          />
        </>
      )}
      {/* Info Note */}
      <div className="flex items-start gap-2.5 bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 mb-4">
        <Info className="w-4 h-4 text-blue-500 shrink-0 mt-0.5" />
        <span className="text-sm text-gray-800 leading-snug">
          <span className="font-bold">Note:</span> <span className="font-normal">All rankings are  <span className="font-bold">provisional  </span> and subject to change based on the completion of <span className="font-bold"> Cohort 17   </span> and the final verification process. The <span className="font-bold"> EduSkills Connect 2026 Award Winners </span> will be selected based on the final rankings. The official winners' list will be announced in the <span className="font-bold">first week of September 2026 </span> and published on the <a href="https://connect.eduskillsfoundation.org/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline"> Eduskills Connect website</a>.</span>
          <br />
          {/* {registrationStatus === 0 && (
            <span className="text-red-400 block mt-2">*Nomination and voting are not applicable.</span>
          )} */}
        </span>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 mb-4 border-b border-gray-200">
        <button
          onClick={() => setActiveTab("institute")}
          className={`pb-2 font-semibold text-sm transition-colors relative ${
            activeTab === "institute" ? "text-amber-600" : "text-gray-500 hover:text-gray-700"
          }`}
        >
          Institute Awards
          {activeTab === "institute" && (
            <div className="absolute bottom-[-1px] left-0 right-0 h-0.5 bg-amber-500 rounded-t-full"></div>
          )}
        </button>
        <button
          onClick={() => setActiveTab("individual")}
          className={`pb-2 font-semibold text-sm transition-colors relative ${
            activeTab === "individual" ? "text-amber-600" : "text-gray-500 hover:text-gray-700"
          }`}
        >
          Individual Awards
          {activeTab === "individual" && (
            <div className="absolute bottom-[-1px] left-0 right-0 h-0.5 bg-amber-500 rounded-t-full"></div>
          )}
        </button>
      </div>

      {activeTab === "institute" ? (
      <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-100">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100 text-sm text-gray-600">
              <th className="p-4 font-semibold">Award Name</th>
              <th className="p-4 font-semibold text-center">State Ranking</th>
              <th className="p-4 font-semibold text-center">National Ranking</th>
              <th className="p-4 font-semibold text-center">Award Winner</th>
            </tr>
          </thead>
          <tbody>
            {rankLoading ? (
              <tr>
                <td colSpan="4" className="p-8 text-center">
                  <div className="flex justify-center">
                    <div className="w-8 h-8 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
                  </div>
                </td>
              </tr>
            ) : rankData.institute.length === 0 ? (
              <tr>
                <td colSpan="4" className="p-8 text-center text-gray-500">
                  <div className="flex flex-col items-center justify-center">
                    <Trophy className="w-10 h-10 text-gray-300 mb-3" />
                    <p className="font-medium">No institute ranking data available yet.</p>
                  </div>
                </td>
              </tr>
            ) : (
              rankData.institute.map(({ awardName, entry }, idx) => (
                <tr
                  key={idx}
                  className={`border-b border-gray-50 transition-colors ${
                    entry?.is_winner
                      ? "bg-amber-50/60 hover:bg-amber-50"
                      : "hover:bg-gray-50/50"
                  }`}
                >
                  <td className="p-4 text-sm font-semibold text-gray-800">{awardName}</td>
                  <td className="p-4 text-center">
                    {getRankingCell(entry, "rank_position_state", "total_institutes_state", idx)}
                  </td>
                  <td className="p-4 text-center">
                    {getRankingCell(entry, "rank_position", "total_institutes", idx)}
                  </td>
                  <td className="p-4 text-center">
                    {entry?.is_winner ? (
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-700 border border-amber-200">
                        <Trophy className="w-3.5 h-3.5" />
                        Winner
                      </span>
                    ) : (
                      <span className="text-xs text-gray-400">—</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      ) : (
        <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-100">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-100 text-sm text-gray-600">
                <th className="p-4 font-semibold">Award Name</th>
                <th className="p-4 font-semibold text-center">Award Winner</th>
              </tr>
            </thead>
            <tbody>
              {rankLoading ? (
                <tr>
                  <td colSpan="2" className="p-8 text-center">
                    <div className="flex justify-center">
                      <div className="w-8 h-8 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
                    </div>
                  </td>
                </tr>
              ) : rankData.individual.length === 0 ? (
                <tr>
                  <td colSpan="2" className="p-8 text-center text-gray-500">
                    <div className="flex flex-col items-center justify-center">
                      <Trophy className="w-10 h-10 text-gray-300 mb-3" />
                      <p className="font-medium">No individual awards available yet.</p>
                    </div>
                  </td>
                </tr>
              ) : (
                rankData.individual.map(({ awardName, status }, idx) => (
                  <tr
                    key={idx}
                    className={`border-b border-gray-50 transition-colors ${
                      status?.is_winner
                        ? "bg-amber-50/60 hover:bg-amber-50"
                        : "hover:bg-gray-50/50"
                    }`}
                  >
                    <td className="p-4 text-sm font-semibold text-gray-800">{awardName}</td>
                    <td className="p-4 text-center">
                      {status?.is_winner ? (
                        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-700 border border-amber-200">
                          <Trophy className="w-3.5 h-3.5" />
                          Winner
                        </span>
                      ) : (
                        <span className="text-xs text-gray-400">—</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const AwardsTab = ({ data, year, openModal, showAward, activeSubCategory, rmDetails, rmLoading }) => {

  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [applyingId, setApplyingId] = useState(null);
  
  const [eduAwards, setEduAwards] = useState([]);
  const [loadingEdu, setLoadingEdu] = useState(false);
  const [errorEdu, setErrorEdu] = useState(null);

  const activeSubTab = activeSubCategory || (showAward === 1 ? "special" : "education");

  const [nominationStatus, setNominationStatus] = useState(null);
  const [nominationLoading, setNominationLoading] = useState(true);
  const [eduTab, setEduTab] = useState('individual');

  // Fetch global nomination status
  useEffect(() => {
    const fetchNominationStatus = async () => {
      try {
        setNominationLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;

        const response = await api.get(`${BASE_URL}/internship/nomination/status`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          setNominationStatus(response.data);
        }
      } catch (error) {
        console.error("Error fetching nomination status:", error);
      } finally {
        setNominationLoading(false);
      }
    };

    fetchNominationStatus();
  }, []);

  // No longer need to reset activeSubTab locally because it is managed by the parent


  const handleApplyClick = async (award) => {
    const awardId = award.id || award.category_id || award.award_id;
    if (award.nomination_status === 'submitted') {
      try {
        setApplyingId(awardId);
        const accessToken = localStorage.getItem("accessToken");
        
        // Use nomination_id if provided by backend, otherwise try awardId as fallback
        const nomId = award.nomination_id || awardId;
        
        const res = await api.get(`${BASE_URL}/awards/nominations?nomination_id=${nomId}`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        
        if (res.data) {
          openModal("view_nomination", res.data, year);
        }
      } catch (err) {
        console.error("Error fetching nomination details:", err);
        openModal("error", { message: err.response?.data?.detail || "Failed to load nomination details." }, year);
      } finally {
        setApplyingId(null);
      }
      return;
    }

    try {
      setApplyingId(awardId);
      const accessToken = localStorage.getItem("accessToken");
      const res = await api.get(`${BASE_URL}/awards/nomination-form/${awardId}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      
      if (res.data) {
        openModal("apply_form", { ...res.data, award_id: awardId, award_name: award.award_name }, year);
      }
    } catch (err) {
      console.error("Error fetching nomination form:", err);
      openModal("error", { message: err.response?.data?.detail || "Failed to load the nomination form. Please try again later." }, year);
    } finally {
      setApplyingId(null);
    }
  };

  useEffect(() => {
    const fetchAwards = async () => {
      try {
        setLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        // Fetch active awards
        const res = await api.get(`${BASE_URL}/awards/award/institutes`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (res.data && res.data.data) {
          setAwards(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching awards:", err);
        setError("Failed to load available awards.");
      } finally {
        setLoading(false);
      }
    };
    
    fetchAwards();
  }, []);

  useEffect(() => {
    const fetchEduAwards = async () => {
      if (activeSubTab !== "education") return;
      if (eduAwards.length > 0) return; // Already fetched
      
      try {
        setLoadingEdu(true);
        const accessToken = localStorage.getItem("accessToken");
        // Attempting to hit the provided API path (might need adjustment if not under /awards)
        // const res = await api.get(`${BASE_URL}/awards/education_excellence_awards`, {
        //   headers: { Authorization: `Bearer ${accessToken}` },
        // });
        // if (res.data && res.data.awards) {
        //   setEduAwards(res.data.awards);
        // }
      } catch (err) {
        console.error("Error fetching education excellence awards:", err);
        setErrorEdu("Failed to load education excellence awards.");
      } finally {
        setLoadingEdu(false);
      }
    };
    
    fetchEduAwards();
  }, [activeSubTab, eduAwards.length]);

  const subTabs = [];
  if (showAward === 1) {
    subTabs.push({ id: "special", label: "Special Category Award", color: "blue" });
  }
  subTabs.push({ id: "education", label: "Education Excellence Category", color: "blue" });
  subTabs.push({ id: "general", label: "Eduskills Center Of Excellence (COE) Awards", color: "blue" });

  const hasAccess = nominationStatus?.registration_status === 1;

  if (nominationLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="w-10 h-10 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!hasAccess && activeSubTab === "education") {
    return (
      <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgb(59,130,246,0.12)] p-3 md:p-4 max-w-2xl mx-auto my-0 border border-blue-100 relative overflow-hidden">
        <div className="flex flex-col items-center text-center relative z-10 pt-4">
          {/* Awards List */}
          <div className="w-full max-w-2xl mx-auto mb-6">
            <h2 className="text-lg md:text-xl font-bold text-slate-800 mb-4 text-center">
              Awards
            </h2>
            <div className="grid grid-cols-2 gap-3 text-left">
              {(rmDetails.awards || []).map((award, index) => (
                <div key={index} className="flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-xl px-3 py-3 hover:bg-blue-100/50 transition-colors">
                  <div className="w-7 h-7 rounded-full bg-blue-500 flex items-center justify-center text-white shrink-0 shadow-sm">
                    <Trophy className="w-3.5 h-3.5" />
                  </div>
                  <span className="text-slate-700 font-semibold text-xs md:text-sm leading-snug">
                    {award.award_name}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Divider 2 */}
          <div className="w-full flex items-center justify-center mb-3 relative max-w-lg mx-auto">
            <div className="h-px bg-transparent flex-1 border-t border-dashed border-gray-300"></div>
            <div className="px-3 relative">
              <div className="w-8 h-8 bg-orange-50 rounded-full border border-orange-100 flex items-center justify-center">
                <Headphones className="w-4 h-4 text-orange-400" />
              </div>
            </div>
            <div className="h-px bg-transparent flex-1 border-t border-dashed border-gray-300"></div>
          </div>

          <h3 className="text-xs md:text-sm font-bold text-slate-800 mb-2">For Nomination, Please Connect With</h3>

          {/* Contact Box */}
          <div className="w-full max-w-3xl bg-orange-50/40 border border-orange-100 rounded-2xl p-4 mb-6">
            <div className="w-fit mx-auto md:w-full flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center text-orange-500 shrink-0">
                  <User className="w-4 h-4" />
                </div>
                <span className="font-bold text-slate-800 text-xs md:text-sm">
                   {rmLoading ? (
                     <span className="animate-pulse bg-slate-200 h-4 w-24 rounded inline-block"></span>
                   ) : (
                     rmDetails.rm_name || "Pritipragyan"
                   )}
                </span>
              </div>
              
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center text-orange-500 shrink-0">
                  <Mail className="w-4 h-4" />
                </div>
                {rmLoading ? (
                  <span className="animate-pulse bg-slate-200 h-4 w-32 rounded inline-block"></span>
                ) : (
                  <a href={`mailto:${rmDetails.rm_email || "lead_op@eduskills.academy"}`} className="font-bold text-blue-600 text-xs md:text-sm hover:underline">
                    {rmDetails.rm_email || "lead_op@eduskills.academy"}
                  </a>
                )}
              </div>

              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center text-orange-500 shrink-0">
                  <Phone className="w-4 h-4" />
                </div>
                {rmLoading ? (
                  <span className="animate-pulse bg-slate-200 h-4 w-24 rounded inline-block"></span>
                ) : (
                  <a href={`tel:${rmDetails.rm_mobile || "8093254905"}`} className="font-bold text-blue-600 text-xs md:text-sm hover:underline">
                    {rmDetails.rm_mobile || "8093254905"}
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Info Banner */}
        

        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Sub Tab Content */}
      <div className="pt-2">
                {/* Education Excellence Category */}
        {activeSubTab === "education" && (() => {
          const individualAwardsList = [];
          const instituteAwardsList = [];

          if (nominationStatus) {
            // Main Award (Individual)
            
            // Check if user has already submitted an individual award (ignore coe type)
            const hasSubmittedIndividual = (nominationStatus.submited_awards || []).some(
              sa => (sa.award_type || '').toLowerCase() === 'individual'
                 && (sa.award_type || '').toLowerCase() !== 'coe'
            );
            const showPrimary = nominationStatus.nomination_submitted || !hasSubmittedIndividual;

            if (showPrimary && nominationStatus.category_name) {
              const primarySubmitted = (nominationStatus.submited_awards || []).find(sa => sa.category_id === nominationStatus.category_id || sa.award_name === nominationStatus.category_name);

              individualAwardsList.push({
                id: nominationStatus.category_id,
                award_name: nominationStatus.category_name,
                nomination_start: nominationStatus.nomination_start_date,
                nomination_end: nominationStatus.nomination_end_date,
                voting_start_date: nominationStatus.voting_start_date,
                voting_end_date: nominationStatus.voting_end_date,
                voting_status: nominationStatus.voting_status,
                status: nominationStatus.nomination_status,
                voters_count: nominationStatus.voters_count,
                corporate_voters_count: nominationStatus.corporate_voters_count,
                is_winner: primarySubmitted ? primarySubmitted.is_winner : undefined,
                isPrimary: true
              });
            }

            // Eligible Awards
            if (nominationStatus.eligible_awards) {
              nominationStatus.eligible_awards.forEach(award => {
                const submitted = (nominationStatus.submited_awards || []).find(sa => sa.id === award.id || sa.award_name === award.award_name);
                const awardData = {
                  ...award,
                  status: submitted ? submitted.nomination_status || 'submitted' : null,
                  voters_count: submitted ? submitted.voters_count : 0,
                  corporate_voters_count: submitted ? submitted.corporate_voters_count : 0,
                  is_winner: submitted ? submitted.is_winner : null,
                  nomination_start: award.nomination_start_date || award.nomination_start,
                  nomination_end: award.nomination_end_date || award.nomination_end,
                };
                if ((award.award_type || '').toLowerCase() === 'individual') {
                  individualAwardsList.push(awardData);
                } else if ((award.award_type || '').toLowerCase() === 'institute') {
                  instituteAwardsList.push(awardData);
                }
              });
            }

            // Other submitted awards not in eligible list (exclude coe type)
            if (nominationStatus.submited_awards) {
              nominationStatus.submited_awards.forEach(sa => {
                // Skip COE type awards entirely
                if ((sa.award_type || '').toLowerCase() === 'coe') return;

                const exists = [...individualAwardsList, ...instituteAwardsList].some(a => a.id === sa.id || a.award_name === sa.award_name);
                if (!exists) {
                  const awardData = {
                    ...sa,
                    status: sa.nomination_status || 'submitted',
                    nomination_start: sa.nomination_start_date || sa.nomination_start,
                    nomination_end: sa.nomination_end_date || sa.nomination_end,
                  };
                  if ((sa.award_type || '').toLowerCase() === 'individual' && awardData.category_id !== nominationStatus.category_id) {
                    individualAwardsList.push(awardData);
                  } else if ((sa.award_type || '').toLowerCase() === 'institute') {
                    instituteAwardsList.push(awardData);
                  }
                }
              });
            }
          }

          // Since the tabs are hidden, combine both lists to show all awards
          const currentAwardsList = [...individualAwardsList, ...instituteAwardsList];

          return (
            <>
              {/* Tabs - Individual/Institute */}
              {/* <div className="flex space-x-2 border-b border-gray-200">
                <button
                  onClick={() => setEduTab("individual")}
                  className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
                    eduTab === "individual"
                      ? "border-blue-600 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-blue-600 hover:border-blue-300"
                  }`}
                >
                  Individual
                </button>
                <button
                  onClick={() => setEduTab("institute")}
                  className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
                    eduTab === "institute"
                      ? "border-blue-600 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-blue-600 hover:border-blue-300"
                  }`}
                >
                  Institute
                </button>
              </div> */}

              {/* Table */}
              <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-100 mt-6 ">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-gray-50 border-b border-gray-100 text-sm text-gray-600">
                      <th className="p-4 font-semibold">Award Names</th>
                      <th className="p-4 font-semibold">Nomination Date</th>
                      <th className="p-4 font-semibold text-center w-48">Nomination</th>
                      <th className="p-4 font-semibold text-center">Winner</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nominationLoading ? (
                      <tr>
                        <td colSpan="4" className="p-8 text-center text-gray-500">
                          <div className="flex justify-center">
                            <div className="w-6 h-6 border-2 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
                          </div>
                        </td>
                      </tr>
                    ) : currentAwardsList.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="p-8 text-center text-gray-500 font-medium">
                          No awards are available.
                        </td>
                      </tr>
                    ) : currentAwardsList.map((award, idx) => {
                        const status = award.status ? award.status.toLowerCase() : null;
                        const totalVotes = (award.voters_count || 0) + (award.corporate_voters_count || 0);
                        return (
                          <tr key={idx} className="border-b border-gray-50 hover:bg-gray-50/50 transition-colors">
                            <td className="p-4 font-bold text-gray-800 text-sm hover:text-blue-600 transition-colors cursor-pointer">
                              {award.award_name}
                            </td>
                            <td className="p-4 text-sm text-gray-600">
                              <div className="flex flex-col gap-1.5">
                                {/* Nomination / Voting Date Range */}
                                {award.nomination_start && award.nomination_end ? (
                                  <div className="flex items-center gap-1.5">
                                    <Calendar className="w-3.5 h-3.5 text-gray-400 shrink-0" />
                                    <span className="text-gray-700 whitespace-nowrap">
                                      {new Date(award.nomination_start).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} – {new Date(award.nomination_end).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                                    </span>
                                  </div>
                                ) : (
                                  <span className="text-gray-400">N/A</span>
                                )}

                                {/* Voting Status badge — shown for primary award */}
                                {award.isPrimary && award.voting_status ? (
                                  <span className="inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-100 w-fit whitespace-nowrap">
                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse inline-block"></span>
                                    Voting {award.voting_status}
                                  </span>
                                ) : !award.isPrimary && !award.voting_start_date ? (
                                  /* Eligible awards with no voting yet */
                                  <span className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-gray-50 text-gray-400 border border-gray-100 w-fit whitespace-nowrap">
                                     No voting
                                  </span>
                                ) : null}
                              </div>
                            </td>
                            <td className="p-4 text-center">
                              {!status ? (
                                award.nomination_end && new Date(award.nomination_end).setHours(23, 59, 59, 999) < new Date() ? (
                                  <span className="inline-block w-full px-3 py-1.5 bg-gray-50 text-gray-500 text-xs font-semibold rounded-lg border border-gray-200">
                                    Nomination Closed
                                  </span>
                                ) : (
                                  <button
                                    onClick={() => {
                                      if (award.isPrimary) {
                                        navigate("/award/e3454-345");
                                      } else {
                                        handleApplyClick(award);
                                      }
                                    }}
                                    className="w-full px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded-lg transition-colors shadow-sm"
                                  >
                                    Nomination
                                  </button>
                                )
                              ) : status === 'accepted' || status === 'nomination accepted' ? (
                                award.isPrimary ? (
                                  <VoteNowBadge 
                                    forceSubmitted={true}
                                    customTrigger={({ onClick }) => (
                                      <div className="flex flex-col items-center gap-1.5 w-full">
                                        <button 
                                          onClick={onClick}
                                          className="w-full px-3 py-1.5 bg-green-50 hover:bg-green-100 text-green-700 text-[11px] font-bold rounded-lg border border-green-200 transition-colors shadow-sm"
                                        >
                                          Nomination Accepted - View Votes
                                        </button>
                                      </div>
                                    )} 
                                  />
                                ) : (
                                  <div className="flex flex-col items-center gap-1.5 w-full">
                                    <span className="w-full px-3 py-1.5 bg-green-50 text-green-700 text-xs font-semibold rounded-lg border border-green-200 text-center">
                                      Nomination Accepted
                                    </span>
                                  </div>
                                )
                              ) : status === 'rejected' || status === 'nomination rejected' ? (
                                <span className="inline-block w-full px-3 py-1.5 bg-red-50 text-red-700 text-xs font-semibold rounded-lg border border-red-200">
                                  Nomination Rejected
                                </span>
                              ) : (
                                <button
                                  onClick={() => {
                                    if (award.isPrimary) {
                                      navigate("/award/e3454-345");
                                    } else {
                                      handleApplyClick(award);
                                    }
                                  }}
                                  className="w-full px-3 py-1.5 bg-green-50 hover:bg-green-100 text-green-700 text-xs font-semibold rounded-lg transition-colors border border-green-200"
                                >
                                  {status.charAt(0).toUpperCase() + status.slice(1)}
                                </button>
                              )}
                            </td>
                            <td className="p-4 text-center text-sm font-medium">
                              {award.is_winner === true || award.is_winner === "true" || award.is_winner === 1 ? (
                                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200 shadow-sm whitespace-nowrap">
                                  🏆 Winner
                                </span>
                              ) : award.is_winner === false || award.is_winner === "false" || award.is_winner === 0 ? (
                                <span className="text-gray-400 font-bold whitespace-nowrap">—</span>
                              ) : (
                                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 text-[11px] font-semibold whitespace-nowrap">
                                  <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse inline-block"></span>
                                  ⏳ Coming Soon
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                    })}
                  </tbody>
                </table>
              </div>
              {/* <p className="text-xs text-gray-400 mt-2 text-center italic">
                *Note: You can submit only one nomination from the above awards.
              </p> */}
            </>
          );
        })()}

        {/* Special Category Award */}
        {activeSubTab === "special" && showAward === 1 && (
          <div>
            {loading ? (
              <div className="flex justify-center py-8">
                <div className="w-8 h-8 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin"></div>
              </div>
            ) : error ? (
              <div className="bg-red-50 text-red-600 p-4 rounded-xl text-sm border border-red-100">
                {error}
              </div>
            ) : awards.length === 0 ? (
              <div className="bg-gray-50 border border-gray-100 rounded-xl p-8 text-center">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Trophy className="w-6 h-6 text-gray-400" />
                </div>
                <p className="text-gray-500 text-sm font-medium">No active awards available at this moment in this category.</p>
              </div>
            ) : (
              <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-gray-100">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-gray-50 border-b border-gray-100 text-sm text-gray-600">
                      <th className="p-4 font-semibold">Award Name</th>
                      <th className="p-4 font-semibold">Award Type</th>
                      <th className="p-4 font-semibold">Nomination Date</th>
                      <th className="p-4 font-semibold text-center w-48">Nomination</th>
                      <th className="p-4 font-semibold text-center">Winner</th>
                    </tr>
                  </thead>
                  <tbody>
                    {awards.map((award, idx) => {
                      const status = award.nomination_status ? award.nomination_status.toLowerCase() : null;
                      return (
                        <tr key={award.id || idx} className="border-b border-gray-50 hover:bg-gray-50/50 transition-colors">
                          <td className="p-4 font-bold text-gray-800 text-sm hover:text-blue-600 transition-colors cursor-pointer">
                            {award.award_name}
                          </td>
                          <td className="p-4 text-sm text-gray-600 font-medium">
                            {award.award_type}
                          </td>
                          <td className="p-4 text-sm text-gray-600">
                            {award.nomination_start_date && award.nomination_end_date ? (
                              <div className="flex items-center gap-1.5">
                                <Calendar className="w-3.5 h-3.5 text-gray-400 shrink-0" />
                                <span className="text-gray-700 whitespace-nowrap">
                                  {new Date(award.nomination_start_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} – {new Date(award.nomination_end_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                                </span>
                              </div>
                            ) : (
                              <span className="text-gray-400">N/A</span>
                            )}
                          </td>
                          <td className="p-4 text-center">
                            {status === 'submitted' ? (
                              <button
                                onClick={() => handleApplyClick(award)}
                                disabled={applyingId === award.id}
                                className="w-full px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors shadow-sm flex items-center justify-center gap-2 bg-green-50 hover:bg-green-100 text-green-700 border border-green-200"
                              >
                                {applyingId === award.id ? (
                                  <div className="w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
                                ) : null}
                                Submitted
                              </button>
                            ) : award.nomination_end_date && new Date(award.nomination_end_date).setHours(23, 59, 59, 999) < new Date() ? (
                              <span className="inline-flex w-full items-center justify-center px-3 py-1.5 bg-gray-50 text-gray-500 text-xs font-semibold rounded-lg border border-gray-200">
                                Nomination Closed
                              </span>
                            ) : (
                              <button
                                onClick={() => handleApplyClick(award)}
                                disabled={applyingId === award.id}
                                className="w-full px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors shadow-sm flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white"
                              >
                                {applyingId === award.id ? (
                                  <div className="w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
                                ) : null}
                                Nomination
                              </button>
                            )}
                          </td>
                          <td className="p-4 text-center text-sm font-medium">
                            {award.is_winner === true || award.is_winner === "true" || award.is_winner === 1 ? (
                              <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200 shadow-sm whitespace-nowrap">
                                🏆 Winner
                              </span>
                            ) : award.is_winner === false || award.is_winner === "false" || award.is_winner === 0 ? (
                              <span className="text-gray-400 font-bold whitespace-nowrap">—</span>
                            ) : (
                              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 text-[11px] font-semibold whitespace-nowrap">
                                <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse inline-block"></span>
                                ⏳ Coming Soon
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Awards (previously COE Awards) */}
        {activeSubTab === "general" && (() => {
          return <CoeAwardTable />;
        })()}
      </div>
    </div>
  );
};

const ParticipateTab = ({ participateLoading, participateData }) => {

  if (participateLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-500 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-500 text-sm">Loading participate info...</p>
        </div>
      </div>
    );
  }

  if (!participateData || !participateData.members || participateData.members.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center max-w-sm w-full">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Users className="w-8 h-8 text-gray-400" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">No Participants</h3>
          <p className="text-gray-500 text-sm">No members are currently registered to participate.</p>
        </div>
      </div>
    );
  }

  const displayMembers = participateData.members;

  return (
    <div className="space-y-5 mt-2">
      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {displayMembers.length === 0 ? (
          <div className="col-span-full flex flex-col items-center justify-center py-12 text-center">
            <div className="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center mb-3">
              <Trophy className="w-7 h-7 text-amber-400" />
            </div>
            <p className="text-gray-500 text-sm font-medium">No nominated members found.</p>
          </div>
        ) : (
          displayMembers.map((member, index) => {
            const hasAwards = member.awards && member.awards.length > 0;
            return (
              <div
                key={index}
                className="group relative bg-white border border-gray-100 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col overflow-hidden hover:-translate-y-1"
              >
                {/* Top gradient accent */}
                <div className="h-1.5 w-full bg-gradient-to-r from-blue-500 to-indigo-600"></div>

                <div className="p-6 flex flex-col gap-5 flex-1">
                  <div className="flex items-center gap-4">
                    {/* Avatar placeholder with initials */}
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center shrink-0 border border-blue-200 group-hover:scale-105 transition-transform duration-300 shadow-sm">
                      <Users className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800 text-lg group-hover:text-blue-600 transition-colors">
                        {member.fullname}
                      </h4>
                      <span className="inline-flex items-center px-2 py-0.5 rounded-lg text-[10px] font-bold bg-gray-50 text-gray-500 border border-gray-200 uppercase tracking-wider mt-1">
                        Participant
                      </span>
                    </div>
                  </div>

                  <div className="space-y-3 bg-gray-50/50 p-3.5 rounded-xl border border-gray-100/50">
                    <div className="flex items-start gap-3 text-sm text-gray-600">
                      <div className="p-1.5 bg-white rounded-md shadow-sm border border-gray-100 shrink-0">
                        <Mail className="w-3.5 h-3.5 text-blue-500" />
                      </div>
                      <span className="font-medium break-all mt-0.5 leading-snug">{member.email}</span>
                    </div>
                    <div className="flex items-start gap-3 text-sm text-gray-600">
                      <div className="p-1.5 bg-white rounded-md shadow-sm border border-gray-100 shrink-0">
                        <Phone className="w-3.5 h-3.5 text-blue-500" />
                      </div>
                      <span className="font-medium mt-0.5 leading-snug">{member.phone_no}</span>
                    </div>
                  </div>

                  {hasAwards && (
                    <div className="pt-2 flex-1 flex flex-col">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="h-px flex-1 bg-gray-100"></div>
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                          Nominated Awards ({member.awards.length})
                        </span>
                        <div className="h-px flex-1 bg-gray-100"></div>
                      </div>
                      <div className="flex flex-col gap-2.5">
                        {member.awards.map((award, idx) => (
                          <div
                            key={idx}
                            className="flex items-start gap-3 bg-white p-3 rounded-xl border border-amber-100 shadow-sm hover:border-amber-300 hover:shadow-md transition-all group/award"
                          >
                            <div className="p-1.5 bg-amber-50 rounded-lg group-hover/award:bg-amber-100 transition-colors">
                              <Trophy className="w-4 h-4 text-amber-500 shrink-0" />
                            </div>
                            <div className="flex flex-col flex-1 min-w-0 justify-center">
                              <span className="text-sm font-bold text-gray-700 leading-tight group-hover/award:text-amber-700 transition-colors">
                                {award.award_name}
                              </span>
                              {award.type && (
                                <span className="text-[10px] uppercase font-bold text-amber-600 tracking-wider mt-1">
                                  {award.type}
                                </span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};


// ─────────────────────────────────────────────────────────────────────────────
// 1 Million Internship Milestone Tab
// API note: /institute-submissions returns ONE row per image, so we group rows
// by submission_id on the frontend. Reupload is per-image via image_id.
// ─────────────────────────────────────────────────────────────────────────────
export const MilestoneTab = () => {
  const [rawRows, setRawRows] = useState([]);
  const [milestoneLoading, setMilestoneLoading] = useState(true);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [reuploadSubmitting, setReuploadSubmitting] = useState(false);
  const [downloadLoadingId, setDownloadLoadingId] = useState(null);
  const [certModal, setCertModal] = useState(null);
  const [certPreviewModalData, setCertPreviewModalData] = useState(null);
  const [certLoadingType, setCertLoadingType] = useState(null);
  const [highlightedSection, setHighlightedSection] = useState(null);

  const scrollToSection = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setHighlightedSection(sectionId);
      setTimeout(() => setHighlightedSection(null), 2000);
    }
  };
  const [viewLoadingKey, setViewLoadingKey] = useState(null);
  const [viewModalData, setViewModalData] = useState(null);
  const [confirmModal, setConfirmModal] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [shareLinks, setShareLinks] = useState([""]); // New state for dynamic links
  const [reuploadFile, setReuploadFile] = useState({});
  const [reuploadLinks, setReuploadLinks] = useState({});
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const fileInputRef = React.useRef(null);
  const reuploadRefs = React.useRef({});

  const getToken = () => localStorage.getItem("accessToken");

  const fetchSubmissions = async () => {
    try {
      setMilestoneLoading(true);
      setError(null);
      const res = await api.get(`${BASE_URL}/awards/institute-submissions`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      setRawRows(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to load submissions.");
    } finally {
      setMilestoneLoading(false);
    }
  };

  useEffect(() => { fetchSubmissions(); }, []);

  const grouped = React.useMemo(() => {
    const map = new Map();
    rawRows.forEach((row) => {
      const sid = row.submission_id;
      if (!map.has(sid)) {
        map.set(sid, {
          submission_id: sid,
          award_id: row.award_id,
          award_name: row.award_name,
          status: (row.status || "").toLowerCase(),
          reason: row.reason,
          images: [],
          media_links: row.media_links || [],
        });
      }
      const existing = map.get(sid);
      if (Array.isArray(row.images) && row.images.length > 0) {
        row.images.forEach((img, idx) => {
          existing.images.push({
            image_id: img.image_id,
            image_key: img.image_key,
            sequence_no: img.sequence_no ?? (idx + 1),
          });
        });
      } else if (row.image_key) {
        existing.images.push({
          image_id: row.image_id,
          image_key: row.image_key,
          sequence_no: row.sequence_no,
        });
      }
    });
    return Array.from(map.values());
  }, [rawRows]);

  const handleFileSelection = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    setSelectedFiles((prev) => {
      // Avoid duplicate files based on name and size
      const existingKeys = new Set(prev.map((f) => `${f.name}_${f.size}`));
      const uniqueNew = files.filter((f) => !existingKeys.has(`${f.name}_${f.size}`));
      const combined = [...prev, ...uniqueNew];
      if (combined.length > 3) {
        setConfirmModal({
          title: "File Limit Reached",
          message: "You can only choose up to 3 files. Please select fewer files.",
          confirmText: "Got it",
          isAlert: true,
          action: null
        });
        return prev;
      }
      return combined;
    });

    // Reset input value so selecting the same file again triggers onChange
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleRemoveSelectedFile = (indexToRemove) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== indexToRemove));
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleAddShareLink = () => {
    if (shareLinks.length < 3) {
      setShareLinks([...shareLinks, ""]);
    }
  };

  const handleShareLinkChange = (index, value) => {
    const newLinks = [...shareLinks];
    newLinks[index] = value;
    setShareLinks(newLinks);
  };

  const handleRemoveShareLink = (index) => {
    if (shareLinks.length > 1) {
       const newLinks = shareLinks.filter((_, i) => i !== index);
       setShareLinks(newLinks);
    }
  };

  const handleUpload = async () => {
    if (!selectedFiles.length) {
      setError("Please select at least one screenshot to upload.");
      return;
    }
    const validLinks = shareLinks.map(l => l.trim()).filter(l => l !== "");
    if (validLinks.length === 0) {
      setError("Please provide at least one Share & Repost link.");
      return;
    }
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
    const invalidLinks = validLinks.filter(link => !urlPattern.test(link));
    if (invalidLinks.length > 0) {
      setError("Please ensure that all provided links are valid URLs.");
      return;
    }
    if (validLinks.length > 3) {
      setError("You can only provide a maximum of 3 links.");
      return;
    }

    setConfirmModal({
      title: "Confirm Upload",
      message: "Are you sure you want to upload the image(s) and link(s)?",
      confirmText: "Confirm",
      action: async () => {
        setConfirmModal(null);
        try {
          setUploadLoading(true);
          setError(null);
          setSuccessMsg(null);
          
          // 1. Get presigned URLs
          const presignedRes = await api.get(`${BASE_URL}/awards/upload/screenshots/presigned-urls?count=${selectedFiles.length}`, {
            headers: { Authorization: `Bearer ${getToken()}` },
          });
          const presignedData = presignedRes.data;
          
          if (!presignedData || presignedData.length !== selectedFiles.length) {
            throw new Error("Failed to generate correct number of upload URLs");
          }
          
          const s3Keys = [];
          
          // 2. Upload to S3 directly
          for (let i = 0; i < selectedFiles.length; i++) {
            const file = selectedFiles[i];
            const { upload_url, s3_key } = presignedData[i];
            
            const uploadRes = await fetch(upload_url, {
              method: "PUT",
              body: file,
              headers: { "Content-Type": file.type },
            });
            
            if (!uploadRes.ok) {
              throw new Error(`Failed to upload ${file.name} to storage.`);
            }
            s3Keys.push(s3_key);
          }

          // 3. Submit data to backend using JSON stringified arrays
          const formData = new FormData();
          if (s3Keys.length > 0) {
            formData.append("s3_keys", JSON.stringify(s3Keys));
          }
          if (validLinks && validLinks.length > 0) {
            formData.append("media_links", JSON.stringify(validLinks));
          }

          await api.post(`${BASE_URL}/awards/upload/screenshots`, formData, {
            headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
          });
          setSelectedFiles([]);
          setShareLinks([""]); // Reset links
          if (fileInputRef.current) fileInputRef.current.value = "";
          setSuccessMsg("Screenshots and links submitted successfully!");
          await fetchSubmissions();
        } catch (err) {
          setError(err.response?.data?.detail || "Upload failed.");
        } finally {
          setUploadLoading(false);
        }
      }
    });
  };

  const handleReuploadAll = async (sub) => {
    const selectedEntries = (sub.images || [])
      .filter((img) => !!reuploadFile[img.image_id])
      .map((img) => ({
        imageId: img.image_id,
        file: reuploadFile[img.image_id],
      }));

    const editedLinks = reuploadLinks[sub.submission_id];
    let validLinksForReupload = [];
    if (editedLinks) {
       validLinksForReupload = editedLinks.map(l => (typeof l === 'string' ? l.trim() : "")).filter(l => l !== "");
       if (validLinksForReupload.length === 0) {
          setError("Please provide at least one Share & Repost link.");
          return;
       }
       const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
       const invalidLinks = validLinksForReupload.filter(link => !urlPattern.test(link));
       if (invalidLinks.length > 0) {
          setError("Please ensure that all edited links are valid URLs.");
          return;
       }
    }

    if (selectedEntries.length === 0 && !editedLinks) return;
    
    setConfirmModal({
      title: "Confirm Re-upload",
      message: "Are you sure you want to submit your changes?",
      confirmText: "Submit",
      action: async () => {
        setConfirmModal(null);
        const MAX_FILE_SIZE = 2 * 1024 * 1024;
        for (const { file } of selectedEntries) {
          if (file.size > MAX_FILE_SIZE) {
            setError(`File "${file.name}" exceeds the 2 MB limit (${(file.size / (1024 * 1024)).toFixed(2)} MB). Please choose a smaller file.`);
            return;
          }
        }

        try {
          setReuploadSubmitting(true);
          setError(null);
          setSuccessMsg(null);
          
          let uploadedS3Keys = [];
          let imageIds = [];

          if (selectedEntries.length > 0) {
            // 1. Get presigned URLs for replacement images
            const presignedRes = await api.get(`${BASE_URL}/awards/upload/screenshots/presigned-urls?count=${selectedEntries.length}`, {
              headers: { Authorization: `Bearer ${getToken()}` },
            });
            const presignedData = presignedRes.data;
            
            if (!presignedData || presignedData.length !== selectedEntries.length) {
              throw new Error("Failed to generate replacement upload URLs");
            }
            
            // 2. Upload replacements directly to S3
            for (let i = 0; i < selectedEntries.length; i++) {
              const { imageId, file } = selectedEntries[i];
              const { upload_url, s3_key } = presignedData[i];
              
              const uploadRes = await fetch(upload_url, {
                method: "PUT",
                body: file,
                headers: { "Content-Type": file.type },
              });
              
              if (!uploadRes.ok) {
                throw new Error(`Failed to upload ${file.name} to storage.`);
              }
              
              imageIds.push(imageId);
              uploadedS3Keys.push(s3_key);
            }
          }

          // 3. Submit data to backend using repeated appends
          const formData = new FormData();
          if (selectedEntries.length > 0) {
            const numericImageIds = imageIds.map(id => parseInt(id, 10));
            formData.append("image_ids", JSON.stringify(numericImageIds));
            formData.append("s3_keys", JSON.stringify(uploadedS3Keys));
          }
          
          if (editedLinks) {
             formData.append("media_links", JSON.stringify(validLinksForReupload));
          }

          const res = await api.put(`${BASE_URL}/awards/reupload/screenshots`, formData, {
            headers: {
              Authorization: `Bearer ${getToken()}`,
              "Content-Type": "multipart/form-data",
            },
          });

          setReuploadFile((prev) => {
            const next = { ...prev };
            selectedEntries.forEach(({ imageId }) => {
              delete next[imageId];
              if (reuploadRefs.current[imageId]) {
                reuploadRefs.current[imageId].value = "";
              }
            });
            return next;
          });

          setSuccessMsg(res.data?.message || `${selectedEntries.length} screenshot(s) re-uploaded successfully. Submission is now pending review.`);
          await fetchSubmissions();
        } catch (err) {
          console.error("Re-upload error:", err);
          setError(err.response?.data?.detail || "Re-upload failed. Please try again.");
        } finally {
          setReuploadSubmitting(false);
        }
      }
    });

  };

  const handleCertSelect = async (certType) => {
    const submissionId = certModal;
    if (!submissionId) return;
    try {
      setCertLoadingType(certType);
      setError(null);
      const res = await api.get(
        `${BASE_URL}/awards/get-certificate?cert_type=${certType}`,
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      const { cert_base64 } = res.data;
      setCertModal(null);
      setCertPreviewModalData({
        certBase64: cert_base64,
        certType: certType,
        submissionId: submissionId,
      });
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to load certificate preview.");
    } finally {
      setCertLoadingType(null);
    }
  };

  const handleDownloadCertPreview = () => {
    if (!certPreviewModalData) return;
    const { certBase64, certType, submissionId } = certPreviewModalData;
    const link = document.createElement("a");
    const imgSrc = certBase64.startsWith("data:")
      ? certBase64
      : `data:image/png;base64,${certBase64}`;
    link.href = imgSrc;
    link.download = `certificate_${submissionId}_${certType}.png`;
    link.click();
  };

  const handleViewImage = async (s3Key) => {
    try {
      setViewLoadingKey(s3Key);
      setError(null);
      const res = await api.get(
        `${BASE_URL}/awards/image-url?s3_key=${encodeURIComponent(s3Key)}`,
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      setViewModalData({ url: res.data.url });
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to load image.");
    } finally {
      setViewLoadingKey(null);
    }
  };

  const statusBadge = (status) => {
    const cfg = {
      pending: { cls: "bg-amber-50 text-amber-700 border-amber-200", label: "⏳ Pending Review" },
      approved: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "✅ Approved" },
      rejected: { cls: "bg-red-50 text-red-700 border-red-200", label: "❌ Rejected" },
    };
    const c = cfg[status] || { cls: "bg-gray-100 text-gray-600 border-gray-200", label: status };
    return (
      <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${c.cls}`}>
        {c.label}
      </span>
    );
  };

  if (milestoneLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-500 rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500 text-sm">Loading submissions...</p>
        </div>
      </div>
    );
  }

  const hasActiveSubmission = grouped.some((s) => s.status === "pending" || s.status === "approved");
  const hasRejected = grouped.some((s) => s.status === "rejected");

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col gap-5">
        <div className="flex items-start gap-4 px-2">
          <div className="p-3 bg-[#fff6ef] rounded-2xl shrink-0 mt-1">
            <Trophy className="w-8 h-8 text-amber-500 fill-amber-500" />
          </div>
          <div>
            <h3 className="font-extrabold text-[#1a2b5f] text-2xl tracking-tight">1 Million Internship Milestone Award</h3>
            <p className="text-slate-500 text-[13.5px] mt-1.5 leading-relaxed max-w-4xl font-medium">
              Certificate will be issued to each College and its respective SPOC after posting meaningful feedback on our <a href="https://www.linkedin.com/posts/eduskillsfoundation_1millionstrong-aicte-eduskills-activity-7497901960206008321-keYa?utm_source=social_share_send&utm_medium=android_app&rcm=ACoAAEKxaaQBxQ6oNLkPARCONMMannaH4cC51ts&utm_campaign=copy_link" target="_blank" rel="noopener noreferrer" className="text-blue-600 font-bold underline hover:text-blue-800">“1 Million Virtual Internships”</a> post.
            </p>
          </div>
        </div>

        {!hasActiveSubmission && (
          <div className="bg-[#f0f6ff] border border-blue-50 rounded-3xl p-5">
            <div className="flex items-center gap-2 mb-4 px-1">
              <div className="p-1.5 bg-[#4e80ee] rounded-full text-white shadow-sm">
                <ClipboardList className="w-4 h-4" />
              </div>
              <h4 className="font-bold text-[#1a2b5f] text-[15px]">To claim your certificate, please submit the following details:</h4>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div 
                className="bg-white/80 border border-blue-50 rounded-xl py-2 px-3 flex gap-2.5 items-center cursor-pointer hover:bg-blue-50 transition-colors shadow-sm hover:shadow-md" 
                onClick={() => scrollToSection('upload-screenshots')}
              >
                <div className="w-7 h-7 bg-[#e8f1ff] rounded-full flex items-center justify-center shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5 text-blue-500">
                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
                    <circle cx="9" cy="9" r="2"/>
                    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
                  </svg>
                </div>
                <div className="flex flex-col text-left">
                  <span className="bg-blue-100 text-blue-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full w-fit mb-0.5">Step 1</span>
                  <p className="font-bold text-[#1a2b5f] text-[12px] leading-tight">Screenshot of the posted feedback</p>
                </div>
              </div>

              <div 
                className="bg-[#fff6ef] rounded-xl py-2 px-3 flex gap-2.5 items-center cursor-pointer hover:bg-orange-50 transition-colors shadow-sm hover:shadow-md"
                onClick={() => scrollToSection('share-repost-links')}
              >
                <div className="w-7 h-7 bg-white rounded-full flex items-center justify-center shrink-0">
                  <Link className="w-3.5 h-3.5 text-orange-500 stroke-[2.5]" />
                </div>
                <div className="flex flex-col text-left">
                  <span className="bg-orange-100 text-orange-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full w-fit mb-0.5">Step 2</span>
                  <p className="font-bold text-[#1a2b5f] text-[12px] leading-tight">Link to your posted feedback</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Alerts */}
      {error && (
        <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
          <span className="text-red-500 text-lg leading-none mt-0.5">⚠️</span>
          <p className="text-red-700 text-sm font-medium flex-1">{error}</p>
          <button onClick={() => setError(null)} className="text-red-400 hover:text-red-600"><X className="w-4 h-4" /></button>
        </div>
      )}
      {successMsg && (
        <div className="flex items-start gap-3 bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-3">
          <span className="text-emerald-500 text-lg leading-none mt-0.5">✅</span>
          <p className="text-emerald-700 text-sm font-medium flex-1">{successMsg}</p>
          <button onClick={() => setSuccessMsg(null)} className="text-emerald-400 hover:text-emerald-600"><X className="w-4 h-4" /></button>
        </div>
      )}

      {/* First-time upload — shown only when no submissions exist */}
      {!hasActiveSubmission && !hasRejected && (
        <div className="bg-white rounded-2xl border-2 border-dashed border-indigo-300 p-6 shadow-sm">
          <div 
            id="upload-screenshots" 
            className={`transition-all duration-700 rounded-xl p-3 -mx-3 ${
              highlightedSection === 'upload-screenshots' 
                ? 'border border-indigo-200 ring-4 ring-indigo-100 bg-indigo-50/50 scale-[1.01]' 
                : 'border border-transparent'
            }`}
          >
          <h4 className="font-semibold text-gray-800 mb-3 text-sm flex items-center gap-2">
            <Upload className="w-4 h-4 text-indigo-500" />
            Upload Screenshots
            <span className="text-gray-400 font-normal text-xs">(max 2 MB each)</span>
          </h4>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            multiple
            onChange={handleFileSelection}
            className="block w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-xl file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 transition-all cursor-pointer"
          />
          {selectedFiles.length > 0 && (
            <div className="mt-3 space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-gray-600">
                  Selected Images ({selectedFiles.length}):
                </span>
                <button
                  type="button"
                  onClick={() => {
                    setSelectedFiles([]);
                    if (fileInputRef.current) fileInputRef.current.value = "";
                  }}
                  className="text-xs text-red-500 hover:text-red-700 font-medium transition-colors"
                >
                  Clear all
                </button>
              </div>
              <div className="flex flex-wrap gap-2">
                {selectedFiles.map((f, i) => (
                  <span
                    key={`${f.name}-${f.size}-${i}`}
                    className="inline-flex items-center gap-1.5 text-xs bg-indigo-50 text-indigo-700 border border-indigo-200 pl-2.5 pr-1.5 py-1 rounded-lg font-medium shadow-sm hover:border-indigo-300 transition-all"
                  >
                    <FileText className="w-3.5 h-3.5 shrink-0 text-indigo-600" />
                    <span className="max-w-[200px] truncate" title={f.name}>{f.name}</span>
                    <span className="text-[10px] text-indigo-500 font-normal">
                      ({(f.size / (1024 * 1024)).toFixed(2)} MB)
                    </span>
                    <button
                      type="button"
                      onClick={() => handleRemoveSelectedFile(i)}
                      className="p-1 text-indigo-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
                      title="Remove this image"
                    >
                      <X className="w-3.5 h-3.5" />
                    </button>
                  </span>
                ))}
              </div>
            </div>
          )}
          </div>

          {/* Share & Repost Links */}
          <div 
            id="share-repost-links" 
            className={`mt-6 pt-4 border-t transition-all duration-700 rounded-xl p-3 -mx-3 ${
              highlightedSection === 'share-repost-links' 
                ? 'border-indigo-200 ring-4 ring-indigo-100 bg-indigo-50/50 scale-[1.01]' 
                : 'border-indigo-100'
            }`}
          >
            <h4 className="font-semibold text-gray-800 mb-3 text-sm">
              Share & Repost links <span className="text-red-500">*</span>
              <span className="text-gray-400 font-normal text-xs ml-2">(Max 3)</span>
            </h4>
            <div className="space-y-3">
              {shareLinks.map((link, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <input
                    type="url"
                    value={link}
                    onChange={(e) => handleShareLinkChange(idx, e.target.value)}
                    placeholder="https://..."
                    className="flex-1 text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-indigo-400 transition-all"
                  />
                  {idx === shareLinks.length - 1 && shareLinks.length < 3 && (
                    <button
                      type="button"
                      onClick={handleAddShareLink}
                      className="p-2 bg-indigo-50 text-indigo-600 hover:bg-indigo-100 rounded-lg transition-colors"
                      title="Add another link"
                    >
                      <span className="font-bold">+</span>
                    </button>
                  )}
                  {shareLinks.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemoveShareLink(idx)}
                      className="p-2 bg-red-50 text-red-600 hover:bg-red-100 rounded-lg transition-colors border border-red-200"
                      title="Remove link"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={handleUpload}
            disabled={(!selectedFiles.length && shareLinks.filter(l => l.trim()).length === 0) || uploadLoading}
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white text-sm font-semibold rounded-xl transition-colors"
          >
            {uploadLoading && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />}
            {uploadLoading ? "Uploading..." : `Submit`}
          </button>
        </div>
      )}

      {/* Submissions list */}
      {grouped.length > 0 && (
        <div className="space-y-5">
          <h4 className="font-semibold text-gray-700 text-sm">Your Submissions</h4>
          {grouped.map((sub) => (
            <div
              key={sub.submission_id}
              className={`bg-white rounded-2xl border shadow-sm overflow-hidden ${sub.status === "rejected" ? "border-red-200" :
                sub.status === "approved" ? "border-emerald-200" : "border-gray-200"
                }`}
            >
              {/* Card header */}
              <div className={`flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-b ${sub.status === "rejected" ? "bg-red-50/50 border-red-100" :
                sub.status === "approved" ? "bg-emerald-50/50 border-emerald-100" :
                  "bg-gray-50/60 border-gray-100"
                }`}>
                <div>
                  <p className="font-bold text-gray-800 text-sm">{sub.award_name}</p>
                  <p className="text-xs text-gray-400 mt-0.5">Submission #{sub.submission_id}</p>
                </div>
                {statusBadge(sub.status)}
              </div>

              <div className="p-5 space-y-4">
                {/* Rejection reason */}
                {sub.status === "rejected" && sub.reason && (
                  <div className="bg-red-50 border border-red-100 rounded-xl px-4 py-3">
                    <p className="text-xs font-semibold text-red-600 mb-1">Rejection Reason:</p>
                    <p className="text-sm text-red-700">{sub.reason}</p>
                  </div>
                )}

                {/* Pending info */}
                {sub.status === "pending" && (
                  <div className="bg-amber-50 border border-amber-100 rounded-xl px-4 py-3">
                    <p className="text-xs text-amber-700">
                      Your submission is under review. Upload and re-upload are disabled while status is <strong>pending</strong>.
                    </p>
                  </div>
                )}

                {/* Media Links Display & Editor */}
                {sub.media_links && sub.media_links.length > 0 && (
                  <div className="space-y-3 pb-2">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      Share Links
                    </p>
                    {sub.status === "rejected" ? (
                      <div className="space-y-3 pt-1">
                        {(reuploadLinks[sub.submission_id] || sub.media_links).map((link, idx) => (
                          <div key={idx} className="flex flex-col sm:flex-row sm:items-center gap-2">
                            <input
                              type="url"
                              value={link}
                              onChange={(e) => {
                                const currentLinks = reuploadLinks[sub.submission_id] || [...sub.media_links];
                                const updated = [...currentLinks];
                                updated[idx] = e.target.value;
                                setReuploadLinks(prev => ({ ...prev, [sub.submission_id]: updated }));
                              }}
                              placeholder="https://..."
                              className="flex-1 text-sm text-gray-700 bg-gray-50 border border-orange-200 rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-orange-400 transition-all font-medium"
                            />
                            <div className="flex items-center gap-2">
                              {idx === (reuploadLinks[sub.submission_id] || sub.media_links).length - 1 && (reuploadLinks[sub.submission_id] || sub.media_links).length < 3 && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    const currentLinks = reuploadLinks[sub.submission_id] || [...sub.media_links];
                                    setReuploadLinks(prev => ({ ...prev, [sub.submission_id]: [...currentLinks, ""] }));
                                  }}
                                  className="p-2 bg-orange-50 text-orange-600 hover:bg-orange-100 rounded-lg transition-colors border border-orange-200"
                                  title="Add another link"
                                >
                                  <span className="font-bold">+</span>
                                </button>
                              )}
                              {(reuploadLinks[sub.submission_id] || sub.media_links).length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    const currentLinks = reuploadLinks[sub.submission_id] || [...sub.media_links];
                                    const updated = currentLinks.filter((_, i) => i !== idx);
                                    setReuploadLinks(prev => ({ ...prev, [sub.submission_id]: updated }));
                                  }}
                                  className="p-2 bg-red-50 text-red-600 hover:bg-red-100 rounded-lg transition-colors border border-red-200"
                                  title="Remove link"
                                >
                                  <X className="w-4 h-4" />
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex flex-col sm:flex-row flex-wrap gap-2.5">
                        {(Array.isArray(sub.media_links) ? sub.media_links : typeof sub.media_links === "string" ? sub.media_links.split(",") : []).map((link, idx) => (
                          <a
                            key={idx}
                            href={link.trim().startsWith("http") ? link.trim() : `https://${link.trim()}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 text-xs bg-indigo-50 text-indigo-700 border border-indigo-200 px-3 py-2 rounded-lg font-medium shadow-sm hover:border-indigo-300 transition-all hover:bg-indigo-100"
                            title={link.trim()}
                          >
                            <Link className="w-4 h-4 shrink-0 text-indigo-600" />
                            <span className="truncate max-w-[350px]">{link.trim()}</span>
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Images */}
                {sub.images.length > 0 && (
                  <div className="space-y-3">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      Uploaded Images ({sub.images.length})
                    </p>
                    {sub.images.map((img, idx) => {
                      const stagedFile = reuploadFile[img.image_id];
                      return (
                        <div
                          key={img.image_id}
                          className={`bg-gray-50 border rounded-xl p-4 space-y-2.5 transition-all ${
                            stagedFile ? "border-orange-300 bg-orange-50/40 ring-1 ring-orange-200" : "border-gray-100"
                          }`}
                        >
                          {/* Image row top */}
                          <div className="flex items-center justify-between gap-3 flex-wrap">
                            <div className="flex items-center gap-2 min-w-0">
                              <div
                                className={`w-7 h-7 rounded-lg flex items-center justify-center shrink-0 ${
                                  stagedFile ? "bg-orange-100 text-orange-600" : "bg-blue-100 text-blue-600"
                                }`}
                              >
                                <FileText className="w-3.5 h-3.5" />
                              </div>
                              <div className="min-w-0">
                                <p className="text-xs font-semibold text-gray-700">
                                  Image {img.sequence_no ?? (idx + 1)}
                                </p>
                                <p className="text-[10px] text-gray-400 font-mono truncate max-w-[180px]">
                                  {img.image_key?.split("/").pop()}
                                </p>
                              </div>
                            </div>

                            <div className="flex items-center gap-2">
                              {/* View button — lazy */}
                              <button
                                type="button"
                                onClick={() => handleViewImage(img.image_key)}
                                disabled={viewLoadingKey === img.image_key}
                                className="shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100 transition-colors disabled:opacity-60"
                              >
                                {viewLoadingKey === img.image_key ? (
                                  <span className="w-3.5 h-3.5 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
                                ) : (
                                  <Eye className="w-3.5 h-3.5" />
                                )}
                                View
                              </button>

                              {/* Re-upload button with icon (shown when status is rejected) */}
                              {sub.status === "rejected" && (
                                <>
                                  <input
                                    ref={(el) => (reuploadRefs.current[img.image_id] = el)}
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={(e) =>
                                      setReuploadFile((prev) => ({
                                        ...prev,
                                        [img.image_id]: e.target.files?.[0] || null,
                                      }))
                                    }
                                  />
                                  <button
                                    type="button"
                                    onClick={() => reuploadRefs.current[img.image_id]?.click()}
                                    className={`shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg border transition-colors ${
                                      stagedFile
                                        ? "bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200"
                                        : "bg-orange-50 text-orange-600 border-orange-200 hover:bg-orange-100"
                                    }`}
                                  >
                                    <Upload className="w-3.5 h-3.5" />
                                    {stagedFile ? "Change File" : "Re-upload"}
                                  </button>
                                </>
                              )}
                            </div>
                          </div>

                          {/* Staged replacement preview */}
                          {sub.status === "rejected" && stagedFile && (
                            <div className="pt-2 border-t border-orange-200/80 flex items-center justify-between gap-2 bg-orange-100/60 px-3 py-1.5 rounded-lg">
                              <div className="flex items-center gap-2 min-w-0">
                                <span className="text-[10px] font-bold uppercase tracking-wider text-orange-700 bg-orange-200 px-1.5 py-0.5 rounded">
                                  Staged
                                </span>
                                <p className="text-xs font-semibold text-orange-900 truncate max-w-[200px] sm:max-w-[320px]">
                                  {stagedFile.name}
                                </p>
                                <span className="text-[10px] text-orange-600 font-normal">
                                  ({(stagedFile.size / (1024 * 1024)).toFixed(2)} MB)
                                </span>
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  setReuploadFile((prev) => {
                                    const n = { ...prev };
                                    delete n[img.image_id];
                                    return n;
                                  });
                                  if (reuploadRefs.current[img.image_id]) {
                                    reuploadRefs.current[img.image_id].value = "";
                                  }
                                }}
                                className="p-1 text-orange-500 hover:text-red-600 hover:bg-orange-200 rounded transition-colors"
                                title="Remove selection"
                              >
                                <X className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })}

                    {/* Batch re-upload submit bar */}
                    {sub.status === "rejected" && (() => {
                      const reuploadedCount = sub.images.filter((img) => !!reuploadFile[img.image_id]).length;
                      const hasEditedLinks = !!reuploadLinks[sub.submission_id];
                      return (
                        <div className="mt-4 bg-orange-50 border border-orange-200 rounded-xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 shadow-sm">
                          <div>
                            <p className="text-xs font-bold text-orange-900">
                              Re-upload Changes
                            </p>
                            <p className="text-xs text-orange-700 mt-0.5">
                              {reuploadedCount} image{sub.images.length !== 1 ? "s" : ""} selected for replacement {hasEditedLinks && " • Links edited"}
                            </p>
                          </div>
                          <button
                            type="button"
                            onClick={() => handleReuploadAll(sub)}
                            disabled={(reuploadedCount === 0 && !hasEditedLinks) || reuploadSubmitting}
                            className="inline-flex items-center gap-2 px-5 py-2.5 bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white text-xs sm:text-sm font-bold rounded-xl transition-all shadow-sm shrink-0 cursor-pointer disabled:cursor-not-allowed"
                          >
                            {reuploadSubmitting ? (
                              <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                            ) : (
                              <Upload className="w-4 h-4" />
                            )}
                            {reuploadSubmitting
                              ? "Submitting Re-uploads..."
                              : `Confirm & Submit Re-uploads`}
                          </button>
                        </div>
                      );
                    })()}
                  </div>
                )}

                {/* Download certificate */}
                {sub.status === "approved" && (
                  <div className="pt-1">
                    <button
                      onClick={() => setCertModal(sub.submission_id)}
                      disabled={downloadLoadingId === sub.submission_id}
                      className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white text-sm font-semibold rounded-xl transition-colors"
                    >
                      {downloadLoadingId === sub.submission_id ? (
                        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      ) : (
                        <Trophy className="w-4 h-4" />
                      )}
                      {downloadLoadingId === sub.submission_id ? "Downloading..." : "Download"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}



      {/* Certificate Select Modal */}
      {certModal &&
        createPortal(
          <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
            style={{ zIndex: 999999 }}
            onClick={() => setCertModal(null)}
          >
            <div
              className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8 max-h-[85vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-xl flex items-center justify-center">
                    <FileText className="w-6 h-6" /> 
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-xl">Certificate Preview</h3>
                    <p className="text-sm text-gray-500 mt-1">Please select the certificate type you want to preview.</p>
                  </div>
                </div>
                <button 
                  onClick={() => setCertModal(null)}
                  className="text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition-colors flex items-center justify-center"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Institute Certificate */}
                <div className="border border-emerald-100 bg-emerald-50/30 rounded-2xl p-6 flex flex-col items-center text-center">
                  <div className="w-14 h-14 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl" style={{ lineHeight: 1 }}>🏦</span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">Institute Certificate</h4>
                  {/* <p className="text-sm text-gray-500 mb-6 flex-grow">Preview the certificate issued by the institute.</p> */}
                  <button
                    onClick={() => handleCertSelect("institute")}
                    disabled={!!certLoadingType}
                    className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-xl transition-colors flex items-center justify-center gap-2 disabled:opacity-50 cursor-pointer"
                  >
                    {certLoadingType === "institute" ? (
                      <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    ) : (
                      <Eye className="w-4 h-4" />
                    )}
                    {certLoadingType === "institute" ? "Loading Preview..." : "Preview Institute Certificate"}
                  </button>
                </div>

                {/* Educator Certificate */}
                <div className="border border-blue-100 bg-blue-50/30 rounded-2xl p-6 flex flex-col items-center text-center">
                  <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl" style={{ lineHeight: 1 }}>🎓</span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">Faculty Certificate</h4>
                  {/* <p className="text-sm text-gray-500 mb-6 flex-grow">Preview the certificate issued by the faculty.</p> */}
                  <button
                    onClick={() => handleCertSelect("educator")}
                    disabled={!!certLoadingType}
                    className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors flex items-center justify-center gap-2 disabled:opacity-50 cursor-pointer"
                  >
                    {certLoadingType === "educator" ? (
                      <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    ) : (
                      <Eye className="w-4 h-4" />
                    )}
                    {certLoadingType === "educator" ? "Loading Preview..." : "Preview Faculty Certificate"}
                  </button>
                </div>
              </div>

              <div className="mt-8 flex justify-end">
                <button
                  onClick={() => setCertModal(null)}
                  className="px-6 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors bg-white shadow-sm"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}

      {/* Certificate Preview Modal */}
      {certPreviewModalData &&
        createPortal(
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center p-4 sm:p-6"
            style={{ zIndex: 999999 }}
            onClick={() => setCertPreviewModalData(null)}
          >
            <div
              className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[85vh] flex flex-col overflow-hidden my-auto"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Upper Bar: Back button on top left, Close on top right */}
              <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50/80">
                <button
                  onClick={() => {
                    const subId = certPreviewModalData.submissionId;
                    setCertPreviewModalData(null);
                    setCertModal(subId);
                  }}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold text-gray-700 bg-white border border-gray-200 hover:bg-gray-100 transition-colors shadow-sm cursor-pointer"
                >
                  <ArrowLeft className="w-4 h-4 text-gray-600" />
                  Back
                </button>

                <button
                  onClick={() => setCertPreviewModalData(null)}
                  className="text-gray-400 hover:text-gray-600 p-1.5 rounded-lg hover:bg-gray-200/60 transition-colors flex items-center justify-center cursor-pointer"
                  title="Close"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {/* Certificate Image Body */}
              <div className="overflow-auto p-4 sm:p-6 flex items-center justify-center bg-gray-100 flex-1 min-h-[300px]">
                <img
                  src={
                    certPreviewModalData.certBase64.startsWith("data:")
                      ? certPreviewModalData.certBase64
                      : `data:image/png;base64,${certPreviewModalData.certBase64}`
                  }
                  alt="Certificate Preview"
                  className="max-w-full max-h-[65vh] object-contain rounded-xl shadow-lg border border-gray-200"
                />
              </div>

              {/* Modal Footer / Actions */}
              <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 bg-white">
                <button
                  onClick={() => setCertPreviewModalData(null)}
                  className="px-5 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  Close
                </button>
                <button
                  onClick={handleDownloadCertPreview}
                  className="px-6 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold rounded-xl transition-colors flex items-center gap-2 shadow-sm cursor-pointer"
                >
                  <Download className="w-4 h-4" />
                  Download
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}

      {/* Confirm modal popup */}
      {confirmModal && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
          style={{ zIndex: 60002 }}
          onClick={() => setConfirmModal(null)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              <h3 className="font-bold text-gray-900 text-lg">{confirmModal.title}</h3>
              <p className="text-sm text-gray-500 mt-2 leading-relaxed">{confirmModal.message}</p>
            </div>
            <div className="flex justify-end gap-3 mt-6">
              {!confirmModal.isAlert && (
                <button
                  onClick={() => setConfirmModal(null)}
                  className="px-4 py-2 border border-gray-200 rounded-xl text-sm text-gray-700 hover:bg-gray-50 font-medium transition-colors"
                >
                  Cancel
                </button>
              )}
              <button
                onClick={() => {
                  if (confirmModal.action) confirmModal.action();
                  else setConfirmModal(null);
                }}
                className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-bold rounded-xl transition-colors"
              >
                {confirmModal.confirmText}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Image view modal */}
      {viewModalData && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
          style={{ zIndex: 60000 }}
          onClick={() => setViewModalData(null)}
        >
          <div
            className="relative bg-white rounded-2xl shadow-2xl overflow-hidden max-w-3xl w-full max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
              <p className="text-sm font-semibold text-gray-700">Submission Screenshot</p>
              <button
                onClick={() => setViewModalData(null)}
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="overflow-auto p-4 flex items-center justify-center bg-gray-50" style={{ maxHeight: "calc(90vh - 60px)" }}>
              <img src={viewModalData.url} alt="Submission screenshot" className="max-w-full max-h-full rounded-xl shadow object-contain" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const ParticipatingCertificateTab = ({ certEligibility }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  // Helper: convert base64 string to a Blob URL
  const base64ToBlobUrl = (base64, mimeType) => {
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      return URL.createObjectURL(blob);
    } catch (e) {
      console.error("Failed to convert base64 to blob:", e);
      return null;
    }
  };

  const handleDownload = async (certType) => {
    try {
      setIsProcessing(certType);
      const accessToken = localStorage.getItem("accessToken");
      const res = await api.get(`${BASE_URL}/awards/get-event-participation-cert?cert_type=${certType}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (res.data && res.data.certificate) {
        let certData = res.data.certificate;
        let downloadUrl = '';
        let ext = 'png';

        if (certData.startsWith('http')) {
          downloadUrl = certData;
          ext = certData.endsWith('.pdf') ? 'pdf' : 'png';
        } else if (certData.startsWith('data:')) {
          downloadUrl = certData;
          ext = certData.startsWith('data:application/pdf') ? 'pdf' : 'png';
        } else {
          // Raw base64 - detect type
          let mimeType = 'image/png';
          if (certData.startsWith('JVBER')) {
            mimeType = 'application/pdf';
            ext = 'pdf';
          } else if (certData.startsWith('/9j/')) {
            mimeType = 'image/jpeg';
            ext = 'jpg';
          }

          const blobUrl = base64ToBlobUrl(certData, mimeType);
          downloadUrl = blobUrl || `data:${mimeType};base64,${certData}`;
        }

        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `${certType}_certificate.${ext}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Revoke blob URL after download
        if (downloadUrl.startsWith('blob:')) {
          setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
        }
      }
    } catch (err) {
      console.error("Error downloading certificate:", err);
      alert("Failed to download certificate.");
    } finally {
      setIsProcessing(false);
    }
  };

  if (!certEligibility) return null;

  if (certEligibility.detail === "Feddback Not Found/Submitted") {
    return (
      <div className="flex flex-col items-center justify-center p-8 bg-white border border-gray-100 rounded-2xl shadow-sm text-center">
        <div className="w-16 h-16 bg-amber-50 text-amber-500 rounded-full flex items-center justify-center mb-4">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
        </div>
        <h3 className="text-xl font-bold text-gray-800 mb-2">Feedback Required</h3>
        <p className="text-gray-600 mb-4 max-w-lg">
          Please give your valuable feedback to get the certificates
        </p>
        <div className="animate-bounce my-4">
          <svg className="w-6 h-6 text-blue-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
        <a 
          href="https://connect.eduskillsfoundation.org/feedback" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-600 font-semibold hover:underline bg-blue-50 px-4 py-3 rounded-xl border border-blue-100 mt-2 block"
        >
          https://connect.eduskillsfoundation.org/feedback
        </a>
      </div>
    );
  }

  return (
    <div className="relative rounded-2xl overflow-hidden mt-4 bg-gradient-to-br from-[#f8fbff] to-[#e6f0ff] border border-blue-50/50 shadow-sm px-6 py-14 group">
      <style>
        {`
          @keyframes float-gentle {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
          }
          @keyframes float-delayed {
            0%, 100% { transform: translateY(0) rotate(45deg); }
            50% { transform: translateY(-6px) rotate(45deg); }
          }
          @keyframes pulse-glow {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.7; transform: scale(0.9); }
          }
          .animate-float {
            animation: float-gentle 4s ease-in-out infinite;
          }
          .animate-float-delayed {
            animation: float-delayed 5s ease-in-out infinite 1s;
          }
          .animate-pulse-glow {
            animation: pulse-glow 3s ease-in-out infinite;
          }
        `}
      </style>
      
      {/* Abstract Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-blue-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl transform translate-x-1/3 translate-y-1/3"></div>
        
        {/* Soft Wave Simulation */}
        <svg
          className="absolute bottom-0 left-0 w-full h-auto text-blue-200/40 transform transition-transform duration-1000 group-hover:scale-105"
          viewBox="0 0 1440 320"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,144C672,139,768,181,864,197.3C960,213,1056,203,1152,176C1248,149,1344,107,1392,85.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>

      <div className="relative z-10 text-center md:mb-12 mb-8">
        {/* Icon & Floating Stars */}
        <div className="relative mx-auto w-20 h-20 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-[0_4px_20px_-4px_rgba(0,100,255,0.15)] ring-1 ring-blue-50 animate-float">
          <FileText className="w-8 h-8 text-blue-600 transition-transform duration-500 group-hover:scale-110 group-hover:text-blue-500" />
          
          {/* Main Badge Star */}
          <div className="absolute -bottom-2 -right-2 bg-amber-400 rounded-full p-1.5 shadow-md border-2 border-white animate-pulse-glow">
            <Star className="w-3.5 h-3.5 text-white fill-current transition-transform duration-500 group-hover:rotate-180" />
          </div>

          {/* Floating Sparks */}
          <div className="absolute -top-4 -right-12 w-3 h-3 bg-amber-400 rounded-sm shadow-sm animate-float-delayed"></div>
          <div className="absolute top-4 -left-10 w-2.5 h-2.5 bg-amber-400 rounded-sm shadow-sm animate-float-delayed" style={{ animationDelay: '2s' }}></div>
        </div>

        <h3 className="text-3xl sm:text-4xl font-extrabold mb-3 tracking-tight">
          <span className="text-[#101828]">Participating</span> <span className="text-[#005af5]">Certificates</span>
        </h3>
        <p className="text-gray-500 font-medium max-w-md mx-auto text-sm sm:text-base">
          Download your participation certificates below.
        </p>
      </div>

      <div className="relative z-10 flex flex-col sm:flex-row items-center justify-center gap-5 max-w-3xl mx-auto px-2">
        {certEligibility.connect_cert && (
          <button
            onClick={() => handleDownload('connect')}
            disabled={isProcessing === 'connect'}
            className="group flex-1 flex items-center justify-between w-full sm:max-w-[340px] bg-[#005af5] hover:bg-blue-700 disabled:opacity-75 text-white py-3.5 px-4 rounded-full font-medium shadow-[0_8px_20px_-6px_rgba(0,90,245,0.5)] hover:shadow-[0_12px_24px_-6px_rgba(0,90,245,0.6)] transition-all duration-300 transform hover:-translate-y-0.5"
          >
            <div className="flex items-center space-x-3.5">
              <div className="bg-white text-blue-600 p-2.5 rounded-xl shadow-sm">
                <FileText className="w-5 h-5" />
              </div>
              <div className="text-left flex flex-col">
                <span className="font-bold text-[15px] tracking-wide leading-tight mb-0.5">Connect 2026</span>
                <span className="text-xs font-medium text-blue-100">Certificate</span>
              </div>
            </div>
            <div className="bg-white/10 group-hover:bg-white/20 p-2.5 rounded-full transition-colors flex items-center justify-center border border-white/10">
              {isProcessing === 'connect' ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              )}
            </div>
          </button>
        )}

        {certEligibility.hr_summit_cert && (
          <button
            onClick={() => handleDownload('hr_summit')}
            disabled={isProcessing === 'hr_summit'}
            className="group flex-1 flex items-center justify-between w-full sm:max-w-[340px] bg-[#008A5E] hover:bg-emerald-700 disabled:opacity-75 text-white py-3.5 px-4 rounded-full font-medium shadow-[0_8px_20px_-6px_rgba(0,138,94,0.5)] hover:shadow-[0_12px_24px_-6px_rgba(0,138,94,0.6)] transition-all duration-300 transform hover:-translate-y-0.5"
          >
            <div className="flex items-center space-x-3.5">
              <div className="bg-white text-emerald-600 p-2.5 rounded-xl shadow-sm">
                <FileText className="w-5 h-5" />
              </div>
              <div className="text-left flex flex-col">
                <span className="font-bold text-[15px] tracking-wide leading-tight mb-0.5">HR Summit</span>
                <span className="text-xs font-medium text-emerald-100">Certificate</span>
              </div>
            </div>
            <div className="bg-white/10 group-hover:bg-white/20 p-2.5 rounded-full transition-colors flex items-center justify-center border border-white/10">
              {isProcessing === 'hr_summit' ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              )}
            </div>
          </button>
        )}
      </div>
    </div>
  );

};

const AwardsAccordion = () => {
  const location = useLocation();
  const [activeYear, setActiveYear] = useState("2026");
  const [modalData, setModalData] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || "general");
  const [isAwardsExpanded, setIsAwardsExpanded] = useState(
    ["special", "education", "general"].includes(location.state?.activeTab || "general")
  );
  const [yearsData, setYearsData] = useState({});
  const [regStatus, setRegStatus] = useState(0); // Add regStatus state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false); // Add sidebar state for mobile
  const [memStatus, setMemStatus] = useState(null); // mem_status from registration-details API
  const [regDetails, setRegDetails] = useState(null); // full reg details if reg_status === 1
  const [regDetailsLoading, setRegDetailsLoading] = useState(true);
  const [showAward, setShowAward] = useState(0); // Add showAward state
  const [showPreview, setShowPreview] = useState(false); // Add showPreview state
  const [showAgendaTabs, setShowAgendaTabs] = useState(false); // show_agenda_tabs from API
  const [nominationRegStatus, setNominationRegStatus] = useState(0); // registration_status from nomination/status API

  // RM details
  const [rmDetails, setRmDetails] = useState({ rm_name: "", rm_email: "", rm_mobile: "" });
  const [rmLoading, setRmLoading] = useState(true);

  // Participating Certificate
  const [certEligibility, setCertEligibility] = useState(null);
  const [certLoading, setCertLoading] = useState(false);

  useEffect(() => {
    const fetchCertEligibility = async () => {
      try {
        setCertLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;
        const res = await api.get(`${BASE_URL}/awards/get-eligiable-cert`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (res.data) {
          setCertEligibility(res.data);
        }
      } catch (err) {
        console.error("Error fetching certificate eligibility:", err);
        if (err.response && err.response.data) {
          setCertEligibility(err.response.data);
        }
      } finally {
        setCertLoading(false);
      }
    };
    fetchCertEligibility();
  }, []);

// ── 1 Million Internship Milestone ──
  const [isEligible, setIsEligible] = useState(false);
  const [eligibleLoading, setEligibleLoading] = useState(true);
// Fetch eligibility for the Milestone tab
  useEffect(() => {
    const fetchEligibility = async () => {
      try {
        setEligibleLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;
        const res = await api.get(`${BASE_URL}/awards/show_upload`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (res.data) {
          setIsEligible(res.data.is_eligible === true);
        }
      } catch (err) {
        console.error("Error fetching milestone eligibility:", err);
      } finally {
        setEligibleLoading(false);
      }
    };
    fetchEligibility();
  }, []);

  useEffect(() => {
    const fetchRmDetails = async () => {
      try {
        setRmLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
          setRmLoading(false);
          return;
        }

        const res = await api.get(`${BASE_URL}/awards/rm_details`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (res.data && res.data.rm_name) {
          setRmDetails(res.data);
        }
      } catch (err) {
        console.error("Error fetching RM details:", err);
      } finally {
        setRmLoading(false);
      }
    };
    fetchRmDetails();
  }, []);

  // Fetch nomination registration_status for Education Excellence tab visibility
  useEffect(() => {
    const fetchNominationRegStatus = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;

        const response = await api.get(`${BASE_URL}/internship/nomination/status`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200 && response.data) {
          setNominationRegStatus(response.data.registration_status || 0);
        }
      } catch (error) {
        console.error("Error fetching nomination registration status:", error);
      }
    };

    fetchNominationRegStatus();
  }, []);

  // New state for institute participation
  const [participateData, setParticipateData] = useState(null);
  const [participateLoading, setParticipateLoading] = useState(false);

  const itemsPerPage = 5;

  // Fetch registration details from /registration-details API
  useEffect(() => {
    const fetchRegDetails = async () => {
      try {
        setRegDetailsLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;

        const res = await api.get(`${BASE_URL}/admin/registration-details`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        let { mem_status, registration_status, data, show_award, show_agenda_tabs } = res.data;

        setMemStatus(mem_status ?? null);
        setRegStatus(registration_status || 0);
        setShowAward(show_award || 0);
        setShowAgendaTabs(show_agenda_tabs === true);
        if (registration_status === 1 && data) {
          setRegDetails(data);
        }
      } catch (err) {
        console.error("Error fetching registration details:", err);
      } finally {
        setRegDetailsLoading(false);
      }
    };
    fetchRegDetails();
  }, []);

  // Fetch institute participation data
  useEffect(() => {
    const fetchParticipateData = async () => {
      try {
        setParticipateLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;

        const res = await api.get(`${BASE_URL}/admin/institute-registration-details`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (res.data) {
          setParticipateData(res.data);
        }
      } catch (err) {
        console.error("Error fetching participate details:", err);
      } finally {
        setParticipateLoading(false);
      }
    };
    fetchParticipateData();
  }, []);

  // API call to fetch event summary data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Get access token from localStorage
        const accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
          throw new Error("No access token found. Please login again.");
        }

        const response = await api.get(`${BASE_URL}/internship/event/summary`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        // Extract registration_status and years data
        const { reg_status, registration_status, ...years } = response.data;
        setYearsData(years);
      } catch (err) {
        console.error("Error fetching data:", err);

        // Handle axios specific errors
        if (err.response) {
          if (err.response.status === 401) {
            setError("Unauthorized. Please login again.");
          } else {
            setError(
              `Server error: ${err.response.status} - ${err.response.data?.message || "Unknown error"
              }`
            );
          }
        } else if (err.request) {
          setError("Network error. Please check your internet connection.");
        } else {
          setError(err.message);
        }

        // Fallback to empty data structure
        setYearsData({});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const toggleYear = (year) => {
    setActiveYear(activeYear === year ? null : year);
    // Reset tab to general when opening any year
    setActiveTab("general");
    // Close sidebar on mobile when changing year
    setSidebarOpen(false);
  };

  const openModal = (type, data, year) => {
    setModalData({ type, data, year });
    setCurrentPage(1);
    if (type === "apply_form") {
      setFormValues({});
      setFormErrors({});
      setShowPreview(false);
    }
  };

  const closeModal = () => {
    setModalData(null);
    setCurrentPage(1);
    setFormValues({});
    setFormErrors({});
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // --- Form Handlers ---
  const handleInputChange = (questionId, value) => {
    setFormValues(prev => ({ ...prev, [questionId]: value }));
    if (formErrors[questionId]) {
      setFormErrors(prev => ({ ...prev, [questionId]: null }));
    }
  };

  const handleCheckboxChange = (questionId, optionValue) => {
    setFormValues(prev => {
      const currentSelected = prev[questionId] || [];
      let newSelected;
      if (currentSelected.includes(optionValue)) {
        newSelected = currentSelected.filter(val => val !== optionValue);
      } else {
        newSelected = [...currentSelected, optionValue];
      }
      return { ...prev, [questionId]: newSelected };
    });
    if (formErrors[questionId]) {
      setFormErrors(prev => ({ ...prev, [questionId]: null }));
    }
  };

  const handleFileChange = (questionId, e, validation) => {
    const file = e.target.files[0];
    if (!file) return;

    // Extension validation
    if (validation?.allowed_extensions) {
      const allowedExts = validation.allowed_extensions
        .split(',')
        .map(ext => ext.trim().toLowerCase())
        .filter(Boolean);
      const fileExt = file.name.split('.').pop().toLowerCase();
      if (allowedExts.length > 0 && !allowedExts.includes(fileExt)) {
        setFormErrors(prev => ({
          ...prev,
          [questionId]: `Invalid file type. Allowed: ${allowedExts.map(e => e.toUpperCase()).join(', ')}`
        }));
        e.target.value = ''; // reset input
        return;
      }
    }

    // File size validation
    if (validation?.max_file_size_mb) {
      const sizeInMb = file.size / (1024 * 1024);
      if (sizeInMb > validation.max_file_size_mb) {
        setFormErrors(prev => ({ ...prev, [questionId]: `File size must be less than ${validation.max_file_size_mb}MB` }));
        e.target.value = ''; // reset input
        return;
      }
    }

    setFormValues(prev => ({ ...prev, [questionId]: file }));
    if (formErrors[questionId]) {
      setFormErrors(prev => ({ ...prev, [questionId]: null }));
    }
  };

  const handlePreviewClick = () => {
    if (!modalData || modalData.type !== "apply_form") return;
    const { data, year } = modalData;
    let errors = {};
    let isValid = true;

    data.questions?.forEach(q => {
      const val = formValues[q.id];
      
      // Required check
      if (q.is_required) {
        if (q.question_type === 'boolean') {
           if (val !== true && val !== false) {
              errors[q.id] = "Please select Yes or No.";
              isValid = false;
              return;
           }
        } else if (val === undefined || val === null || val === "" || (Array.isArray(val) && val.length === 0)) {
          errors[q.id] = "This field is required.";
          isValid = false;
          return;
        }
      }

      // Validation check
      if (val !== undefined && val !== null && val !== "") {
         if (q.question_type === 'text' || q.question_type === 'textarea') {
            if (q.validation?.min_length && val.length < q.validation.min_length) {
               errors[q.id] = `Minimum length is ${q.validation.min_length} characters.`;
               isValid = false;
            }
            if (q.validation?.max_length && val.length > q.validation.max_length) {
               errors[q.id] = `Maximum length is ${q.validation.max_length} characters.`;
               isValid = false;
            }
         }
         if (q.question_type === 'number' || q.question_type === 'numeric') {
            const numVal = Number(val);
            if (q.validation?.min_value !== null && numVal < q.validation.min_value) {
               errors[q.id] = `Minimum value is ${q.validation.min_value}.`;
               isValid = false;
            }
            if (q.validation?.max_value !== null && numVal > q.validation.max_value) {
               errors[q.id] = `Maximum value is ${q.validation.max_value}.`;
               isValid = false;
            }
         }
      }
    });

    if (!isValid) {
      setFormErrors(errors);
      setTimeout(() => {
        const firstErrorId = Object.keys(errors)[0];
        if (firstErrorId) {
          const errorElement = document.getElementById(`question-container-${firstErrorId}`);
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }, 100);
      return;
    }

    setShowPreview(true);
    
    // Scroll to top of modal when showing preview
    setTimeout(() => {
      const container = document.getElementById("modal-scroll-container");
      if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 50);
  };

  const handleFormSubmit = async () => {
    if (!modalData || modalData.type !== "apply_form") return;
    const { data, year } = modalData;

    setIsSubmitting(true);
    try {
      const answersList = [];
      
      // Upload files to S3 first
      for (const q of (data.questions || [])) {
        const val = formValues[q.id];
        
        if (q.question_type === 'file' || q.question_type === 'upload') {
          if (val instanceof File) {
            // Upload directly to S3 using the presigned URL
            if (!q.upload_url || !q.s3_key || !q.file_url_base) {
              throw new Error(`Presigned URL information is missing for question: ${q.question_text}`);
            }
            
            // Using standard fetch for S3 upload to avoid interceptors in the api instance
            const uploadRes = await fetch(q.upload_url, {
              method: "PUT",
              body: val,
              headers: {
                "Content-Type": val.type
              }
            });
            
            if (!uploadRes.ok) {
              throw new Error(`Failed to upload file ${val.name} to S3.`);
            }
            
            answersList.push({
              question_id: q.id,
              file_name: val.name,
              file_path: `${q.file_url_base}/${q.s3_key}`,
              file_size_bytes: val.size
            });
          }
        } else {
           if (val !== undefined && val !== null && val !== "") {
               let answerStr = val;
               if (Array.isArray(val)) {
                   answerStr = val.join(',');
               } else if (typeof val === 'boolean') {
                   answerStr = val ? 'Yes' : 'No';
               }
               answersList.push({ question_id: q.id, answer: String(answerStr) });
           }
        }
      }

      const formData = new FormData();
      formData.append("award_id", data.award_id);
      formData.append("answers_json", JSON.stringify(answersList));

      const accessToken = localStorage.getItem("accessToken");
      const res = await api.post(`${BASE_URL}/awards/nominations/create`, formData, {
        headers: { 
           Authorization: `Bearer ${accessToken}`
        }
      });
      
      if (res.data) {
         openModal("success", { message: res.data.message || "Nomination submitted successfully!" }, year);
      }
    } catch (err) {
      console.error("Submission error:", err);
      const errorMsg = err.response?.data?.detail || err.message || "Failed to submit nomination. Please try again.";
      openModal("error", { message: errorMsg }, year);
    } finally {
      setIsSubmitting(false);
    }
  };

  const parseOptions = (optionsStr, optionKeysStr) => {
    if (!optionsStr) return [];
    const opts = optionsStr.split(',').map(s => s.trim());
    const keys = optionKeysStr ? optionKeysStr.split(',').map(s => s.trim()) : opts;
    return opts.map((opt, index) => ({
      label: opt,
      value: keys[index] !== undefined ? keys[index] : opt
    }));
  };

  // Close sidebar when tab changes on mobile
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setSidebarOpen(false);
  };

  // Coming Soon component
  const ComingSoon = ({ title }) => {
    return (
      <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">🚀</span>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">{title}</h3>
          <p className="text-gray-500 text-sm">
            This section is coming soon. Stay tuned for updates!
          </p>
        </div>
      </div>
    );
  };

  // Event Photos Tab Component
  const EventPhotosTab = () => {
    return (
      <div className="space-y-6">
        {/* Header */}
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">📸</span>
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-1">Event Photos</h3>
          <p className="text-gray-500 text-sm">View and download event memories from each day</p>
        </div>

        {/* Day 1 & Day 2 Photos - Side by Side */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Day 1 Photos */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200">
            <div className="flex items-center space-x-4 mb-4">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-lg">1</span>
              </div>
              <div className="text-left">
                <h4 className="text-lg font-semibold text-gray-800">Day 1 Photos <span className="text-sm font-normal text-blue-600">(25th Sep 2026)</span></h4>
                <p className="text-sm text-gray-600">View  Day 1 event memories</p>
              </div>
            </div>
            <a
              href="https://drive.google.com/drive/folders/1V1qK-lOvKuy3Gk2DzcWHyIM299JCXILT?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-lg hover:shadow-xl w-full justify-center"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              View Photos
            </a>
          </div>

          {/* Day 2 Photos */}
          <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-6 border border-indigo-200">
            <div className="flex items-center space-x-4 mb-4">
              <div className="w-12 h-12 bg-indigo-500 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-lg">2</span>
              </div>
              <div className="text-left">
                <h4 className="text-lg font-semibold text-gray-800">Day 2 Photos <span className="text-sm font-normal text-indigo-600">(26th Sep 2026)</span></h4>
                <p className="text-sm text-gray-600">View Day 2 event memories</p>
              </div>
            </div>
            <a
              href="https://drive.google.com/drive/folders/1iAf3md8dQ0yM5kZ6PvqkR9gkqkpYuKm8?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors duration-200 shadow-lg hover:shadow-xl w-full justify-center"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              View Photos
            </a>
          </div>
        </div>

        {/* Footer note */}
        
      </div>
    );
  };

  // Compact Stats Card Component
  const StatsCard = ({
    icon,
    label,
    value,
    color,
    onClick,
    clickable = false,
  }) => {
    const colorClasses = {
      blue: "bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100",
      yellow: "bg-amber-50 border-amber-200 text-amber-700 hover:bg-amber-100",
      green:
        "bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100",
      gray: "bg-gray-50 border-gray-200 text-gray-700",
    };

    const iconClasses = {
      blue: "bg-blue-500 text-white",
      yellow: "bg-amber-500 text-white",
      green: "bg-emerald-500 text-white",
      gray: "bg-gray-500 text-white",
    };

    const Component = clickable ? "button" : "div";

    return (
      <Component
        onClick={clickable ? onClick : undefined}
        className={`
          ${colorClasses[color]} 
          ${clickable ? "cursor-pointer transform hover:scale-105" : ""}
          rounded-xl border p-4 transition-all duration-200 shadow-sm
        `}
      >
        <div className="flex items-center space-x-3">
          <div className={`p-2 rounded-lg ${iconClasses[color]}`}>{icon}</div>
          <div className="text-left">
            <p className="text-xs font-medium opacity-75 uppercase tracking-wide">
              {label}
            </p>
            <p className="text-xl font-bold">{value}</p>
          </div>
        </div>
      </Component>
    );
  };

  // AwardsTab is extracted outside

  // Registration Tab Component with conditional UI based on mem_status & reg_status
  const RegistrationTab = ({ data, year }) => {
    // Loading state for registration details
    if (regDetailsLoading) {
      return (
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-gray-500 text-sm">Loading registration info...</p>
          </div>
        </div>
      );
    }

    // Case 1: mem_status is 0 or 1 → Registration not yet open
    if (memStatus === 0 || memStatus === 1) {
      return (
        <div className="flex items-center justify-center py-12">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center max-w-sm w-full">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
              <span style={{ fontSize: 48 }}>📅</span>
            </div>
            {/* <h3 className="text-xl font-bold text-gray-800 mb-2">Registration opens on 1st July</h3> */}
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              Registration Opening Soon
            </h3>
            {/* <p className="text-gray-500 text-sm mb-6">Please check back on 1st July to complete your registration.</p> */}
            {/* <button
              onClick={() => window.location.reload()}
              className="px-8 py-2.5 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold transition-colors"
            >
              Refresh
            </button> */}
          </div>
        </div>
      );
    }

    // Case 2: mem_status is 2 and reg_status is 0 → Not yet registered
    if (memStatus === 2 && regStatus === 0) {
      return (
        <div className="flex items-center justify-center py-12">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center max-w-sm w-full">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
              <span style={{ fontSize: 48 }}>🎟️</span>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Register for Connect 2026</h3>
            <p className="text-gray-500 text-sm mb-6">You're eligible to register! Click below to explore and register yourself for the event.</p>
            <a
              href="https://connect.eduskillsfoundation.org"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl font-semibold transition-colors"
            >
              Register Now
            </a>
          </div>
        </div>
      );
    }

    // Case 3: reg_status is 1 → Already registered — show their registration details
    if (regStatus === 1 && regDetails) {
      const mealDays = regDetails.meal_days || {};
      return (
        <div className="space-y-5">
          {/* Registration confirmed banner */}
          <div className="flex items-center gap-3 bg-emerald-50 border border-emerald-200 rounded-xl px-5 py-3">
            <span className="text-2xl">✅</span>
            <div>
              <p className="font-semibold text-emerald-700 text-sm">Registration Confirmed</p>
              <p className="text-emerald-600 text-xs">You are registered for Connect 2026</p>
            </div>
          </div>

          {/* Details grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Member Type</p>
              <p className="font-semibold text-gray-800 capitalize">{regDetails.mem_type || "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Package</p>
              <p className="font-semibold text-gray-800">{regDetails.package_name || "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Total Days</p>
              <p className="font-semibold text-gray-800">{regDetails.total_days || "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Start Date</p>
              <p className="font-semibold text-gray-800">{regDetails.start_date ? new Date(regDetails.start_date).toLocaleDateString() : "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">End Date</p>
              <p className="font-semibold text-gray-800">{regDetails.end_date ? new Date(regDetails.end_date).toLocaleDateString() : "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Check-in Date</p>
              <p className="font-semibold text-gray-800">{regDetails.checkin_date ? new Date(regDetails.checkin_date).toLocaleDateString() : "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Check-out Date</p>
              <p className="font-semibold text-gray-800">{regDetails.checkout_date ? new Date(regDetails.checkout_date).toLocaleDateString() : "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Mode of Travel</p>
              <p className="font-semibold text-gray-800 capitalize">{regDetails.mode_of_travel ? regDetails.mode_of_travel.replace(/_/g, ' ') : "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Cuisine</p>
              <p className="font-semibold text-gray-800 capitalize">{regDetails.cuisine ? regDetails.cuisine.replace(/_/g, ' ') : "—"}</p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Alcohol Pref.</p>
              <p className="font-semibold text-gray-800 capitalize">{regDetails.alcohol_preference ? regDetails.alcohol_preference.replace(/_/g, ' ') : "—"}</p>
            </div>
          </div>

          {/* Meal preferences per day */}
          {Object.keys(mealDays).length > 0 && (
            <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
              <p className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-3">Meal Preferences</p>
              <div className="flex flex-wrap gap-2">
                {Object.entries(mealDays).map(([day, meal]) => (
                  <span
                    key={day}
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${meal === "veg"
                      ? "bg-green-100 text-green-700"
                      : "bg-amber-100 text-amber-700"
                      }`}
                  >
                    Day {day}: {meal === "veg" ? "🥦 Veg" : "🍗 Non-Veg"}
                  </span>
                ))}
              </div>
            </div>
          )}


        </div>
      );
    }

    // Default fallback — show attendees count
    return (
      <div className="space-y-6">
        <div className="grid grid-cols-1 gap-4">
          <StatsCard
            icon={<Users className="w-4 h-4" />}
            label="Attendees"
            value={data.attendees?.length || 0}
            color="blue"
            onClick={() => openModal("attendees", data.attendees || [], year)}
            clickable={true}
          />
        </div>
      </div>
    );
  };

  // Dynamic tabs based on regStatus and showAward
  const getAvailableTabs = () => {
    const baseTabs = [
      { id: "awards-parent", label: "Awards Category", icon: Trophy, color: "blue", isParent: true }
    ];

    baseTabs.push(
      { id: "general", label: "Connect 2026 Awards", icon: Trophy, color: "blue", parentId: "awards-parent" }
    );

    baseTabs.push(
      { id: "education", label: "Education Excellence", icon: Trophy, color: "blue", parentId: "awards-parent" }
    );

    if (showAward === 1) {
      baseTabs.push({ id: "special", label: "Special Category Award", icon: Trophy, color: "blue", parentId: "awards-parent" });
    }

    if (showAgendaTabs) {
      baseTabs.push(
        // { id: "venue", label: "Venue", icon: MapPin, color: "blue" },
        // { id: "agenda", label: "Agenda", icon: Calendar, color: "blue" },
        // { id: "attending", label: "Attending", icon: Users, color: "blue" },
        { id: "photos", label: "Event Photos", icon: Users, color: "blue" },
        // { id: "participate", label: "Participating", icon: Users, color: "blue" },
        // { id: "feedback", label: "Feedback", icon: Star, color: "blue" }
      );

      if (
        certEligibility?.connect_cert || 
        certEligibility?.hr_summit_cert || 
        certEligibility?.detail === "Feddback Not Found/Submitted"
      ) {
        baseTabs.push(
          { id: "participating_certificate", label: "Participating Certificate", icon: FileText, color: "blue" }
        );
      }
    }

    return baseTabs;
  };

  const tabs = getAvailableTabs();

  const renderTabContent = (data, year) => {
    switch (activeTab) {
      case "registration":
        return <RegistrationTab data={data} year={year} />;
      case "participate":
        return <ParticipateTab participateLoading={participateLoading} participateData={participateData} />;
      case "special":
      case "education":
      case "general":
        return <AwardsTab data={data} year={year} openModal={openModal} showAward={showAward} activeSubCategory={activeTab} rmDetails={rmDetails} rmLoading={rmLoading} />;
      case "winners":
        return <AwardsByCategory data={data} year={year} />;

      case "venue":
        return showAgendaTabs ? (
          <EastBourneResortMap />
        ) : (
          <RegistrationTab data={data} year={year} />
        );
      case "agenda":
        return showAgendaTabs ? (
          <EnhancedMinimalistAgenda />
        ) : (
          <RegistrationTab data={data} year={year} />
        );
      case "attending":
        return showAgendaTabs ? (
          <ConferenceTicketGenerator />
        ) : (
          <RegistrationTab data={data} year={year} />
        );
      case "photos":
        return showAgendaTabs ? (
          <EventPhotosTab />
        ) : (
          <RegistrationTab data={data} year={year} />
        );
      case "feedback":
        return regStatus === 1 ? <EventFeedbackForm /> : <ComingSoon title="Feedback" />;
      case "participating_certificate":
        return <ParticipatingCertificateTab certEligibility={certEligibility} />;
      default:
        return <AwardsTab data={data} year={year} openModal={openModal} showAward={showAward} />;
    }
  };

  // Reset active tab if it's not available anymore
  useEffect(() => {
    const availableTabIds = tabs.map((tab) => tab.id);
    if (!availableTabIds.includes(activeTab)) {
      setActiveTab("general");
    }
  }, [regStatus, tabs, activeTab]);

  const renderModalContent = () => {
    if (!modalData) return null;

    const { type, data, year } = modalData;
    const yearData = yearsData[year];
    const instituteNominatedCategories =
      yearData?.instituteNominatedCategories || [];
    const instituteWinnerCategories = yearData?.instituteWinnerCategories || [];

    return (
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
        style={{ zIndex: 50000 }}
      >
        <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-hidden shadow-2xl border border-gray-200">
          <div className={`flex items-center justify-between p-6 border-b ${(type === "apply_form" || type === "view_nomination") ? "bg-blue-500 border-blue-600 shadow-sm" : "border-gray-100 bg-gray-50/50"}`}>
            <div>
              <h2 className={`text-xl font-bold ${(type === "apply_form" || type === "view_nomination") ? "text-white" : "text-gray-800"}`}>
                {type === "attendees"
                  ? "Event Attendees"
                  : type === "nominated"
                    ? "Nominated Candidates"
                    : type === "apply_form"
                      ? "Apply for Award Nomination"
                      : type === "view_nomination"
                        ? "Nomination Submission Details"
                        : type === "error"
                          ? "Error"
                          : type === "success"
                            ? "Success"
                            : "Award Winners"}
              </h2>
              <p className={`text-sm mt-1 ${(type === "apply_form" || type === "view_nomination") ? "text-blue-50 font-medium" : "text-gray-500"}`}>
                {type === "apply_form" ? data.award_name : (type === "error" || type === "success" || type === "view_nomination") ? "" : `${year} • ${data?.length || 0} entries`}
              </p>
            </div>
            <button
              onClick={closeModal}
              className={`transition-colors p-2 rounded-lg ${(type === "apply_form" || type === "view_nomination") ? "text-blue-100 hover:text-white hover:bg-blue-600" : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"}`}
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div
            id="modal-scroll-container"
            className="p-6 overflow-y-auto"
            style={{ maxHeight: "calc(90vh - 140px)" }}
          >
            {type === "apply_form" ? (
              <div>
                {!data.is_eligible ? (
                  <div className="bg-red-50 text-red-700 p-4 rounded-xl border border-red-200">
                    {/* <h3 className="font-bold mb-2">Not Eligible to Apply hhhhh</h3> */}
                    <p className="text-sm">{data.reason}</p>
                  </div>
                ) : (
                  <div className="space-y-6">
                    
                    <div className="space-y-4">
                      <h3 className="text-lg font-bold text-blue-700 border-b pb-2">{showPreview ? "Preview Nomination" : "Nomination Form"}</h3>
                      {showPreview ? (
                        <div className="space-y-4">
                          {data.questions?.map((q, idx) => {
                            const val = formValues[q.id];
                            let displayVal = val;
                            if (q.question_type === 'file' || q.question_type === 'upload') {
                               displayVal = val ? (val.name || (typeof val === 'string' ? val.split('/').pop() : 'Uploaded File')) : "No file chosen";
                            } else if (q.question_type === 'boolean') {
                               displayVal = val === true ? "Yes" : (val === false ? "No" : "");
                            } else if (Array.isArray(val)) {
                               displayVal = val.join(', ');
                            } else if (q.question_type === 'select' || q.question_type === 'dropdown' || q.question_type === 'radio') {
                               const options = parseOptions(q.options, q.option_keys);
                               const selectedOpt = options.find(o => String(o.value) === String(val));
                               displayVal = selectedOpt ? selectedOpt.label : val;
                            }
                            return (
                               <div key={q.id} className="py-4 border-b border-gray-100 last:border-0">
                                  <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-1">Question {idx + 1}</p>
                                  <p className="font-medium text-gray-800 mb-2">{q.question_text}</p>
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mt-1">
                                    {((q.question_type === 'file' || q.question_type === 'upload') && val) ? (
                                      <button 
                                        type="button"
                                        onClick={() => {
                                          if (val instanceof File) {
                                            window.open(URL.createObjectURL(val), '_blank');
                                          } else if (typeof val === 'string') {
                                            window.open(val, '_blank');
                                          }
                                        }}
                                        className="px-4 py-2 bg-blue-50 text-blue-600 rounded-md text-sm font-semibold hover:bg-blue-100 transition-colors flex items-center gap-2 shrink-0 self-start w-fit"
                                      >
                                        <Eye className="w-4 h-4" />
                                        Preview Document
                                      </button>
                                    ) : (
                                      <p className="text-base text-gray-900 font-semibold break-all leading-tight">
                                        {displayVal || <span className="text-gray-400 font-normal italic">No answer provided</span>}
                                      </p>
                                    )}
                                  </div>
                               </div>
                            );
                          })}
                        </div>
                      ) : data.questions?.length > 0 ? (
                        data.questions.map((q, idx) => {
                          const options = parseOptions(q.options, q.option_keys);
                          const value = formValues[q.id];
                          const error = formErrors[q.id];
                          const inputClass = `w-full border ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-amber-500'} rounded-lg p-2.5 text-sm shadow-sm focus:outline-none focus:ring-2 transition-shadow`;

                          return (
                            <div key={q.id} id={`question-container-${q.id}`} className="bg-gray-50 p-4 rounded-xl border border-gray-100 shadow-sm">
                              <p className="font-medium text-gray-800">
                                {idx + 1}. {q.question_text} {q.is_required && <span className="text-red-500">*</span>}
                              </p>
                              {q.helper_text && <p className="text-xs text-gray-500 mt-1">{q.helper_text}</p>}
                              <div className="mt-3">
                                {q.question_type === 'text' || q.question_type === 'number' || q.question_type === 'numeric' || q.question_type === 'url' ? (
                                  <input 
                                    type={q.question_type === 'number' || q.question_type === 'numeric' ? 'number' : 'text'} 
                                    className={inputClass} 
                                    placeholder="Your answer..." 
                                    value={value !== undefined ? value : ''}
                                    onChange={(e) => handleInputChange(q.id, e.target.value)}
                                    onWheel={(e) => e.target.blur()}
                                  />
                                ) : q.question_type === 'date' ? (
                                  <input 
                                    type="date"
                                    className={inputClass} 
                                    value={value || ''}
                                    onChange={(e) => handleInputChange(q.id, e.target.value)}
                                  />
                                ) : q.question_type === 'boolean' ? (
                                  <div className="flex items-center space-x-6 mt-2">
                                    <label className="flex items-center space-x-3 cursor-pointer">
                                      <input 
                                        type="radio"
                                        name={`question_${q.id}`}
                                        checked={value === true}
                                        onChange={() => handleInputChange(q.id, true)}
                                        className={`w-4 h-4 text-amber-500 focus:ring-amber-500 border-gray-300 ${error ? 'border-red-500' : ''}`}
                                      />
                                      <span className="text-sm text-gray-700">Yes</span>
                                    </label>
                                    <label className="flex items-center space-x-3 cursor-pointer">
                                      <input 
                                        type="radio"
                                        name={`question_${q.id}`}
                                        checked={value === false}
                                        onChange={() => handleInputChange(q.id, false)}
                                        className={`w-4 h-4 text-amber-500 focus:ring-amber-500 border-gray-300 ${error ? 'border-red-500' : ''}`}
                                      />
                                      <span className="text-sm text-gray-700">No</span>
                                    </label>
                                  </div>
                                ) : q.question_type === 'textarea' ? (
                                  <textarea 
                                    className={inputClass} 
                                    rows="3" 
                                    placeholder="Your answer..."
                                    value={value || ''}
                                    onChange={(e) => handleInputChange(q.id, e.target.value)}
                                  ></textarea>
                                ) : q.question_type === 'select' || q.question_type === 'dropdown' ? (
                                  <select 
                                    className={inputClass}
                                    value={value || ''}
                                    onChange={(e) => handleInputChange(q.id, e.target.value)}
                                  >
                                    <option value="">Select an option...</option>
                                    {options.map((opt, i) => <option key={i} value={opt.value}>{opt.label}</option>)}
                                  </select>
                                ) : q.question_type === 'radio' ? (
                                  <div className="space-y-2">
                                    {options.map((opt, i) => (
                                       <label key={i} className="flex items-center space-x-3 cursor-pointer">
                                         <input 
                                           type="radio" 
                                           name={`question_${q.id}`} 
                                           value={opt.value}
                                           checked={value === opt.value}
                                           onChange={(e) => handleInputChange(q.id, e.target.value)}
                                           className="w-4 h-4 text-amber-500 focus:ring-amber-500 border-gray-300"
                                         />
                                         <span className="text-sm text-gray-700">{opt.label}</span>
                                       </label>
                                    ))}
                                  </div>
                                ) : q.question_type === 'checkbox' ? (
                                  <div className="space-y-2">
                                    {options.map((opt, i) => (
                                       <label key={i} className="flex items-center space-x-3 cursor-pointer">
                                         <input 
                                           type="checkbox" 
                                           value={opt.value}
                                           checked={(value || []).includes(opt.value)}
                                           onChange={() => handleCheckboxChange(q.id, opt.value)}
                                           className="w-4 h-4 text-amber-500 focus:ring-amber-500 rounded border-gray-300"
                                         />
                                         <span className="text-sm text-gray-700">{opt.label}</span>
                                       </label>
                                    ))}
                                  </div>
                                ) : q.question_type === 'file' || q.question_type === 'upload' ? (
                                  <div className="mt-2">
                                    <div 
                                      className={`relative border-2 border-dashed rounded-xl p-6 transition-all duration-200 ${
                                        error 
                                          ? 'border-red-300 bg-red-50 hover:bg-red-100/50' 
                                          : value 
                                            ? 'border-emerald-300 bg-emerald-50' 
                                            : 'border-gray-300 bg-gray-50 hover:bg-gray-100'
                                      }`}
                                    >
                                      <input 
                                        key={value ? value.name : 'empty'}
                                        type="file"
                                        accept={q.validation?.allowed_extensions
                                          ? q.validation.allowed_extensions.split(',').map(e => `.${e.trim().toLowerCase()}`).join(',')
                                          : undefined
                                        }
                                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" 
                                        onChange={(e) => handleFileChange(q.id, e, q.validation)}
                                      />
                                      
                                      <div className="flex flex-col items-center justify-center text-center space-y-3">
                                        {value ? (
                                          <>
                                            <div className="w-12 h-12 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-1">
                                              <FileText className="w-6 h-6" />
                                            </div>
                                            <div>
                                              <p className="text-sm font-semibold text-emerald-700">{value.name}</p>
                                              <p className="text-xs text-emerald-600 mt-1">{(value.size / (1024 * 1024)).toFixed(2)} MB</p>
                                            </div>
                                            <div className="flex gap-2 relative z-10 mt-2">
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  if (value instanceof File) {
                                                    const url = URL.createObjectURL(value);
                                                    window.open(url, "_blank");
                                                  } else if (value && typeof value === 'object' && value.url) {
                                                    window.open(value.url, "_blank");
                                                  } else if (typeof value === "string") {
                                                    window.open(value, "_blank");
                                                  }
                                                }}
                                                className="text-xs px-4 py-1.5 bg-white text-blue-600 font-medium hover:bg-blue-50 rounded-lg border border-blue-200 transition-colors shadow-sm"
                                              >
                                                View File
                                              </button>
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  handleInputChange(q.id, null);
                                                }}
                                                className="text-xs px-4 py-1.5 bg-white text-red-600 font-medium hover:bg-red-50 rounded-lg border border-red-200 transition-colors shadow-sm"
                                              >
                                                Remove File
                                              </button>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-1 transition-colors ${
                                              error ? 'bg-red-100 text-red-500' : 'bg-amber-100 text-amber-500'
                                            }`}>
                                              <Upload className="w-6 h-6" />
                                            </div>
                                            <div>
                                              <p className="text-sm font-medium text-gray-700">
                                                <span className="text-amber-600 font-semibold hover:underline cursor-pointer">Click to upload</span> or drag and drop
                                              </p>
                                              <div className="text-xs text-gray-500 mt-2 space-y-1">
                                                {q.validation?.allowed_extensions && (
                                                  <p>Allowed: {q.validation.allowed_extensions.split(',').map(e => e.trim().toUpperCase()).join(', ')}</p>
                                                )}
                                                {q.validation?.max_file_size_mb && (
                                                  <p>Maximum file size: {q.validation.max_file_size_mb}MB</p>
                                                )}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="text-sm text-gray-400 italic">Input type: {q.question_type}</div>
                                )}
                              </div>
                              {error && <p className="text-red-500 text-xs mt-2 font-medium bg-red-50 p-2 rounded inline-block">{error}</p>}
                            </div>
                          );
                        })
                      ) : (
                        <div className="bg-white rounded-2xl shadow-sm p-12 mt-2 text-center border border-gray-100 flex flex-col items-center justify-center">
                          <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4 border border-gray-100 shadow-sm">
                            <Trophy className="w-8 h-8 text-gray-300" />
                          </div>
                          <h3 className="text-xl font-bold mb-2 text-gray-700">Application Not Available</h3>
                          <p className="text-gray-500 max-w-md mx-auto text-sm leading-relaxed">
                            The application questions for this award have not been configured yet. Please check back later or contact the administrator.
                          </p>
                        </div>
                      )}
                    </div>
                    
                    {data.questions?.length > 0 && (
                      <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-100">
                        {showPreview ? (
                           <>
                             <button onClick={() => setShowPreview(false)} disabled={isSubmitting} className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium transition-colors disabled:opacity-50">Edit</button>
                             <button onClick={handleFormSubmit} disabled={isSubmitting} className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-bold transition-colors flex items-center gap-2 disabled:opacity-70">
                               {isSubmitting && <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>}
                               Confirm & Submit
                             </button>
                           </>
                        ) : (
                           <>
                             <button onClick={closeModal} className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium transition-colors">Cancel</button>
                             <button onClick={handlePreviewClick} className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-bold transition-colors">Save & Preview</button>
                           </>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : type === "view_nomination" ? (
              <div className="space-y-6">
                <div className="space-y-4">
                  <h3 className="text-lg font-bold text-gray-800 border-b pb-2">{data.award_name}</h3>
                  <div className="space-y-4">
                    {data.answers?.map((ans, idx) => (
                      <div key={ans.id} className="py-4 border-b border-gray-100 last:border-0">
                         <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-1">Question {idx + 1}</p>
                         <p className="font-medium text-gray-800 mb-2">{ans.question_text}</p>
                         <p className="text-base text-gray-900 font-semibold break-words">
                           {ans.answer || (ans.file_name ? (
                              <div className="flex items-center gap-3 mt-1">
                                <a href={ans.file_path} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 text-sm font-semibold transition-colors border border-blue-100">
                                  <Eye className="w-4 h-4" /> View Document
                                </a>
                              </div>
                           ) : <span className="text-gray-400 font-normal italic">No answer provided</span>)}
                         </p>
                      </div>
                    ))}
                    {(!data.answers || data.answers.length === 0) && (
                      <p className="text-gray-500 italic">No answers found for this nomination.</p>
                    )}
                  </div>
                </div>
              </div>
            ) : type === "error" ? (
              <div className="flex flex-col items-center justify-center py-10 text-center">
                <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-4">
                  <X className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Failed to load</h3>
                <p className="text-gray-600">{data.message}</p>
                <button onClick={closeModal} className="mt-6 px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg font-bold transition-colors">
                  Close
                </button>
              </div>
            ) : type === "success" ? (
              <div className="flex flex-col items-center justify-center py-10 text-center">
                <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4 text-3xl">
                  ✓
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Success!</h3>
                <p className="text-gray-600">{data.message}</p>
                <button onClick={() => { closeModal(); window.location.reload(); }} className="mt-6 px-6 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg font-bold transition-colors">
                  Done
                </button>
              </div>
            ) : (
              <DataTable
                data={data}
                type={type}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                instituteNominatedCategories={instituteNominatedCategories}
                instituteWinnerCategories={instituteWinnerCategories}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  // Mobile Tab Navigation Component
  const MobileTabNavigation = ({ tabs, activeTab, onTabChange }) => {
    return (
      <div className="lg:hidden bg-white border-b border-gray-200 px-4 py-2">
        <style>{`
          .scrollbar-hide::-webkit-scrollbar { display: none; }
          .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
        `}</style>
        <div className="flex overflow-x-auto space-x-2 scrollbar-hide">
          {tabs.map((tab) => {
            if (tab.isHeader || tab.isParent) return null;
            if (tab.parentId && !isAwardsExpanded) return null;

            const IconComponent = tab.icon;
            const isActive = activeTab === tab.id;

            const colorClasses = {
              blue: isActive
                ? "bg-blue-100 text-blue-700 border-blue-200"
                : "text-gray-900 hover:bg-blue-50 hover:text-blue-600",
              amber: isActive
                ? "bg-amber-100 text-amber-700 border-amber-200"
                : "text-gray-900 hover:bg-amber-50 hover:text-amber-600",
              green: isActive
                ? "bg-green-100 text-green-700 border-green-200"
                : "text-gray-900 hover:bg-green-50 hover:text-green-600",
              purple: isActive
                ? "bg-purple-100 text-purple-700 border-purple-200"
                : "text-gray-900 hover:bg-purple-50 hover:text-purple-600",
              indigo: isActive
                ? "bg-indigo-100 text-indigo-700 border-indigo-200"
                : "text-gray-900 hover:bg-indigo-50 hover:text-indigo-600",
            };

            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`
                  flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap border
                  ${isActive
                    ? `${colorClasses[tab.color]} shadow-sm`
                    : `${colorClasses[tab.color]} border-transparent`
                  }
                `}
              >
                {IconComponent && <IconComponent className="w-4 h-4 flex-shrink-0" />}
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  // Error state
  if (error) {
    return (
      <div className="p-4 sm:p-6 max-w-[1500px] mx-auto bg-gray-50 min-h-screen">
        <div className="bg-white rounded-xl shadow-sm border border-red-200 p-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">⚠️</span>
            </div>
            <h3 className="text-xl font-semibold text-red-600 mb-2">
              Error Loading Data
            </h3>
            <p className="text-gray-600 mb-6">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Loading state
  if (loading) {
    return (
      <div className="p-4 max-w-[1500px] mx-auto min-h-[50vh] flex justify-center items-center">
        <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <>
      {/* Main Content - Lower z-index */}
      <div
        className="p-4 max-w-[1700px] mx-auto min-h-screen relative"
        style={{ zIndex: 1 }}
      >
        {/* Year Accordions */}
        <div className="space-y-4">
          {Object.keys(yearsData).length === 0 ? (
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">📊</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-600 mb-2">
                  No Data Available
                </h3>
                <p className="text-gray-500 text-sm">
                  There are no awards data to display at the moment.
                </p>
              </div>
            </div>
          ) : (
            <div className="flex flex-col">
              {/* Active Year Content */}
              {activeYear && yearsData[activeYear] && (
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 relative mt-2">
                  {/* Static Top-Right Year Badge */}
                  <div className="absolute -top-3.5 right-6 z-20">
                    <span className="px-4 py-1 text-xs uppercase tracking-widest rounded-full font-bold shadow-md border bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-transparent">
                      {activeYear}
                    </span>
                  </div>
                  {activeYear === "2026" ? (
                    // Enhanced Responsive Layout for 2026
                    <>
                      {/* Mobile Tab Navigation */}
                      <MobileTabNavigation
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                      />

                      {/* Desktop Sidebar Layout + Mobile Stack Layout */}
                      <div className="lg:flex lg:h-[85vh] lg:overflow-visible">
                        {/* Desktop Sidebar Navigation */}
                        <div className="hidden lg:block w-64 bg-gray-50/50 border-r border-gray-100 p-4 flex-shrink-0 overflow-y-auto">
                          <div className="space-y-2">
                            {tabs.map((tab) => {
                              if (tab.isHeader) {
                                return (
                                  <div key={tab.id} className="pt-4 pb-1 px-4">
                                    <h3 className="text-xs font-bold text-gray-400 tracking-widest uppercase">{tab.label}</h3>
                                  </div>
                                );
                              }

                              if (tab.parentId && !isAwardsExpanded) {
                                return null;
                              }

                              if (tab.isParent) {
                                const IconComponent = tab.icon;
                                return (
                                  <button
                                    key={tab.id}
                                    onClick={() => {
                                      setIsAwardsExpanded(!isAwardsExpanded);
                                      if (!isAwardsExpanded) {
                                        setActiveTab("general");
                                      }
                                    }}
                                    className={`
                                      w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-bold transition-all duration-200
                                      text-gray-900 hover:bg-gray-50 border border-transparent
                                    `}
                                  >
                                    {IconComponent && <IconComponent className="w-4 h-4 flex-shrink-0" />}
                                    <span className="text-left flex-1">{tab.label}</span>
                                    <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isAwardsExpanded ? 'rotate-180' : ''}`} />
                                  </button>
                                );
                              }

                              const IconComponent = tab.icon;
                              const isActive = activeTab === tab.id;
                              const isSubItem = !!tab.parentId;

                              const colorClasses = {
                                blue: isActive
                                  ? "bg-blue-100 text-blue-700 border-blue-200"
                                  : "hover:bg-blue-50 hover:text-blue-600",
                                amber: isActive
                                  ? "bg-amber-100 text-amber-700 border-amber-200"
                                  : "hover:bg-amber-50 hover:text-amber-600",
                                green: isActive
                                  ? "bg-green-100 text-green-700 border-green-200"
                                  : "hover:bg-green-50 hover:text-green-600",
                                purple: isActive
                                  ? "bg-purple-100 text-purple-700 border-purple-200"
                                  : "hover:bg-purple-50 hover:text-purple-600",
                                indigo: isActive
                                  ? "bg-indigo-100 text-indigo-700 border-indigo-200"
                                  : "hover:bg-indigo-50 hover:text-indigo-600",
                              };

                              return (
                                <button
                                  key={tab.id}
                                  onClick={() => setActiveTab(tab.id)}
                                  className={`
                                    w-full flex items-center space-x-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
                                    ${isSubItem ? 'pl-11' : ''}
                                    ${isActive
                                      ? `${colorClasses[tab.color]} border shadow-sm`
                                      : `text-gray-900 ${colorClasses[tab.color]} border border-transparent`
                                    }
                                  `}
                                >
                                  {IconComponent && <IconComponent className="w-4 h-4 flex-shrink-0" />}
                                  <span className="text-left">{tab.label}</span>
                                  {isActive && (
                                    <div className="ml-auto w-1.5 h-1.5 bg-current rounded-full opacity-60"></div>
                                  )}
                                </button>
                              );
                            })}
                          </div>
                        </div>

                        {/* Main Content Area - responsive padding */}
                        <div className="flex-1 p-4 sm:p-6 lg:overflow-y-auto lg:overflow-x-visible min-h-[50vh] lg:min-h-0">
                          {renderTabContent(yearsData[activeYear], activeYear)}
                        </div>
                      </div>
                    </>
                  ) : (
                    // Original Simple Card Layout for other years (no tabs)
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-4 sm:p-6 mt-4">
                      {loading ? (
                        <div className="col-span-full flex justify-center items-center py-12">
                          <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                        </div>
                      ) : (
                        <>
                          {/* Attendees Card */}
                          <button
                            onClick={() => openModal("attendees", yearsData[activeYear].attendees || [], activeYear)}
                            className="bg-blue-50 rounded-lg shadow-sm p-3 border-l-4 border-blue-500 hover:shadow-md transition-shadow text-left w-full"
                          >
                            <div className="flex items-center justify-between">
                              <div>
                                <h3 className="text-xs font-medium text-blue-700 mb-1">Attendees</h3>
                                <p className="text-xl font-bold text-blue-600">{yearsData[activeYear].attendees?.length || 0}</p>
                              </div>
                              <div className="bg-blue-100 p-1.5 rounded">
                                <Users className="w-4 h-4 text-blue-600" />
                              </div>
                            </div>
                          </button>

                          {/* Nominated Card */}
                          <button
                            onClick={() => openModal("nominated", yearsData[activeYear].nominated || [], activeYear)}
                            className="bg-yellow-50 rounded-lg shadow-sm p-3 border-l-4 border-yellow-500 hover:shadow-md transition-shadow text-left w-full"
                          >
                            <div className="flex items-center justify-between">
                              <div>
                                <h3 className="text-xs font-medium text-yellow-700 mb-1">Nominated</h3>
                                <p className="text-xl font-bold text-yellow-600">{yearsData[activeYear].nominated?.length || 0}</p>
                              </div>
                              <div className="bg-yellow-100 p-1.5 rounded">
                                <Star className="w-4 h-4 text-yellow-600" />
                              </div>
                            </div>
                          </button>

                          {/* Winners Card */}
                          <button
                            onClick={() => openModal("winners", yearsData[activeYear].winners || [], activeYear)}
                            className="bg-green-50 rounded-lg shadow-sm p-3 border-l-4 border-green-500 hover:shadow-md transition-shadow text-left w-full"
                          >
                            <div className="flex items-center justify-between">
                              <div>
                                <h3 className="text-xs font-medium text-green-700 mb-1">Winners</h3>
                                <p className="text-xl font-bold text-green-600">{yearsData[activeYear].winners?.length || 0}</p>
                              </div>
                              <div className="bg-green-100 p-1.5 rounded">
                                <Trophy className="w-4 h-4 text-green-600" />
                              </div>
                            </div>
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Modal - Highest z-index, rendered outside main content */}
      {renderModalContent()}
    </>
  );
};

export default AwardsAccordion;